/*
  German interface strings. Keys are the English source (see ./index.js);
  a key missing here falls back to English. Generated from the Russian/Spanish key set
  and checked for placeholders and markup; edit by hand like any other map.
*/

const de = {
  "White pages": "White Pages",
  "Static pages for bots/ad review — hosted here, served same-origin on your domain (Google-safe cloaking)": "Statische Seiten für Bots/Anzeigenprüfung — hier gehostet, same-origin auf deiner Domain ausgeliefert (Google-sicheres Cloaking)",
  "White pages (hosted, same-origin)": "White Pages (gehostet, same-origin)",
  "Safe page URL (external)": "URL der Safe Page (extern)",
  "External safe page — the tracker proxies it same-origin (identity tags stripped). Used when no white page is selected. Must be an absolute http(s) URL. This method already passes Google review on its own; a hosted white page is just an extra-robust alternative served fully on your domain.": "Externe Safe Page — der Tracker leitet sie same-origin per Proxy weiter (Identitäts-Tags entfernt). Wird verwendet, wenn keine White Page ausgewählt ist. Muss eine absolute http(s)-URL sein. Diese Methode besteht die Google-Prüfung bereits von sich aus; eine gehostete White Page ist nur eine noch robustere Alternative, die vollständig auf deiner Domain ausgeliefert wird.",
  "Optional — the most robust option for Google/Facebook: served from your own campaign domain (/wp/…), so the final URL stays on-domain. Select several to rotate a random one per request, so one white isn’t reused across hundreds of ads. Manage under White pages.": "Optional — die robusteste Option für Google/Facebook: wird von deiner eigenen Kampagnen-Domain ausgeliefert (/wp/…), sodass die finale URL auf der Domain bleibt. Wähle mehrere aus, um bei jeder Anfrage zufällig zu rotieren, damit nicht dieselbe White Page für Hunderte Anzeigen verwendet wird. Verwaltung unter White Pages.",
  "selected — rotated per request": "ausgewählt — rotiert bei jeder Anfrage",
  "No white pages yet. Upload some under White pages, then pick them here.": "Noch keine White Pages. Lade welche unter White Pages hoch und wähle sie dann hier aus.",
  "Recommended for Google/Facebook: served from your own campaign domain (/wp/…), so the ad’s final URL stays on-domain and passes review. Select several to rotate a random one per request — so one white isn’t reused across hundreds of ads. Manage under White pages.": "Empfohlen für Google/Facebook: wird von deiner eigenen Kampagnen-Domain ausgeliefert (/wp/…), sodass die finale URL der Anzeige auf der Domain bleibt und die Prüfung besteht. Wähle mehrere aus, um bei jeder Anfrage zufällig zu rotieren — damit nicht dieselbe White Page für Hunderte Anzeigen verwendet wird. Verwaltung unter White Pages.",
  "Static pages for bots & ad review": "Statische Seiten für Bots & Anzeigenprüfung",
  "Compliant static pages served to bots and ad reviewers — same-origin on your campaign domain.": "Konforme statische Seiten, die Bots und Anzeigenprüfern angezeigt werden — same-origin auf deiner Kampagnen-Domain.",
  "These pages are hosted here and served same-origin at /wp/<slug>/ on any of your verified domains. Pick one in a campaign’s Cloaking settings — bots and Google/Facebook reviewers get this page, real users get the offer.": "Diese Seiten werden hier gehostet und same-origin unter /wp/<slug>/ auf jeder deiner verifizierten Domains ausgeliefert. Wähle eine in den Cloaking-Einstellungen einer Kampagne aus — Bots und Google/Facebook-Prüfer sehen diese Seite, echte Nutzer sehen das Offer.",
  "Upload white page": "White Page hochladen",
  "Upload a static ZIP (index.html + assets). PHP is not allowed. Max 50MB.": "Lade ein statisches ZIP hoch (index.html + Assets). PHP ist nicht erlaubt. Max. 50 MB.",
  "My white page": "Meine White Page",
  "What this white page is for": "Wofür diese White Page dient",
  "Static files only (.html/.css/.js/images). No .php.": "Nur statische Dateien (.html/.css/.js/Bilder). Kein .php.",
  "Please enter a name for the white page": "Bitte gib einen Namen für die White Page ein",
  "White page uploaded successfully": "White Page erfolgreich hochgeladen",
  "Error uploading white page": "Fehler beim Hochladen der White Page",
  "Error loading white pages": "Fehler beim Laden der White Pages",
  "Error deleting white page": "Fehler beim Löschen der White Page",
  "White page deleted": "White Page gelöscht",
  "No white pages": "Keine White Pages",
  "Upload a static white page to use for campaign cloaking": "Lade eine statische White Page hoch, die für das Cloaking von Kampagnen verwendet wird",
  "Search white pages…": "White Pages durchsuchen…",
  "Same-origin path": "Same-Origin-Pfad",
  "Delete white page": "White Page löschen",
  "This permanently deletes \"{name}\" and its files. Campaigns still pointing at it will fall back to their Safe page URL (or the offer if none).": "Dadurch werden \"{name}\" und die zugehörigen Dateien dauerhaft gelöscht. Kampagnen, die noch darauf verweisen, greifen dann auf ihre Safe-Page-URL zurück (oder auf das Offer, falls keine vorhanden ist).",
  "Multiple HTML pages detected. Select the main page bots will land on.": "Es wurden mehrere HTML-Seiten erkannt. Wähle die Hauptseite aus, auf der Bots landen sollen.",
  "White page (hosted, same-origin)": "White Page (gehostet, Same-Origin)",
  "None — use Safe page URL below": "Keine — die Safe-Page-URL unten verwenden",
  "Recommended for Google/Facebook: served from your own campaign domain (/wp/…), so the ad’s final URL stays on-domain and passes review. Manage these under White pages.": "Empfohlen für Google/Facebook: wird von deiner eigenen Kampagnen-Domain ausgeliefert (/wp/…), sodass die finale URL der Anzeige auf der Domain bleibt und die Prüfung besteht. Verwalte sie unter White Pages.",
  "Safe page URL (external fallback)": "Safe-Page-URL (externer Fallback)",
  "Optional fallback, used only when no white page is selected above. Must be an absolute http(s) URL. Note: an external URL lives on another domain — exactly what triggers Google’s “destination mismatch”, so prefer a white page for paid search.": "Optionaler Fallback, der nur verwendet wird, wenn oben keine White Page ausgewählt ist. Muss eine absolute http(s)-URL sein. Hinweis: Eine externe URL liegt auf einer anderen Domain — genau das löst Googles „destination mismatch“ aus. Bevorzuge daher für Paid Search eine White Page.",
  "Select a white page or enter a valid http(s) Safe page URL for cloaking": "Wähle eine White Page aus oder gib eine gültige http(s)-Safe-Page-URL für das Cloaking ein",
  "The ready-to-copy tracking link for this campaign. Swap the domain for any verified workspace domain to run several domains on one campaign; the ad network fills the placeholders at click time.": "Der kopierbereite Tracking-Link für diese Kampagne. Tausche die Domain gegen eine beliebige verifizierte Workspace-Domain aus, um mehrere Domains für eine Kampagne zu nutzen; das Werbenetzwerk füllt die Platzhalter beim Klick aus.",
  "Secret that authenticates incoming postbacks for this campaign. Paste it as &token=… in the postback URLs you give the network. Keep it private; anyone with it can register conversions.": "Geheimnis, das eingehende Postbacks für diese Kampagne authentifiziert. Füge es als &token=… in die Postback-URLs ein, die du dem Netzwerk gibst. Halte es geheim – jeder, der es kennt, kann Conversions registrieren.",
  "Translate the raw status words a network sends into our buckets. Priority: inline URL param > this campaign map > the affiliate-network preset > custom types > built-in defaults.": "Übersetzt die rohen Statuswörter, die ein Netzwerk sendet, in unsere Kategorien. Priorität: Inline-URL-Parameter > diese Kampagnen-Zuordnung > die Affiliate-Netzwerk-Vorlage > benutzerdefinierte Typen > Standardwerte.",
  "Outbound calls that notify another system (your traffic source, another tracker, Telegram) when a conversion arrives. For ad-platform CAPI (Facebook/Google/TikTok) use Conversion forwarders instead — hashed PII and retries.": "Ausgehende Aufrufe, die ein anderes System (deine Traffic-Quelle, einen anderen Tracker, Telegram) benachrichtigen, sobald eine Conversion eintrifft. Für CAPI von Werbeplattformen (Facebook/Google/TikTok) nutze stattdessen Conversion-Weiterleitungen – gehashte personenbezogene Daten und Wiederholungsversuche.",
  "The query-string parameter name in your tracking link — keep it URL-safe: letters, digits and _ (no spaces). Spaces are auto-converted to _ so the link never shows %20.": "Der Name des Query-String-Parameters in deinem Tracking-Link — halte ihn URL-sicher: Buchstaben, Ziffern und _ (keine Leerzeichen). Leerzeichen werden automatisch in _ umgewandelt, damit der Link nie %20 anzeigt.",
  "UA-pattern bots and UAs that fake a search-crawler identity (failed DNS check) get the safe page.": "Bots mit erkanntem UA-Muster und UAs, die sich als Suchmaschinen-Crawler ausgeben (fehlgeschlagene DNS-Prüfung), erhalten die sichere Seite.",
  "DNS-verified search crawlers (Googlebot/Bingbot/…) get the safe page. Turn off to let them index the real offer.": "Per DNS verifizierte Suchmaschinen-Crawler (Googlebot/Bingbot/…) erhalten die sichere Seite. Deaktiviere diese Option, damit sie den echten Offer indexieren können.",
  "Visitors from datacenter or Tor-exit IPs get the safe page.": "Besucher mit Datacenter- oder Tor-Exit-IPs erhalten die sichere Seite.",
  "Visitors behind a proxy/VPN get the safe page.": "Besucher hinter einem Proxy/VPN erhalten die sichere Seite.",
  "Works only when an active Google Ads forwarder exists (simple mode or with a conversion tag). The AW-…/label can be passed per click via the tm parameter, so one campaign credits conversions to different accounts.": "Funktioniert nur, wenn ein aktiver Google-Ads-Forwarder existiert (einfacher Modus oder mit Conversion-Tag). Die AW-…/Label kann pro Klick über den Parameter tm übergeben werden, sodass eine Kampagne Conversions verschiedenen Konten zuordnen kann.",
  "Fire Google Ads gtag on redirect (click-time conversion)": "Google-Ads-gtag bei der Weiterleitung auslösen (Conversion zum Klickzeitpunkt)",
  "Fires a Google Ads conversion at the click moment (on /r/, before the offer) from the AW-…/label in the {tm} parameter — no forwarder needed. This optimizes Google on CLICKS, not on registrations/deposits.": "Löst eine Google-Ads-Conversion zum Zeitpunkt des Klicks aus (auf /r/, vor dem Offer) anhand der AW-…/Label im Parameter {tm} — kein Forwarder nötig. Dadurch optimiert Google auf KLICKS, nicht auf Registrierungen/Deposits.",
  "Click-time signal: the conversion fires for every clean click, so Google optimizes on clicks. To optimize on real registrations/deposits keep this OFF and use the \"Google Ads\" button under Forwarding — S2S postbacks (fires on the broker postback by {gclid}). Leaving both on double-counts.": "Klick-Signal: Die Conversion wird bei jedem sauberen Klick ausgelöst, sodass Google auf Klicks optimiert. Um auf echte Registrierungen/Deposits zu optimieren, lasse diese Option AUS und nutze den Button „Google Ads“ unter Forwarding — S2S-Postbacks (löst beim Broker-Postback anhand von {gclid} aus). Wenn beide aktiv sind, werden Conversions doppelt gezählt.",
  "Bot model": "Bot-Modell",
  "Member access": "Mitgliederzugriff",
  "Scope what each team member can see and edit — per entity, plus which report metrics they may read. Owners and admins are never restricted.": "Lege fest, was jedes Teammitglied sehen und bearbeiten darf — pro Entität, sowie welche Berichtsmetriken es lesen darf. Eigentümer und Admins werden nie eingeschränkt.",
  "Member": "Mitglied",
  "Choose a member…": "Mitglied auswählen…",
  "Failed to load members": "Mitglieder konnten nicht geladen werden",
  "Retry": "Erneut versuchen",
  "No team members yet": "Noch keine Teammitglieder",
  "Invite teammates from the Workspace page, then configure their access here.": "Lade Teammitglieder über die Workspace-Seite ein und konfiguriere hier anschließend ihren Zugriff.",
  "Pick a member to configure": "Wähle ein Mitglied zum Konfigurieren",
  "Their entity access and allowed report metrics will show up here.": "Hier werden ihr Entitätszugriff und die erlaubten Berichtsmetriken angezeigt.",
  "Failed to load member access": "Mitgliederzugriff konnte nicht geladen werden",
  "Owners and admins have full, unrestricted access": "Eigentümer und Admins haben vollen, uneingeschränkten Zugriff",
  "You can still save these rules, but they stay inert unless the role changes to manager or viewer.": "Du kannst diese Regeln trotzdem speichern, aber sie bleiben inaktiv, solange die Rolle nicht auf Manager oder Viewer geändert wird.",
  "Entity access": "Entitätszugriff",
  "Full is the default: no restriction. Read-only blocks edits. To selected limits the member to the listed IDs. Created and selected adds anything the member created themselves.": "Vollständig ist die Standardeinstellung: keine Einschränkung. Nur Lesen blockiert Bearbeitungen. Auf ausgewählte beschränkt das Mitglied auf die aufgeführten IDs. Erstellt und ausgewählt fügt alles hinzu, was das Mitglied selbst erstellt hat.",
  "Entity": "Entität",
  "Access mode": "Zugriffsmodus",
  "Allowed IDs": "Erlaubte IDs",
  "Full": "Full",
  "Read-only": "Nur lesen",
  "To selected": "Auf ausgewählte",
  "Created and selected": "Erstellt und ausgewählt",
  "IDs, comma or space separated": "IDs, durch Komma oder Leerzeichen getrennt",
  "IDs of the specific items this member may access": "IDs der konkreten Elemente, auf die dieses Mitglied zugreifen darf",
  "No IDs yet — the member will only see items they created themselves.": "Noch keine IDs — das Mitglied sieht nur Elemente, die es selbst erstellt hat.",
  "No IDs yet — the member will not see any items of this type.": "Noch keine IDs — das Mitglied sieht keine Elemente dieses Typs.",
  "All items": "Alle Elemente",
  "Allowed report metrics": "Erlaubte Report-Metriken",
  "Toggle the metrics this member may see in reports and dashboards. Leaving every metric off means no restriction.": "Aktiviere oder deaktiviere die Metriken, die dieses Mitglied in Reports und Dashboards sehen darf. Sind alle Metriken deaktiviert, gilt keine Einschränkung.",
  "All metrics (no restriction)": "Alle Metriken (keine Einschränkung)",
  "metrics allowed": "Metriken erlaubt",
  "Clear (allow all)": "Zurücksetzen (alle erlauben)",
  "Save access": "Zugriff speichern",
  "Member access saved": "Mitgliederzugriff gespeichert",
  "Failed to save member access": "Mitgliederzugriff konnte nicht gespeichert werden",
  "Click traces": "Klick-Traces",
  "Diagnostics": "Diagnose",
  "Sampled real clicks with the full routing decision behind each one — which streams were evaluated and why the winner matched.": "Stichprobenartig erfasste reale Klicks mit der vollständigen Routing-Entscheidung dahinter — welche Streams geprüft wurden und warum der Gewinner passte.",
  "Pick a campaign above to inspect where its real clicks were routed and why.": "Wähle oben eine Kampagne aus, um zu sehen, wohin ihre realen Klicks geroutet wurden und warum.",
  "Live-click tracing": "Live-Klick-Tracing",
  "Enable live-click tracing": "Live-Klick-Tracing aktivieren",
  "Off by default. When enabled, a sampled share of real clicks records its full routing trace. Privacy-safe: no IP addresses or user agents are stored, and traces expire automatically.": "Standardmäßig deaktiviert. Bei Aktivierung wird für einen Stichprobenanteil der realen Klicks die vollständige Routing-Trace aufgezeichnet. Datenschutzsicher: Es werden keine IP-Adressen oder User-Agents gespeichert, und Traces laufen automatisch ab.",
  "Sample rate (%)": "Stichprobenrate (%)",
  "Share of clicks to trace, from 0 to 100%. Example: 10% traces roughly one click in ten.": "Anteil der zu tracenden Klicks, von 0 bis 100%. Beispiel: 10% tracet etwa jeden zehnten Klick.",
  "Sample rate must be between 0 and 100": "Die Stichprobenrate muss zwischen 0 und 100 liegen",
  "Trace settings saved": "Trace-Einstellungen gespeichert",
  "Error loading click traces": "Fehler beim Laden der Klick-Traces",
  "Could not load traces": "Traces konnten nicht geladen werden",
  "Something went wrong while loading click traces for this campaign.": "Beim Laden der Klick-Traces für diese Kampagne ist etwas schiefgelaufen.",
  "No traces yet": "Noch keine Traces",
  "Enable tracing above; traces of sampled real clicks will appear here.": "Aktiviere das Tracing oben; Traces der stichprobenartig erfassten realen Klicks erscheinen dann hier.",
  "Tracing is on — traces of sampled real clicks will appear here as traffic arrives. If nothing shows up, check the sample rate.": "Tracing ist aktiv — Traces der stichprobenartig erfassten realen Klicks erscheinen hier, sobald Traffic eintrifft. Falls nichts erscheint, prüfe die Stichprobenrate.",
  "Flags": "Flags",
  "Show routing trace": "Routing-Trace anzeigen",
  "Hide routing trace": "Routing-Trace ausblenden",
  "Per-stream verdicts": "Verdikte pro Stream",
  "No per-stream verdicts were recorded for this click.": "Für diesen Klick wurden keine Verdikte pro Stream erfasst.",
  "Not matched": "Keine Übereinstimmung",
  "Filters evaluated": "Ausgewertete Filter",
  "Relation": "Beziehung",
  "Page": "Seite",
  "entries": "Einträge",
  "just now": "gerade eben",
  "{n}m ago": "vor {n} Min.",
  "{n}h ago": "vor {n} Std.",
  "ML bot model": "ML-Bot-Modell",
  "Weak-supervision bot classifier: train it on recent clicks, inspect metrics and score ad-hoc payloads. Shadow-only — it never affects live routing.": "Bot-Klassifikator mit Weak Supervision: Trainiere ihn mit aktuellen Klicks, prüfe Metriken und bewerte Ad-hoc-Payloads. Nur im Shadow-Modus – beeinflusst niemals das Live-Routing.",
  "Admin access required": "Admin-Zugriff erforderlich",
  "The ML bot-model panel is only available to workspace admins.": "Das ML-Bot-Modell-Panel steht nur Workspace-Admins zur Verfügung.",
  "Error loading bot-model status": "Fehler beim Laden des Bot-Modell-Status",
  "Model status": "Modellstatus",
  "Trained": "Trainiert",
  "Not trained": "Nicht trainiert",
  "Inference": "Inferenz",
  "Degenerate": "Degeneriert",
  "Trained on a single class or too few samples — metrics are not meaningful.": "Mit nur einer Klasse oder zu wenigen Samples trainiert – Metriken sind nicht aussagekräftig.",
  "Inference is off by default and shadow-only — even when enabled, scores are only recorded on clicks for analysis and never affect routing.": "Inferenz ist standardmäßig deaktiviert und nur im Shadow-Modus aktiv – selbst wenn aktiviert, werden Scores nur bei Klicks zur Analyse erfasst und beeinflussen niemals das Routing.",
  "Accuracy": "Genauigkeit",
  "Positive rate": "Positivrate",
  "Log loss": "Log Loss",
  "AUC": "AUC",
  "Training samples": "Trainings-Samples",
  "Trained at": "Trainiert am",
  "No bot model trained yet. Train one on recent clicks below.": "Noch kein Bot-Modell trainiert. Trainiere unten eins mit aktuellen Klicks.",
  "Train model": "Modell trainieren",
  "Training…": "Training läuft…",
  "Training pulls up to 5,000 recent clicks, weak-labels them with the existing bot heuristics (user agent, uniqueness, behaviour score) and fits a small logistic-regression model. Retraining replaces the stored model.": "Das Training zieht bis zu 5.000 aktuelle Klicks heran, labelt sie mit den bestehenden Bot-Heuristiken (User-Agent, Eindeutigkeit, Verhaltens-Score) und passt ein kleines logistisches Regressionsmodell an. Ein erneutes Training ersetzt das gespeicherte Modell.",
  "Model trained on {n} clicks — accuracy {acc}": "Modell trainiert mit {n} Klicks — Genauigkeit {acc}",
  "Model trained on {n} clicks": "Modell trainiert mit {n} Klicks",
  "No click data to train on yet.": "Noch keine Klickdaten zum Trainieren vorhanden.",
  "Training finished": "Training abgeschlossen",
  "Training failed": "Training fehlgeschlagen",
  "Score a sample": "Beispiel bewerten",
  "Developer tool: paste a click-shaped JSON payload and run it through the trained model. Nothing is stored and live traffic is unaffected.": "Entwickler-Tool: Füge einen Klick-ähnlichen JSON-Payload ein und lasse ihn vom trainierten Modell bewerten. Es wird nichts gespeichert und der Live-Traffic bleibt unberührt.",
  "Click payload (JSON)": "Klick-Payload (JSON)",
  "Score": "Bewerten",
  "Scoring…": "Bewertung läuft…",
  "Reset example": "Beispiel zurücksetzen",
  "Invalid JSON — check the payload and try again.": "Ungültiges JSON – überprüfe den Payload und versuche es erneut.",
  "Payload must be a JSON object.": "Payload muss ein JSON-Objekt sein.",
  "No trained model — train one first.": "Kein trainiertes Modell – trainiere zuerst eins.",
  "Scoring failed": "Bewertung fehlgeschlagen",
  "Likely bot": "Wahrscheinlich Bot",
  "Likely human": "Wahrscheinlich Mensch",
  "Threshold 0.5 — scores above are flagged as bots.": "Schwellenwert 0,5 — Scores darüber werden als Bots markiert.",
  "Heuristic weak label": "Heuristisches Weak Label",
  "Human": "Mensch",
  "Feature": "Merkmal",
  "{n} min ago": "vor {n} Min.",
  "{n} h ago": "vor {n} Std.",
  "{n} d ago": "vor {n} Tg.",
  "Archive & restore": "Archivieren & wiederherstellen",
  "Access control": "Zugriffskontrolle",
  "Offer rotation on daily cap": "Offer-Rotation bei täglichem Limit",
  "No threshold needed. This rule fires when any offer used by the campaign reaches its daily cap and notifies you that traffic is rotating to the fallback / remaining offers. Set the cap and fallback offer on each offer.": "Kein Schwellenwert nötig. Diese Regel löst aus, wenn ein von der Kampagne genutztes Offer sein Tageslimit erreicht, und benachrichtigt dich, dass der Traffic auf das Fallback- / die restlichen Offers umgeleitet wird. Lege das Limit und das Fallback-Offer bei jedem Offer fest.",
  "Connection types": "Verbindungstypen",
  "Filter by network connection type. 'hosting' (datacenter/cloud) works out of the box; other values like cellular or wifi require the edge proxy to send an X-Connection-Type header.": "Filtert nach Art der Netzwerkverbindung. 'hosting' (Datacenter/Cloud) funktioniert sofort; andere Werte wie cellular oder wifi erfordern, dass der Edge-Proxy einen X-Connection-Type-Header sendet.",
  "Status mapping": "Status-Zuordnung",
  "Add status": "Status hinzufügen",
  "No status mappings added": "Keine Status-Mappings hinzugefügt",
  "Network status (e.g. ftd)": "Status des Netzwerks (z. B. ftd)",
  "Map the raw status this network sends to a canonical bucket. Applied to inbound postbacks when the campaign status map does not match.": "Ordne den vom Affiliate-Netzwerk gesendeten Rohstatus einem kanonischen Bucket zu. Wird auf eingehende Postbacks angewendet, wenn die Status-Zuordnung der Kampagne nicht übereinstimmt.",
  "Lead": "Lead",
  "Sale": "Sale",
  "Reject": "Ablehnen",
  "Upsell": "Upsell",
  "Ignore": "Ignorieren",
  "Split testing": "Split-Testing",
  "Parameter filters": "Parameterfilter",
  "Params": "Parameter",
  "Split testing enabled": "Split-Testing aktiviert",
  "Split testing disabled": "Split-Testing deaktiviert",
  "Failed to update campaign": "Kampagne konnte nicht aktualisiert werden",
  "Flow rotation. On: Normal streams rotate by weight, position is ignored. Off: streams are checked top-down by position and the first match takes all the traffic. Catch streams always intercept first and never rotate by weight.": "Flow-Rotation. An: Normal-Streams rotieren nach Gewichtung, die Position wird ignoriert. Aus: Streams werden von oben nach unten nach Position geprüft, und der erste Treffer bekommt den gesamten Traffic. Catch-Streams greifen immer zuerst und rotieren nie nach Gewichtung.",
  "Route by URL sub-parameters. One rule per line: name=value1, value2 allows listed values; name!=value1, value2 blocks them (a missing parameter passes a block rule). A rule without values adds no constraint.": "Route nach URL-Sub-Parametern. Eine Regel pro Zeile: name=value1, value2 lässt die gelisteten Werte zu; name!=value1, value2 blockiert sie (ein fehlender Parameter besteht eine Blockierregel). Eine Regel ohne Werte fügt keine Einschränkung hinzu.",
  "Regions": "Regionen",
  "GeoIP region / state / oblast names (e.g. California, Bavaria). Masks, /regex/ and @empty are supported.": "GeoIP-Namen für Region / Bundesland / Oblast (z. B. California, Bavaria). Masken, /regex/ und @empty werden unterstützt.",
  "IP addresses": "IP-Adressen",
  "Exact IPs, CIDR blocks (10.0.0.0/8) or masks (192.168.*). Handy for allow-listing your own test IPs or blocking a datacenter range.": "Exakte IPs, CIDR-Blöcke (10.0.0.0/8) oder Masken (192.168.*). Praktisch, um eigene Test-IPs auf die Positivliste zu setzen oder einen Datacenter-Bereich zu blockieren.",
  "User agents": "User-Agents",
  "Substrings, masks or /regex/ matched against the raw User-Agent — e.g. *Chrome/12* targets Chrome 120+, HeadlessChrome catches headless browsers.": "Teilstrings, Masken oder /regex/, die mit dem rohen User-Agent abgeglichen werden — z. B. zielt *Chrome/12* auf Chrome 120+, HeadlessChrome erkennt Headless-Browser.",
  "Clicks per hour": "Klicks pro Stunde",
  "Rolling-window limit: the stream stops taking NEW clicks after this many in the last hour, traffic falls through to the next stream. Empty = no limit.": "Gleitendes Zeitfenster-Limit: Der Stream nimmt keine NEUEN Klicks mehr an, sobald diese Anzahl in der letzten Stunde erreicht ist; der Traffic fällt an den nächsten Stream durch. Leer = kein Limit.",
  "Clicks per 24h": "Klicks pro 24h",
  "Rolling-window limit over the last 24 hours. Empty = no limit.": "Rolling-Window-Limit über die letzten 24 Stunden. Leer = kein Limit.",
  "Filter relation": "Filter-Beziehung",
  "AND: the click must pass every configured filter. OR: any single passing filter admits the click.": "AND: Der Klick muss alle konfigurierten Filter bestehen. OR: Ein einziger bestandener Filter lässt den Klick zu.",
  "AND (all)": "AND (alle)",
  "OR (any)": "OR (beliebig)",
  "Is": "Ist",
  "Is not": "Ist nicht",
  "Days of the week and hours when the stream is active. Time is in the campaign owner's time zone. 'Is not' inverts the schedule: the stream accepts clicks EXCEPT at the listed times.": "Wochentage und Uhrzeiten, zu denen der Stream aktiv ist. Die Uhrzeit bezieht sich auf die Zeitzone des Kampagnen-Inhabers. „Ist nicht“ kehrt den Zeitplan um: Der Stream akzeptiert Klicks AUSSER zu den angegebenen Zeiten.",
  "A free-text network label for notes and filters only — it has no effect. For a real link use the Affiliate network field or the Affiliate routing block below.": "Ein frei wählbares Netzwerk-Label nur für Notizen und Filter — es hat keine Auswirkung. Für eine echte Verknüpfung nutze das Feld Affiliate-Netzwerk oder den Block Affiliate-Routing weiter unten.",
  "A reusable partner network from the Affiliate networks section: postback template, offer params and per-network reports. Optional.": "Ein wiederverwendbares Partnernetzwerk aus dem Bereich Affiliate-Netzwerke: Postback-Vorlage, Offer-Parameter und Berichte pro Netzwerk. Optional.",
  "Where the click goes for a plain redirect offer. Macros work: {click_id}, {country_code}, {gclid} and more. For form offers (lead to CRM) the URL can be anything.": "Wohin der Klick bei einem einfachen Redirect-Offer geleitet wird. Makros funktionieren: {click_id}, {country_code}, {gclid} und mehr. Bei Formular-Offers (Lead an CRM) kann die URL beliebig sein.",
  "Max conversions per offer per day. When the cap is hit, traffic goes to the fallback offer. Empty = no limit.": "Maximale Conversions pro Offer und Tag. Ist das Limit erreicht, geht der Traffic an das Fallback-Offer. Leer = kein Limit.",
  "Time zone in which the daily cap is counted and the counter resets.": "Zeitzone, in der das Tageslimit gezählt wird und der Zähler zurückgesetzt wird.",
  "Fallback offer: traffic goes here once the main offer hits its daily cap.": "Fallback-Offer: Hierhin geht der Traffic, sobald das Haupt-Offer sein Tageslimit erreicht.",
  "The partner/CRM the lead is sent to. Set up once in the Integrations section (TrackBox or Custom API).": "Der Partner/das CRM, an den/das der Lead gesendet wird. Einmalig im Bereich Integrations einrichten (TrackBox oder Custom API).",
  "The offer's Box/Goal ID at the partner — which product/box receives the lead. The partner provides the value (e.g. 420).": "Die Box/Goal ID des Offers beim Partner — welches Produkt/welche Box den Lead erhält. Der Partner gibt den Wert vor (z. B. 420).",
  "Share of leads to this partner when there are several (split/rotation). E.g. 70 and 30 = 70% and 30%.": "Anteil der Leads an diesen Partner, wenn es mehrere gibt (Split/Rotation). Z. B. 70 und 30 = 70 % und 30 %.",
  "Off = the partner is temporarily skipped (e.g. until launch is agreed); its settings are kept.": "Aus = der Partner wird vorübergehend übersprungen (z. B. bis der Launch abgestimmt ist); seine Einstellungen bleiben erhalten.",
  "A per-offer form endpoint for THIS offer only. Usually NOT needed — use the shared /api/lead (see docs). Only for binding a form to one specific offer.": "Ein Formular-Endpoint pro Offer nur für DIESES Offer. Normalerweise NICHT nötig — nutze das gemeinsame /api/lead (siehe Docs). Nur um ein Formular an ein bestimmtes Offer zu binden.",
  "Telegram notification on EVERY form submit (accepted/rejected/test). Separate from the campaign Telegram postback (that fires on a confirmed conversion). Bot token from @BotFather; group Chat ID starts with -100…": "Telegram-Benachrichtigung bei JEDER Formular-Übermittlung (akzeptiert/abgelehnt/Test). Getrennt vom Telegram-Postback der Kampagne (der bei einer bestätigten Conversion auslöst). Bot-Token von @BotFather; Gruppen-Chat-ID beginnt mit -100…",
  "Default URL when no stream matched. Routing is usually driven by Streams — this field is a safety net.": "Standard-URL, wenn kein Stream passt. Das Routing wird normalerweise über Streams gesteuert — dieses Feld ist ein Sicherheitsnetz.",
  "The ad platform (Google Ads, Facebook…). Defines the set of macros/subs appended to the tracking link to pass click data.": "Die Werbeplattform (Google Ads, Facebook…). Legt fest, welche Makros/Subs an den Tracking-Link angehängt werden, um Klickdaten zu übergeben.",
  "How cost is counted: CPC — per click, CPM — per 1000 impressions, CPA — per conversion. Affects Cost / ROI / CPC / CPA in reports.": "Wie die Kosten berechnet werden: CPC — pro Klick, CPM — pro 1000 Impressionen, CPA — pro Conversion. Wirkt sich auf Kosten / ROI / CPC / CPA in den Berichten aus.",
  "The GET parameter name the tracker uses to append click_id to the offer URL (e.g. click_id → ?click_id=…). Needed so the partner returns this click_id in the postback. Form snippets read both click_id and clickid.": "Der Name des GET-Parameters, mit dem der Tracker die click_id an die Offer-URL anhängt (z. B. click_id → ?click_id=…). Notwendig, damit der Partner diese click_id im Postback zurückgibt. Formular-Snippets lesen sowohl click_id als auch clickid.",
  "Do not set the xpnsr_vid cookie (for networks that forbid cookies). Uniqueness is then by IP+User Agent, and click_id is passed via URL — the Click ID forward parameter field above.": "Das xpnsr_vid-Cookie nicht setzen (für Netzwerke, die Cookies verbieten). Die Eindeutigkeit basiert dann auf IP+User-Agent, und die click_id wird per URL übergeben — siehe das Feld Click ID forward parameter oben.",
  "Hash the IP before storing (for GDPR). GEO is resolved BEFORE hashing, so country/city targeting is unaffected.": "Die IP vor dem Speichern hashen (für die DSGVO). Das GEO wird VOR dem Hashing ermittelt, sodass das Targeting nach Land/Stadt davon nicht betroffen ist.",
  "How to redirect: 302 — a plain fast redirect; Meta refresh / JS — when the network does not follow 302 or gtag is needed; Cloaked (iframe) — hide the offer URL in the address bar.": "Art der Weiterleitung: 302 — eine einfache, schnelle Weiterleitung; Meta refresh / JS — wenn das Netzwerk 302 nicht folgt oder gtag benötigt wird; Cloaked (iframe) — versteckt die Offer-URL in der Adressleiste.",
  "Normal — a regular stream with filters; Catch — catches traffic that matched no Normal stream; Default — the last-resort stream when nothing matched.": "Normal — ein regulärer Stream mit Filtern; Catch — fängt Traffic auf, der zu keinem Normal-Stream passte; Default — der Stream als letzte Instanz, wenn nichts passt.",
  "Check priority. The lower the number, the earlier the stream is checked. Traffic goes to the first matching one.": "Prüfpriorität. Je niedriger die Zahl, desto früher wird der Stream geprüft. Der Traffic geht an den ersten passenden.",
  "When several streams share a type — the split of traffic between them. E.g. 70 and 30 = 70% and 30%.": "Wenn sich mehrere Streams einen Typ teilen — die Aufteilung des Traffics zwischen ihnen. Z. B. 70 und 30 = 70 % und 30 %.",
  "Max clicks for this stream. Once reached, the stream stops taking traffic. Empty = no limit.": "Maximale Klicks für diesen Stream. Ist dieser Wert erreicht, nimmt der Stream keinen Traffic mehr an. Leer = kein Limit.",
  "Redirect — send to the stream's landing/offer; Action — a special response (e.g. 404 / empty response for anti-fraud); Split test — split between variants.": "Redirect — leitet zur Landingpage/zum Offer des Streams weiter; Action — eine spezielle Antwort (z. B. 404 / leere Antwort für Anti-Fraud); Split-Test — Aufteilung zwischen Varianten.",
  "Filter by visit uniqueness: unique only / repeat only / do not filter.": "Nach Eindeutigkeit des Besuchs filtern: nur eindeutige / nur wiederholte / nicht filtern.",
  "How to handle bots (detected by User-Agent): do not filter / bots only / exclude bots. Handy for an anti-fraud stream.": "Wie mit Bots umgehen (erkannt per User-Agent): nicht filtern / nur Bots / Bots ausschließen. Praktisch für einen Anti-Fraud-Stream.",
  "Proxy/VPN filter (datacenter/Tor): do not filter / proxy only / exclude proxy.": "Proxy/VPN-Filter (Datacenter/Tor): nicht filtern / nur Proxy / Proxy ausschließen.",
  "Allow only IPv4 or only IPv6, or do not filter.": "Nur IPv4 oder nur IPv6 zulassen, oder nicht filtern.",
  "Days of the week and hours when the stream is active. Time is in the campaign owner's time zone.": "Wochentage und Uhrzeiten, zu denen der Stream aktiv ist. Die Uhrzeit gilt in der Zeitzone des Kampagnen-Inhabers.",
  "A ready platform preset (Google Ads, Facebook…) — fills in the name, the standard macros/subs and the S2S postback for this source.": "Eine fertige Plattform-Vorlage (Google Ads, Facebook…) — füllt den Namen, die Standard-Macros/Subs und den S2S-Postback für diese Quelle aus.",
  "Search templates…": "Vorlagen suchen…",
  "All categories": "Alle Kategorien",
  "Templates in catalog": "Vorlagen im Katalog",
  "Optional. An outbound postback TO the ad network on conversion — so the platform can optimize campaigns on its side (e.g. legacy Facebook CAPI).": "Optional. Ein ausgehender Postback AN das Affiliate-Netzwerk bei Conversion — damit die Plattform Kampagnen auf ihrer Seite optimieren kann (z. B. klassisches Facebook CAPI).",
  "Parameters the platform passes into the click (sub1…subN, gclid, tm, etc.). They become macros, appear in reports and are added to the tracking link.": "Parameter, die die Plattform in den Klick übergibt (sub1…subN, gclid, tm usw.). Sie werden zu Macros, erscheinen in Reports und werden dem Tracking-Link hinzugefügt.",
  "TrackBox / Tigloo — a typed adapter for their API. Custom API — for any other CRM: you configure the request yourself (URL, headers, body, where to read the redirect).": "TrackBox / Tigloo — ein typisierter Adapter für deren API. Custom API — für jede andere CRM: du konfigurierst die Anfrage selbst (URL, Header, Body, woher der Redirect gelesen wird).",
  "The partner's secret Push/Registration key. Get it in the partner dashboard (API / API Testing section) or from your affiliate manager.": "Der geheime Push/Registration-Key des Partners. Erhältst du im Partner-Dashboard (Bereich API / API Testing) oder von deinem Affiliate-Manager.",
  "Your Affiliate ID at the partner. Provided by the partner.": "Deine Affiliate ID beim Partner. Wird vom Partner bereitgestellt.",
  "Campaign ID at the partner. Usually 1 unless told otherwise.": "Campaign ID beim Partner. In der Regel 1, sofern nicht anders angegeben.",
  "Raw network statuses to treat as a LEAD (registration). Comma-separated. E.g. new, reg, registration.": "Rohe Netzwerk-Status, die als LEAD (Registrierung) gezählt werden sollen. Durch Komma getrennt. Z. B. new, reg, registration.",
  "Raw statuses to treat as a SALE/deposit. E.g. ftd, deposit, approved.": "Rohe Status, die als SALE/Einzahlung gezählt werden sollen. Z. B. ftd, deposit, approved.",
  "Rejection/bad statuses. E.g. bl, fake, rejected.": "Ablehnungs-/schlechte Status. Z. B. bl, fake, rejected.",
  "These statuses are silently dropped — not recorded as conversions. E.g. spam, junk, test.": "Diese Status werden stillschweigend verworfen — nicht als Conversion erfasst. Z. B. spam, junk, test.",
  "Dashboard": "Dashboard",
  "Campaigns": "Kampagnen",
  "Landing pages": "Landingpages",
  "Offers": "Offers",
  "Sources": "Traffic-Quellen",
  "Report": "Bericht",
  "Group clicks and conversions by any dimension with full metrics.": "Gruppiere Klicks und Conversions nach beliebiger Dimension mit allen Metriken.",
  "Grouped by": "Gruppiert nach",
  "No data for this period.": "Keine Daten für diesen Zeitraum.",
  "Empty ref.": "Leerer Ref.",
  "Group": "Gruppe",
  "— no level —": "— keine Ebene —",
  "Click a row to drill in": "Klicke auf eine Zeile, um ins Detail zu gehen",
  "Expand": "Erweitern",
  "Collapse": "Einklappen",
  "Open in clicks log": "Im Klick-Log öffnen",
  "Failed to load": "Laden fehlgeschlagen",
  "Card view": "Kartenansicht",
  "Table view": "Tabellenansicht",
  "Save view": "Ansicht speichern",
  "Save current view": "Aktuelle Ansicht speichern",
  "Saved views": "Gespeicherte Ansichten",
  "Delete view": "Ansicht löschen",
  "View saved": "Ansicht gespeichert",
  "View name": "Name der Ansicht",
  "Remember the current filters, sort and layout under a name for one-click recall.": "Speichere die aktuellen Filter, die Sortierung und das Layout unter einem Namen, um sie mit einem Klick wieder abzurufen.",
  "e.g. Tier-1 by revenue": "z. B. Tier-1 nach Umsatz",
  "Upload pre-landing (ZIP)": "Prelander hochladen (ZIP)",
  "Upload a ZIP with your warm-up page. index.html is auto-detected.": "Lade ein ZIP mit deiner Warm-up-Seite hoch. index.html wird automatisch erkannt.",
  "ZIP file": "ZIP-Datei",
  "Pre-landing uploaded": "Prelander hochgeladen",
  "Upload failed": "Hochladen fehlgeschlagen",
  "Choose a ZIP file": "ZIP-Datei auswählen",
  "Uploaded": "Hochgeladen",
  "Uploading…": "Wird hochgeladen…",
  "Columns": "Spalten",
  "Receiving conversions (incoming postback)": "Conversions empfangen (eingehender Postback)",
  "Paste these URLs into your affiliate network (e.g. TrackBox) so it notifies this campaign on conversions. Pass your click_id in the network parameter and it comes back here.": "Füge diese URLs in dein Affiliate-Netzwerk ein (z. B. TrackBox), damit es diese Kampagne bei Conversions benachrichtigt. Übergib deine click_id im Netzwerk-Parameter, und sie kommt hier wieder zurück.",
  "Map the network raw statuses to ours (comma-separated). Works for any network and applies to every inbound postback of this campaign. Inline URL params take priority.": "Ordne die Rohstatus des Netzwerks unseren zu (durch Komma getrennt). Funktioniert mit jedem Netzwerk und gilt für jeden eingehenden Postback dieser Kampagne. Inline-URL-Parameter haben Vorrang.",
  "Forwarding — S2S postbacks": "Weiterleitung — S2S-Postbacks",
  "Landing click": "Klick auf die Landingpage",
  "Time on landing": "Zeit auf der Landingpage",
  "sec": "Sek.",
  "OS": "OS",
  "ISP / provider": "ISP / Anbieter",
  "Proxy": "Proxy",
  "Empty referrer": "Leerer Referrer",
  "Bots": "Bots",
  "Only bots": "Nur Bots",
  "Exclude bots": "Bots ausschließen",
  "Proxy / VPN": "Proxy / VPN",
  "Only proxy": "Nur Proxy",
  "Exclude proxy": "Proxy ausschließen",
  "IP version": "IP-Version",
  "Show 404": "404 anzeigen",
  "Do nothing": "Nichts tun",
  "Schedule": "Zeitplan",
  "Add interval": "Intervall hinzufügen",
  "Every day, all day": "Jeden Tag, den ganzen Tag",
  "Every day": "Jeden Tag",
  "Error loading affiliate networks": "Fehler beim Laden der Affiliate-Netzwerke",
  "Quick start from preset": "Schnellstart aus Preset",
  "Affiliate network name": "Name des Affiliate-Netzwerks",
  "Vertical": "Vertical",
  "Postback URL template": "Postback-URL-Vorlage",
  "Outbound postback the tracker calls to notify this network.": "Ausgehender Postback, den der Tracker aufruft, um dieses Netzwerk zu benachrichtigen.",
  "Offer parameters": "Offer-Parameter",
  "Key": "Schlüssel",
  "Notes": "Notizen",
  "Internal notes": "Interne Notizen",
  "Affiliate networks": "Affiliate-Netzwerke",
  "Reusable partner networks: postback template, offer params and inbound URL.": "Wiederverwendbare Partner-Netzwerke: Postback-Vorlage, Offer-Parameter und eingehende URL.",
  "Create network": "Netzwerk erstellen",
  "Create affiliate network": "Affiliate-Netzwerk erstellen",
  "Pick a preset or configure a partner network from scratch.": "Wähle ein Preset oder konfiguriere ein Partner-Netzwerk von Grund auf.",
  "Search networks": "Netzwerke suchen",
  "No affiliate networks yet": "Noch keine Affiliate-Netzwerke",
  "Create one from a preset like TrackBox or Adcombo.": "Erstelle eins aus einem Preset wie TrackBox oder Adcombo.",
  "Postback copied": "Postback kopiert",
  "Inbound postback URL (paste in the network)": "Eingehende Postback-URL (in das Netzwerk einfügen)",
  "Inbound URL copied": "Eingehende URL kopiert",
  "conv.": "Conv.",
  "offer parameter(s)": "Offer-Parameter",
  "Edit affiliate network": "Affiliate-Netzwerk bearbeiten",
  "Update partner network settings": "Partnernetzwerk-Einstellungen aktualisieren",
  "Delete affiliate network": "Affiliate-Netzwerk löschen",
  "This permanently deletes the network. Offers linked to it keep their other settings.": "Dadurch wird das Netzwerk endgültig gelöscht. Verknüpfte Offers behalten ihre übrigen Einstellungen.",
  "Affiliate network created": "Affiliate-Netzwerk erstellt",
  "Error creating affiliate network": "Fehler beim Erstellen des Affiliate-Netzwerks",
  "Affiliate network updated": "Affiliate-Netzwerk aktualisiert",
  "Error updating affiliate network": "Fehler beim Aktualisieren des Affiliate-Netzwerks",
  "Affiliate network deleted": "Affiliate-Netzwerk gelöscht",
  "Cannot delete: network is linked to offers": "Löschen nicht möglich: Netzwerk ist mit Offers verknüpft",
  "Error deleting affiliate network": "Fehler beim Löschen des Affiliate-Netzwerks",
  "Copy failed": "Kopieren fehlgeschlagen",
  "Network (text label)": "Netzwerk (Textlabel)",
  "Traffic": "Traffic",
  "A/B Tests": "A/B-Tests",
  "Anti-fraud": "Anti-Fraud",
  "Analytics": "Analytics",
  "Automation": "Automatisierung",
  "Integrations": "Integrationen",
  "Settings": "Einstellungen",
  "Account": "Konto",
  "My account": "Mein Konto",
  "Profile": "Profil",
  "Sign out": "Abmelden",
  "User": "Benutzer",
  "Welcome, {name}.": "Willkommen, {name}.",
  "Welcome,": "Willkommen,",
  "Real-time overview of your campaigns and stats": "Echtzeit-Übersicht über deine Kampagnen und Statistiken",
  "Create campaign": "Kampagne erstellen",
  "Clicks": "Klicks",
  "Unique visitors": "Unique Visitors",
  "Conversions": "Conversions",
  "Total active campaigns": "Aktive Kampagnen insgesamt",
  "Total clicks": "Klicks insgesamt",
  "Unique clicks": "Unique Clicks",
  "{rate}% conversion": "{rate}% Conversion",
  "Recent campaigns": "Letzte Kampagnen",
  "Your latest campaigns": "Deine letzten Kampagnen",
  "You have no campaigns yet": "Du hast noch keine Kampagnen",
  "Create your first campaign": "Erstelle deine erste Kampagne",
  "Quick actions": "Schnellzugriff",
  "Commonly used features": "Häufig genutzte Funktionen",
  "Add a new ad campaign": "Neue Kampagne hinzufügen",
  "View detailed statistics": "Detaillierte Statistiken ansehen",
  "Manage campaigns": "Kampagnen verwalten",
  "Edit existing campaigns": "Bestehende Kampagnen bearbeiten",
  "Show all campaigns": "Alle Kampagnen anzeigen",
  "More details": "Mehr Details",
  "Active": "Aktiv",
  "Paused": "Pausiert",
  "No description": "Keine Beschreibung",
  "{n} clicks": "{n} Klicks",
  "{n} unique": "{n} Unique",
  "{n} conversions": "{n} Conversions",
  "Loading workspace": "Workspace wird geladen",
  "Loading your data…": "Deine Daten werden geladen…",
  "Sign in": "Anmelden",
  "Sign up": "Registrieren",
  "Email": "E-Mail",
  "Work email": "Geschäftliche E-Mail",
  "Password": "Passwort",
  "Full name": "Vollständiger Name",
  "Jane Doe": "Max Mustermann",
  "Create account": "Konto erstellen",
  "Create new account": "Neues Konto erstellen",
  "Already have an account?": "Du hast bereits ein Konto?",
  "Don't have an account?": "Du hast noch kein Konto?",
  "Welcome back": "Willkommen zurück",
  "Sign in to your xpnsr account": "Melde dich bei deinem xpnsr-Konto an",
  "Attribution,": "Attribution,",
  "honest": "ehrlich",
  "Create": "Erstellen",
  "account": "Konto",
  "S2S postback · bot shield": "S2S-Postback · Bot-Schutz",
  "Remember this device": "Dieses Gerät merken",
  "Reset": "Zurücksetzen",
  "Access tracker": "Zum Tracker",
  "Hide password": "Passwort ausblenden",
  "Show password": "Passwort anzeigen",
  "At least 6 characters": "Mindestens 6 Zeichen",
  "Signing in…": "Anmeldung läuft…",
  "Creating account…": "Konto wird erstellt…",
  "Invalid email or password": "Ungültige E-Mail oder ungültiges Passwort",
  "Registration failed. Please try again.": "Registrierung fehlgeschlagen. Bitte versuche es erneut.",
  "New registrations are disabled. Contact your workspace admin for an invitation.": "Neue Registrierungen sind deaktiviert. Wende dich für eine Einladung an deinen Workspace-Admin.",
  "Home": "Startseite",
  "Auth": "Auth",
  "Book Demo": "Demo buchen",
  "Search campaigns, streams…": "Kampagnen, Streams durchsuchen…",
  "One visual language for the xpnsr.tech family.": "Eine visuelle Sprache für die xpnsr.tech-Familie.",
  "Control": "Kontrolle",
  "Operations": "Operations",
  "Precise tracking": "Präzises Tracking",
  "KPIs, sources and leads in one panel.": "KPIs, Quellen und Leads in einem Panel.",
  "Readable reports": "Verständliche Reports",
  "Data visualization for fast decisions.": "Datenvisualisierung für schnelle Entscheidungen.",
  "Scale your team": "Skaliere dein Team",
  "Organize teams, campaigns and sources without friction.": "Organisiere Teams, Kampagnen und Quellen ohne Reibungsverluste.",
  "Enter your credentials to continue.": "Gib deine Zugangsdaten ein, um fortzufahren.",
  "Create a new xpnsr.tech account.": "Erstelle ein neues xpnsr.tech-Konto.",
  "Campaign management": "Kampagnenverwaltung",
  "Create, edit and track your ad campaigns in real time": "Erstelle, bearbeite und tracke deine Werbekampagnen in Echtzeit",
  "Search campaigns…": "Kampagnen suchen…",
  "Create new campaign": "Neue Kampagne erstellen",
  "Edit campaign": "Kampagne bearbeiten",
  "Fill in the details of your new ad campaign": "Gib die Details deiner neuen Werbekampagne ein",
  "Update campaign details": "Kampagnendetails aktualisieren",
  "Campaign name": "Kampagnenname",
  "Description (optional)": "Beschreibung (optional)",
  "Target URL": "Ziel-URL",
  "Traffic source": "Traffic-Quelle",
  "Cost model": "Kostenmodell",
  "Select a traffic source (optional)": "Wähle eine Traffic-Quelle (optional)",
  "CPC (per click)": "CPC (pro Klick)",
  "CPM (per impression)": "CPM (pro Impression)",
  "CPA (per action)": "CPA (pro Aktion)",
  "Cancel": "Abbrechen",
  "Save changes": "Änderungen speichern",
  "Edit": "Bearbeiten",
  "Copy link": "Link kopieren",
  "Delete": "Löschen",
  "Are you sure you want to delete this campaign?": "Bist du sicher, dass du diese Kampagne löschen möchtest?",
  "Campaign created successfully!": "Kampagne erfolgreich erstellt!",
  "Campaign updated successfully!": "Kampagne erfolgreich aktualisiert!",
  "Campaign deleted successfully!": "Kampagne erfolgreich gelöscht!",
  "No campaigns": "Keine Kampagnen",
  "Campaigns not found": "Keine Kampagnen gefunden",
  "Create your first campaign to start tracking traffic": "Erstelle deine erste Kampagne, um mit dem Tracking von Traffic zu beginnen",
  "Try adjusting search criteria": "Versuche, die Suchkriterien anzupassen",
  "Tracking ID": "Tracking-ID",
  "Link copied to clipboard!": "Link in die Zwischenablage kopiert!",
  "Failed to copy link": "Link konnte nicht kopiert werden",
  "Error loading campaigns": "Fehler beim Laden der Kampagnen",
  "Error creating campaign": "Fehler beim Erstellen der Kampagne",
  "Error updating campaign": "Fehler beim Aktualisieren der Kampagne",
  "Error deleting campaign": "Fehler beim Löschen der Kampagne",
  "For example: Product A ad": "Zum Beispiel: Anzeige für Produkt A",
  "Short campaign description": "Kurze Kampagnenbeschreibung",
  "New landing page": "Neue Landingpage",
  "Add landing page": "Landingpage hinzufügen",
  "Add a landing page for use in campaigns and A/B tests": "Füge eine Landingpage hinzu, die du in Kampagnen und A/B-Tests nutzen kannst",
  "Edit landing page": "Landingpage bearbeiten",
  "Edit landing page settings": "Landingpage-Einstellungen bearbeiten",
  "Search landing pages…": "Landingpages suchen…",
  "Create landing pages for use in campaigns": "Erstelle Landingpages für den Einsatz in Kampagnen",
  "No landing pages": "Keine Landingpages",
  "Nothing found": "Nichts gefunden",
  "Landing page created": "Landingpage erstellt",
  "Landing page updated": "Landingpage aktualisiert",
  "Landing page deleted": "Landingpage gelöscht",
  "Delete this landing page?": "Diese Landingpage löschen?",
  "Error loading landing pages": "Fehler beim Laden der Landingpages",
  "Error creating landing page": "Fehler beim Erstellen der Landingpage",
  "Error updating landing page": "Fehler beim Aktualisieren der Landingpage",
  "Error deleting landing page": "Fehler beim Löschen der Landingpage",
  "Please fill in name and URL": "Bitte gib Name und URL ein",
  "URL copied": "URL kopiert",
  "My landing": "Meine Landingpage",
  "Landing page description": "Beschreibung der Landingpage",
  "Lead generation": "Lead-Generierung",
  "Subscription": "Abonnement",
  "Download": "Herunterladen",
  "Other": "Sonstiges",
  "Category": "Kategorie",
  "Select category": "Kategorie auswählen",
  "Description": "Beschreibung",
  "Tags": "Tags",
  "Add tag": "Tag hinzufügen",
  "Status": "Status",
  "Inactive": "Inaktiv",
  "Visits": "Besuche",
  "CR": "CR",
  "Actions": "Aktionen",
  "Name": "Name",
  "URL": "URL",
  "Save": "Speichern",
  "Unique": "Eindeutig",
  "Add offer": "Offer hinzufügen",
  "New offer": "Neuer Offer",
  "Edit offer": "Offer bearbeiten",
  "Add an offer to use in campaigns": "Füge einen Offer hinzu, den du in Kampagnen nutzen kannst",
  "Change offer parameters": "Offer-Parameter ändern",
  "Search offers…": "Offers suchen…",
  "No offers": "Keine Offers",
  "Create offers to monetize your traffic": "Erstelle Offers, um deinen Traffic zu monetarisieren",
  "Offer created": "Offer erstellt",
  "Offer updated": "Offer aktualisiert",
  "Offer deleted": "Offer gelöscht",
  "Delete this offer?": "Diesen Offer löschen?",
  "Error loading offers": "Fehler beim Laden der Offers",
  "Error creating offer": "Fehler beim Erstellen des Offers",
  "Error updating offer": "Fehler beim Aktualisieren des Offers",
  "Error deleting offer": "Fehler beim Löschen des Offers",
  "My offer": "Mein Offer",
  "Offer URL": "Offer URL",
  "Offer description": "Offer-Beschreibung",
  "Affiliate network": "Affiliate-Netzwerk",
  "Network": "Netzwerk",
  "Payout": "Payout",
  "Currency": "Währung",
  "Geo": "GEO",
  "Countries (ISO codes, e.g. US, RU)": "Länder (ISO-Codes, z. B. US, RU)",
  "Nutra": "Nutra",
  "Gambling": "Gambling",
  "Dating": "Dating",
  "Finance": "Finanzen",
  "Crypto": "Krypto",
  "Sweepstakes": "Sweepstakes",
  "Back": "Zurück",
  "Streams": "Streams",
  "Open target URL": "Ziel-URL öffnen",
  "Copy tracking link": "Tracking-Link kopieren",
  "Tracking link copied!": "Tracking-Link kopiert!",
  "Campaign not found": "Kampagne nicht gefunden",
  "Successful conversions": "Erfolgreiche Conversions",
  "Conversion rate": "Conversion-Rate",
  "Conversion percentage": "Conversion-Anteil",
  "Campaign info": "Kampagneninfo",
  "Tracking link": "Tracking-Link",
  "Created": "Erstellt",
  "Updated": "Aktualisiert",
  "Recent clicks": "Letzte Klicks",
  "Recent activity for this campaign": "Letzte Aktivität dieser Kampagne",
  "No clicks for this campaign yet": "Noch keine Klicks für diese Kampagne",
  "Showing latest 10 clicks": "Zeigt die letzten 10 Klicks",
  "Device breakdown": "Aufschlüsselung nach Gerät",
  "Browser breakdown": "Aufschlüsselung nach Browser",
  "No data to display": "Keine Daten zum Anzeigen",
  "Unknown": "Unbekannt",
  "Traffic sources": "Traffic-Quellen",
  "Create source": "Quelle anlegen",
  "Create traffic source": "Traffic-Quelle erstellen",
  "Edit traffic source": "Traffic-Quelle bearbeiten",
  "Update traffic source settings": "Einstellungen der Traffic-Quelle aktualisieren",
  "Configure a traffic source for UTM tags and conversion postbacks": "Konfiguriere eine Traffic-Quelle für UTM-Tags und Conversion-Postbacks",
  "Source template": "Quellenvorlage",
  "Pick a template or create your own": "Wähle eine Vorlage oder erstelle deine eigene",
  "Traffic source name": "Name der Traffic-Quelle",
  "Traffic source description": "Beschreibung der Traffic-Quelle",
  "Postback URL": "Postback URL",
  "Postback URL copied": "Postback-URL kopiert",
  "UTM parameters": "UTM-Parameter",
  "Add parameter": "Parameter hinzufügen",
  "Enter parameter name:": "Parametername eingeben:",
  "Parameter": "Parameter",
  "Alias": "Alias",
  "Placeholder": "Platzhalter",
  "Action": "Aktion",
  "Source macro": "Quellen-Makro",
  "No parameters added": "Keine Parameter hinzugefügt",
  "Search traffic sources…": "Traffic-Quellen durchsuchen…",
  "Sources not found": "Quellen nicht gefunden",
  "No traffic sources": "Keine Traffic-Quellen",
  "Create sources to integrate with ad networks": "Erstelle Quellen, um dich mit Affiliate-Netzwerken zu verbinden",
  "Spend": "Ausgaben",
  "Parameters configured:": "Konfigurierte Parameter:",
  "Traffic source created": "Traffic-Quelle erstellt",
  "Traffic source updated": "Traffic-Quelle aktualisiert",
  "Traffic source deleted": "Traffic-Quelle gelöscht",
  "Are you sure you want to delete this traffic source?": "Möchtest du diese Traffic-Quelle wirklich löschen?",
  "Cannot delete: source is in use by campaigns": "Löschen nicht möglich: Die Quelle wird von Kampagnen verwendet",
  "Error loading traffic sources": "Fehler beim Laden der Traffic-Quellen",
  "Error creating traffic source": "Fehler beim Erstellen der Traffic-Quelle",
  "Error updating traffic source": "Fehler beim Aktualisieren der Traffic-Quelle",
  "Error deleting traffic source": "Fehler beim Löschen der Traffic-Quelle",
  "Preferences": "Einstellungen",
  "Notifications": "Benachrichtigungen",
  "System": "System",
  "Profile information": "Profilinformationen",
  "Manage your basic account information": "Verwalte deine grundlegenden Kontoinformationen",
  "Enter your full name": "Gib deinen vollständigen Namen ein",
  "Enter your email": "Gib deine E-Mail-Adresse ein",
  "Save profile": "Profil speichern",
  "Change password": "Passwort ändern",
  "Update your password to keep your account secure": "Aktualisiere dein Passwort, um dein Konto sicher zu halten",
  "Current password": "Aktuelles Passwort",
  "New password": "Neues Passwort",
  "Confirm new password": "Neues Passwort bestätigen",
  "Enter current password": "Aktuelles Passwort eingeben",
  "Enter new password": "Neues Passwort eingeben",
  "New passwords do not match": "Die neuen Passwörter stimmen nicht überein",
  "New password must be at least 6 characters": "Das neue Passwort muss mindestens 6 Zeichen lang sein",
  "Password changed successfully": "Passwort erfolgreich geändert",
  "Profile updated successfully": "Profil erfolgreich aktualisiert",
  "Error updating profile": "Fehler beim Aktualisieren des Profils",
  "Error changing password": "Fehler beim Ändern des Passworts",
  "Error loading settings": "Fehler beim Laden der Einstellungen",
  "Error saving settings": "Fehler beim Speichern der Einstellungen",
  "Error saving system settings": "Fehler beim Speichern der Systemeinstellungen",
  "User settings saved": "Benutzereinstellungen gespeichert",
  "System settings saved": "Systemeinstellungen gespeichert",
  "Interface preferences": "Oberflächeneinstellungen",
  "Customize the look and behavior of the app": "Passe das Aussehen und Verhalten der App an",
  "Timezone": "Zeitzone",
  "Moscow (UTC+3)": "Moskau (UTC+3)",
  "Kyiv (UTC+2)": "Kyiv (UTC+2)",
  "New York (UTC-5)": "New York (UTC-5)",
  "Language": "Sprache",
  "Date format": "Datumsformat",
  "Dashboard refresh rate (sec)": "Aktualisierungsrate des Dashboards (Sek.)",
  "Save settings": "Einstellungen speichern",
  "Configure how you receive notifications": "Lege fest, wie du Benachrichtigungen erhältst",
  "Email notifications": "E-Mail-Benachrichtigungen",
  "SMS notifications": "SMS-Benachrichtigungen",
  "Get email notifications about important events": "Erhalte E-Mail-Benachrichtigungen zu wichtigen Ereignissen",
  "Get SMS for critical events": "Erhalte SMS bei kritischen Ereignissen",
  "Save notification settings": "Benachrichtigungseinstellungen speichern",
  "Tracking domains": "Tracking-Domains",
  "Configure domains for campaign tracking": "Konfiguriere Domains für das Kampagnen-Tracking",
  "Primary tracking domain": "Primäre Tracking-Domain",
  "Additional domains": "Weitere Domains",
  "Add domain": "Domain hinzufügen",
  "Add": "Hinzufügen",
  "Save domain settings": "Domain-Einstellungen speichern",
  "Security": "Sicherheit",
  "Security and access settings": "Sicherheits- und Zugriffseinstellungen",
  "Security settings": "Sicherheitseinstellungen",
  "Coming in upcoming releases": "Kommt in zukünftigen Versionen",
  "Active campaigns": "Aktive Kampagnen",
  "Clicks today": "Klicks heute",
  "For the current day": "Für den aktuellen Tag",
  "Confirmed": "Bestätigt",
  "Refresh": "Aktualisieren",
  "Export": "Export",
  "Report exported": "Report exportiert",
  "Period:": "Zeitraum:",
  "Today": "Heute",
  "7 days": "7 Tage",
  "14 days": "14 Tage",
  "30 days": "30 Tage",
  "90 days": "90 Tage",
  "Campaign:": "Kampagne:",
  "All campaigns": "Alle Kampagnen",
  "Overview": "Übersicht",
  "Devices": "Geräte",
  "Clicks and conversions": "Klicks und Conversions",
  "No data for the selected period": "Keine Daten für den ausgewählten Zeitraum",
  "No data": "Keine Daten",
  "Hourly activity": "Aktivität nach Stunde",
  "CR% by day": "CR% pro Tag",
  "Campaign stats": "Kampagnenstatistik",
  "Revenue": "Umsatz",
  "No campaign data": "Keine Kampagnendaten",
  "Total revenue": "Gesamtumsatz",
  "Total spend": "Gesamtausgaben",
  "Profit": "Gewinn",
  "Net positive": "Netto positiv",
  "Net loss": "Nettoverlust",
  "Advanced notification preferences": "Erweiterte Benachrichtigungseinstellungen",
  "Push notifications, webhook URL, alert categories": "Push-Benachrichtigungen, Webhook-URL, Alarmkategorien",
  "Configure": "Konfigurieren",
  "All values shown in": "Alle Werte angezeigt in",
  "FX rates unavailable — non-USD revenue is excluded from the totals.": "Wechselkurse nicht verfügbar — Nicht-USD-Umsätze werden aus den Summen ausgeschlossen.",
  "ROI by campaigns": "ROI nach Kampagnen",
  "No ROI data": "Keine ROI-Daten",
  "Clicks by country": "Klicks nach Land",
  "Geo table": "GEO-Tabelle",
  "No geo data": "Keine Geo-Daten",
  "Country": "Land",
  "Devices table": "Gerätetabelle",
  "Device type": "Gerätetyp",
  "Share": "Anteil",
  "No device data": "Keine Gerätedaten",
  "Failed to load campaign": "Kampagne konnte nicht geladen werden",
  "Failed to load streams": "Streams konnten nicht geladen werden",
  "Stream created": "Stream erstellt",
  "Failed to create stream": "Stream konnte nicht erstellt werden",
  "Stream updated": "Stream aktualisiert",
  "Failed to update stream": "Stream konnte nicht aktualisiert werden",
  "Delete this stream?": "Diesen Stream löschen?",
  "Stream deleted": "Stream gelöscht",
  "Failed to delete stream": "Stream konnte nicht gelöscht werden",
  "Catch": "Catch",
  "Fallback": "Fallback",
  "Normal": "Normal",
  "Stream name": "Stream-Name",
  "Stream type": "Stream-Typ",
  "Position": "Position",
  "Weight (%)": "Gewichtung (%)",
  "Click limit": "Klicklimit",
  "No limit": "Kein Limit",
  "Stream action": "Stream-Aktion",
  "Action type": "Aktionstyp",
  "Redirect": "Weiterleitung",
  "Split test": "Split-Test",
  "Redirect URL": "Redirect URL",
  "Landings and offers": "Landingpages und Offers",
  "Landings": "Landings",
  "No landings available": "Keine Landingpages verfügbar",
  "No offers available": "Keine Offers verfügbar",
  "Traffic filters": "Traffic-Filter",
  "Countries (ISO codes)": "Länder (ISO-Codes)",
  "Cities": "Städte",
  "Browsers": "Browser",
  "Operating systems": "Betriebssysteme",
  "Languages": "Sprachen",
  "Don't filter": "Nicht filtern",
  "Accept only unique": "Nur eindeutige akzeptieren",
  "Filter unique": "Unique filtern",
  "Campaign streams": "Kampagnen-Streams",
  "Create stream": "Stream erstellen",
  "Configure stream for traffic distribution by conditions": "Stream für Traffic-Verteilung nach Bedingungen konfigurieren",
  "No streams": "Keine Streams",
  "Create streams to distribute traffic by conditions": "Erstelle Streams, um Traffic nach Bedingungen zu verteilen",
  "Weight": "Gewichtung",
  "Bots filtered": "Bots gefiltert",
  "Countries": "Länder",
  "Limit": "Limit",
  "Edit stream": "Stream bearbeiten",
  "Modify stream settings": "Stream-Einstellungen ändern",
  "Failed to load data": "Daten konnten nicht geladen werden",
  "Failed to load traffic rules": "Traffic-Regeln konnten nicht geladen werden",
  "Select a campaign": "Wähle eine Kampagne",
  "Traffic rule created": "Traffic-Regel erstellt",
  "Failed to create rule": "Regel konnte nicht erstellt werden",
  "Rule updated": "Regel aktualisiert",
  "Failed to update rule": "Regel konnte nicht aktualisiert werden",
  "Rule deleted": "Regel gelöscht",
  "Failed to delete rule": "Regel konnte nicht gelöscht werden",
  "Landing created": "Landingpage erstellt",
  "Failed to create landing": "Landingpage konnte nicht erstellt werden",
  "Failed to create offer": "Offer konnte nicht erstellt werden",
  "Traffic management": "Traffic-Verwaltung",
  "Select campaign": "Kampagne auswählen",
  "Traffic rules": "Traffic-Regeln",
  "Traffic distribution rules": "Regeln für Traffic-Verteilung",
  "Create rule": "Regel erstellen",
  "Create traffic rule": "Traffic-Regel erstellen",
  "Edit rule": "Regel bearbeiten",
  "Configure conditions and actions for traffic distribution": "Konfiguriere Bedingungen und Aktionen für die Traffic-Verteilung",
  "Rule name": "Regelname",
  "Priority": "Priorität",
  "Rule description": "Regelbeschreibung",
  "Conditions (leave empty for any value)": "Bedingungen (leer lassen für beliebigen Wert)",
  "Update": "Aktualisieren",
  "No traffic rules": "Keine Traffic-Regeln",
  "Create rules to distribute traffic by conditions": "Erstelle Regeln, um Traffic nach Bedingungen zu verteilen",
  "Stopped": "Gestoppt",
  "Any": "Beliebig",
  "Redirects": "Weiterleitungen",
  "Select a campaign to manage traffic rules": "Wähle eine Kampagne, um Traffic-Regeln zu verwalten",
  "Add landing": "Landingpage hinzufügen",
  "Add a new landing to the library": "Eine neue Landingpage zur Bibliothek hinzufügen",
  "Landing name": "Name der Landingpage",
  "Landing description": "Beschreibung der Landingpage",
  "No landings": "Keine Landingpages",
  "Add landings to use in traffic rules": "Füge Landingpages hinzu, um sie in Traffic-Regeln zu nutzen",
  "Add a new offer to monetize traffic": "Ein neues Offer hinzufügen, um Traffic zu monetarisieren",
  "Offer name": "Offer-Name",
  "Add offers to monetize traffic": "Füge Offers hinzu, um Traffic zu monetarisieren",
  "A/B Testing": "A/B-Tests",
  "Create A/B test": "A/B-Test erstellen",
  "Set up split testing to optimize conversions": "Richte Split-Testing ein, um Conversions zu optimieren",
  "Test name": "Testname",
  "Landing page test": "Landingpage-Test",
  "Test description": "Testbeschreibung",
  "Test type": "Testtyp",
  "Traffic paths": "Traffic-Pfade",
  "Confidence level (%)": "Konfidenzniveau (%)",
  "Minimum sample size": "Mindeststichprobengröße",
  "Test variants": "Testvarianten",
  "Add variant": "Variante hinzufügen",
  "Variant {n}": "Variante {n}",
  "Variant name": "Variantenname",
  "URL (or pick below)": "URL (oder unten auswählen)",
  "Pick landing page": "Landingpage auswählen",
  "Pick offer": "Offer auswählen",
  "Traffic weight (%)": "Traffic-Gewichtung (%)",
  "Total weight": "Gesamtgewichtung",
  "Create test": "Test erstellen",
  "No A/B tests": "Keine A/B-Tests",
  "Create split tests to optimize conversions": "Erstelle Split-Tests, um Conversions zu optimieren",
  "Visitors": "Besucher",
  "Significance": "Signifikanz",
  "Variants": "Varianten",
  "Progress to minimum sample": "Fortschritt zur Mindeststichprobe",
  "A/B test results": "A/B-Testergebnisse",
  "Variant performance analysis": "Analyse der Variantenleistung",
  "Conversion": "Conversion",
  "Confidence interval": "Konfidenzintervall",
  "Not enough data for analysis": "Nicht genügend Daten für die Analyse",
  "Close": "Schließen",
  "Running": "Läuft",
  "Completed": "Abgeschlossen",
  "Draft": "Entwurf",
  "Delete this A/B test?": "Diesen A/B-Test löschen?",
  "A/B test deleted": "A/B-Test gelöscht",
  "Failed to delete test": "Test konnte nicht gelöscht werden",
  "A/B test created": "A/B-Test erstellt",
  "Failed to create A/B test": "A/B-Test konnte nicht erstellt werden",
  "A/B test started": "A/B-Test gestartet",
  "Failed to start test": "Test konnte nicht gestartet werden",
  "A/B test paused": "A/B-Test pausiert",
  "Failed to pause test": "Test konnte nicht pausiert werden",
  "Failed to load results": "Ergebnisse konnten nicht geladen werden",
  "Failed to load A/B tests": "A/B-Tests konnten nicht geladen werden",
  "At least 2 variants required": "Mindestens 2 Varianten erforderlich",
  "Webhooks": "Webhooks",
  "Import costs and conversions": "Kosten und Conversions importieren",
  "Sync campaigns and conversions": "Kampagnen und Conversions synchronisieren",
  "Import ad statistics": "Werbestatistiken importieren",
  "VKontakte integration": "VKontakte-Integration",
  "Automatic traffic import": "Automatischer Traffic-Import",
  "Server-to-server postbacks": "Server-to-Server-Postbacks",
  "Custom API integration": "Benutzerdefinierte API-Integration",
  "Telegram notifications": "Telegram-Benachrichtigungen",
  "Click": "Klick",
  "Campaign paused": "Kampagne pausiert",
  "Campaign started": "Kampagne gestartet",
  "Fraud detected": "Betrug erkannt",
  "Threshold reached": "Schwellenwert erreicht",
  "Fill in type and name": "Typ und Namen ausfüllen",
  "Integration created": "Integration erstellt",
  "Error creating": "Fehler beim Erstellen",
  "Integration updated": "Integration aktualisiert",
  "Error updating": "Fehler beim Aktualisieren",
  "Delete integration?": "Integration löschen?",
  "Integration deleted": "Integration gelöscht",
  "Error deleting": "Fehler beim Löschen",
  "Fill in name and URL": "Namen und URL ausfüllen",
  "Webhook created": "Webhook erstellt",
  "Error creating webhook": "Fehler beim Erstellen des Webhooks",
  "Webhook updated": "Webhook aktualisiert",
  "Delete webhook?": "Webhook löschen?",
  "Webhook deleted": "Webhook gelöscht",
  "Test succeeded (HTTP {code})": "Test erfolgreich (HTTP {code})",
  "Test error: {detail}": "Testfehler: {detail}",
  "Error testing webhook": "Fehler beim Testen des Webhooks",
  "Integration type": "Integrationstyp",
  "Select type": "Typ auswählen",
  "Configuration (key-value)": "Konfiguration (Schlüssel-Wert)",
  "Key (e.g. api_key)": "Schlüssel (z. B. api_key)",
  "Value": "Wert",
  "My webhook": "Mein Webhook",
  "Secret (optional)": "Secret (optional)",
  "Events": "Ereignisse",
  "Retry attempts": "Wiederholungsversuche",
  "Timeout (sec)": "Timeout (Sek.)",
  "Add integration": "Integration hinzufügen",
  "New integration": "Neue Integration",
  "Configure connection to an external service": "Verbindung zu einem externen Dienst konfigurieren",
  "No integrations": "Keine Integrationen",
  "Connect external services to automate workflows": "Verbinde externe Dienste, um Arbeitsabläufe zu automatisieren",
  "Connected": "Verbunden",
  "Disconnected": "Getrennt",
  "Last sync": "Letzte Synchronisierung",
  "Add webhook": "Webhook hinzufügen",
  "New webhook": "Neuer Webhook",
  "Configure a webhook to receive notifications": "Konfiguriere einen Webhook, um Benachrichtigungen zu erhalten",
  "No webhooks": "Keine Webhooks",
  "Create webhooks to send events to external systems": "Erstelle Webhooks, um Ereignisse an externe Systeme zu senden",
  "Success": "Erfolg",
  "Errors": "Fehler",
  "Test": "Test",
  "Edit integration": "Integration bearbeiten",
  "Edit webhook": "Webhook bearbeiten",
  "Anti-fraud system": "Antifraud-System",
  "Filter created": "Filter erstellt",
  "Failed to create filter": "Filter konnte nicht erstellt werden",
  "Filter updated": "Filter aktualisiert",
  "Failed to update filter": "Filter konnte nicht aktualisiert werden",
  "Filter deleted": "Filter gelöscht",
  "Failed to delete filter": "Filter konnte nicht gelöscht werden",
  "IP added to blacklist": "IP zur Blacklist hinzugefügt",
  "IP added to whitelist": "IP zur Whitelist hinzugefügt",
  "Failed to add IP": "IP konnte nicht hinzugefügt werden",
  "IP removed from blacklist": "IP aus der Blacklist entfernt",
  "IP removed from whitelist": "IP aus der Whitelist entfernt",
  "Failed to remove IP": "IP konnte nicht entfernt werden",
  "Activity marked as resolved": "Aktivität als erledigt markiert",
  "Failed to update activity": "Aktivität konnte nicht aktualisiert werden",
  "Filters": "Filter",
  "IP lists": "IP-Listen",
  "Suspicious activity": "Verdächtige Aktivität",
  "Statistics": "Statistiken",
  "Fraud filters": "Antifraud-Filter",
  "Create filter": "Filter erstellen",
  "Edit filter": "Filter bearbeiten",
  "Create fraud filter": "Antifraud-Filter erstellen",
  "Configure automatic filters to block suspicious traffic": "Konfiguriere automatische Filter, um verdächtigen Traffic zu blockieren",
  "Filter name": "Filtername",
  "Filter type": "Filtertyp",
  "Bot detection": "Bot-Erkennung",
  "Click frequency": "Klickfrequenz",
  "Country block": "Länderblockierung",
  "ASN block": "ASN-Blockierung",
  "Datacenter / hosting block": "Blockierung von Rechenzentren / Hosting",
  "Proxy / VPN / Tor block": "Blockierung von Proxy / VPN / Tor",
  "External risk score": "Externer Risiko-Score",
  "Filter description": "Filterbeschreibung",
  "Max clicks per minute": "Maximale Klicks pro Minute",
  "Blocked countries (ISO codes)": "Blockierte Länder (ISO-Codes)",
  "ASN numbers": "ASN-Nummern",
  "ASN name substrings": "Teilzeichenfolgen des ASN-Namens",
  "Comma-separated AS numbers (e.g. 16509 = AWS, 24940 = Hetzner).": "Durch Kommas getrennte AS-Nummern (z. B. 16509 = AWS, 24940 = Hetzner).",
  "Case-insensitive substring match against the ASN label.": "Teilzeichenfolgen-Abgleich ohne Groß-/Kleinschreibung mit dem ASN-Label.",
  "Allowed ASNs (whitelist)": "Erlaubte ASNs (Whitelist)",
  "Optional. Datacenter IPs that match these ASNs / labels are not blocked.": "Optional. Datacenter-IPs, die mit diesen ASNs / Labels übereinstimmen, werden nicht blockiert.",
  "Block Tor exit nodes": "Tor-Exit-Nodes blockieren",
  "Block proxies (requires API key)": "Proxys blockieren (API-Schlüssel erforderlich)",
  "Block VPNs (requires API key)": "VPNs blockieren (API-Schlüssel erforderlich)",
  "External provider": "Externer Anbieter",
  "Set IPQS_API_KEY or FRAUDSCORE_API_KEY in the backend environment.": "Lege IPQS_API_KEY oder FRAUDSCORE_API_KEY in der Backend-Umgebung fest.",
  "Risk score threshold (0-100)": "Risiko-Score-Schwelle (0–100)",
  "Block when the provider returns a score >= this threshold (default 85).": "Blockieren, wenn der Anbieter einen Score >= diesem Schwellenwert zurückgibt (Standard 85).",
  "Block": "Blockieren",
  "Log only": "Nur protokollieren",
  "No active filters": "Keine aktiven Filter",
  "Create filters for automatic fraud protection": "Filter für automatischen Fraud-Schutz erstellen",
  "Blocked": "Blockiert",
  "False positives": "Fehlalarme",
  "IP blacklist": "IP-Blacklist",
  "IP whitelist": "IP-Whitelist",
  "Blacklist is empty": "Blacklist ist leer",
  "Whitelist is empty": "Whitelist ist leer",
  "Blocked: {n} times": "Blockiert: {n} Mal",
  "View blocked samples": "Blockierte Beispiele ansehen",
  "Blocked samples": "Blockierte Beispiele",
  "Blocked samples: {name}": "Blockierte Beispiele: {name}",
  "Most recent traffic caught by this filter. Use it to spot false positives.": "Zuletzt von diesem Filter erfasster Traffic. Nutze ihn, um False Positives zu erkennen.",
  "No blocked samples yet": "Noch keine blockierten Beispiele",
  "Failed to load blocked samples": "Blockierte Beispiele konnten nicht geladen werden",
  "(empty UA)": "(leerer UA)",
  "Add IP to blacklist": "IP zur Blacklist hinzufügen",
  "Add IP to whitelist": "IP zur Whitelist hinzufügen",
  "IP address": "IP-Adresse",
  "Reason": "Reason",
  "Reason for adding": "Grund für das Hinzufügen",
  "Notes (optional)": "Notizen (optional)",
  "Additional information": "Zusätzliche Informationen",
  "No suspicious activity detected": "Keine verdächtige Aktivität erkannt",
  "The system automatically tracks suspicious actions": "Das System verfolgt verdächtige Aktionen automatisch",
  "Resolved": "Gelöst",
  "Mark as resolved": "Als erledigt markieren",
  "User Agent": "User Agent",
  "Time": "Zeit",
  "Details": "Details",
  "Active filters": "Aktive Filter",
  "Blocked IPs": "Blockierte IPs",
  "Failed to load automation rules": "Automatisierungsregeln konnten nicht geladen werden",
  "Automation rule created": "Automatisierungsregel erstellt",
  "Failed to create automation rule": "Automatisierungsregel konnte nicht erstellt werden",
  "Automation rule updated": "Automatisierungsregel aktualisiert",
  "Failed to update automation rule": "Automatisierungsregel konnte nicht aktualisiert werden",
  "Are you sure you want to delete this rule?": "Möchtest du diese Regel wirklich löschen?",
  "Automation rule deleted": "Automatisierungsregel gelöscht",
  "Failed to delete automation rule": "Automatisierungsregel konnte nicht gelöscht werden",
  "Rule activated": "Regel aktiviert",
  "Rule deactivated": "Regel deaktiviert",
  "Failed to change rule status": "Regelstatus konnte nicht geändert werden",
  "Notification settings saved": "Benachrichtigungseinstellungen gespeichert",
  "Failed to save notification settings": "Benachrichtigungseinstellungen konnten nicht gespeichert werden",
  "Pause campaign": "Kampagne pausieren",
  "Budget alert": "Budgetwarnung",
  "Performance alert": "Performance-Warnung",
  "Rules": "Regeln",
  "Automation rules": "Automatisierungsregeln",
  "Create automation rule": "Automatisierungsregel erstellen",
  "Configure automatic actions based on conditions": "Konfiguriere automatische Aktionen basierend auf Bedingungen",
  "Rule type": "Regeltyp",
  "Trigger conditions": "Auslösebedingungen",
  "Maximum cost per click": "Maximale Kosten pro Klick",
  "Minimum CR (%)": "Minimale CR (%)",
  "Budget percentage for alert": "Budgetprozentsatz für Warnung",
  "Execution settings": "Ausführungseinstellungen",
  "Interval between executions (min)": "Intervall zwischen Ausführungen (Min.)",
  "Maximum executions per day": "Maximale Ausführungen pro Tag",
  "No automation rules": "Keine Automatisierungsregeln",
  "Create rules to automatically manage campaigns": "Erstelle Regeln, um Kampagnen automatisch zu verwalten",
  "Executions": "Ausführungen",
  "Interval": "Intervall",
  "{n} min": "{n} Min.",
  "Daily limit": "Tageslimit",
  "Last execution": "Letzte Ausführung",
  "Notification channels": "Benachrichtigungskanäle",
  "Receive notifications by email": "Erhalte Benachrichtigungen per E-Mail",
  "Receive SMS for critical events": "Erhalte SMS für kritische Ereignisse",
  "Push notifications": "Push-Benachrichtigungen",
  "Browser notifications": "Browser-Benachrichtigungen",
  "Webhook URL": "Webhook URL",
  "Manage how and when you receive alerts": "Verwalte, wie und wann du Benachrichtigungen erhältst",
  "Save preferences": "Einstellungen speichern",
  "Saving…": "Speichern…",
  "Delivery channels": "Zustellkanäle",
  "Choose how to receive notifications": "Wähle, wie du Benachrichtigungen erhalten möchtest",
  "Receive alerts via email": "Benachrichtigungen per E-Mail erhalten",
  "Critical alerts via SMS": "Kritische Benachrichtigungen per SMS",
  "In-app and browser push": "Push in App und Browser",
  "POST JSON payloads to your endpoint": "POST JSON-Payloads an deinen Endpoint",
  "Alert categories": "Warnkategorien",
  "Choose which types of events trigger notifications": "Wähle, welche Ereignistypen Benachrichtigungen auslösen",
  "Campaign alerts": "Kampagnenwarnungen",
  "Paused, resumed, daily cap reached": "Pausiert, fortgesetzt, Tageslimit erreicht",
  "Performance alerts": "Performance-Warnungen",
  "ROI drop, conversion rate change, EPC decline": "ROI-Rückgang, Änderung der Conversion-Rate, EPC-Rückgang",
  "Fraud alerts": "Betrugswarnungen",
  "Suspicious clicks, bot traffic, IP blacklist hits": "Verdächtige Klicks, Bot-Traffic, Treffer auf IP-Blacklist",
  "System alerts": "Systemwarnungen",
  "Domain verification, TLS expiry, billing": "Domain-Verifizierung, TLS-Ablauf, Abrechnung",
  "Notification preferences saved": "Benachrichtigungseinstellungen gespeichert",
  "Failed to load notification settings": "Fehler beim Laden der Benachrichtigungseinstellungen",
  "CSV exported": "CSV exportiert",
  "Export campaigns to CSV": "Kampagnen als CSV exportieren",
  "Export offers to CSV": "Offers als CSV exportieren",
  "No domains yet": "Noch keine Domains",
  "Add a custom domain to serve tracking links from your own branded URL.": "Füge eine eigene Domain hinzu, um Tracking-Links über deine eigene Marken-URL bereitzustellen.",
  "Create streams to split traffic by geo, device, OS, or custom conditions.": "Erstelle Streams, um Traffic nach GEO, Gerät, Betriebssystem oder individuellen Bedingungen aufzuteilen.",
  "Create rules to automatically pause, resume, or adjust campaigns based on performance thresholds.": "Erstelle Regeln, um Kampagnen basierend auf Leistungsschwellen automatisch zu pausieren, fortzusetzen oder anzupassen.",
  "No members yet": "Noch keine Mitglieder",
  "Invite teammates above to collaborate.": "Lade oben Teammitglieder zur Zusammenarbeit ein.",
  "URL for receiving notifications in JSON format": "URL zum Empfangen von Benachrichtigungen im JSON-Format",
  "Alert types": "Warnungstypen",
  "Campaign start, pause, completion": "Kampagnenstart, -pause, -abschluss",
  "Changes in CR, ROI, cost": "Änderungen bei CR, ROI, Kosten",
  "Suspicious traffic detection": "Erkennung von verdächtigem Traffic",
  "Updates and technical information": "Updates und technische Informationen",
  "Execution history": "Ausführungsverlauf",
  "Execution history is empty": "Ausführungsverlauf ist leer",
  "Records of automatic rule executions will appear here": "Hier erscheinen die Protokolle automatischer Regelausführungen",
  "Edit automation rule": "Automatisierungsregel bearbeiten",
  "Change automation rule settings": "Einstellungen der Automatisierungsregel ändern",
  "Geographic statistics": "Geografische Statistik",
  "Loading geographic data...": "Geodaten werden geladen...",
  "By country": "Nach Land",
  "By city": "Nach Stadt",
  "No country data": "Keine Länderdaten",
  "No city data": "Keine Stadtdaten",
  "Click map": "Klickkarte",
  "No data to display on map": "Keine Daten für die Kartenanzeige",
  "Geographic data will appear after the first clicks with resolvable coordinates": "Geodaten erscheinen nach den ersten Klicks mit auflösbaren Koordinaten",
  "Signed in successfully!": "Erfolgreich angemeldet!",
  "Sign in failed": "Anmeldung fehlgeschlagen",
  "Registration successful!": "Registrierung erfolgreich!",
  "Registration failed": "Registrierung fehlgeschlagen",
  "Signed out": "Abgemeldet",
  "One moment…": "Einen Moment…",
  "Documentation": "Dokumentation",
  "Help": "Hilfe",
  "Step-by-step guide for every feature": "Schritt-für-Schritt-Anleitung für jede Funktion",
  "Search sections...": "Abschnitte durchsuchen...",
  "Loading documentation...": "Dokumentation wird geladen...",
  "Back to top": "Nach oben",
  "Domains": "Domains",
  "Tracker domains": "Tracker-Domains",
  "Custom domains": "Eigene Domains",
  "Bind your own domain to mask tracking links. Point a CNAME to our edge and verify ownership via TXT record.": "Verbinde deine eigene Domain, um Tracking-Links zu maskieren. Richte einen CNAME auf unseren Edge-Server und bestätige den Besitz per TXT-Eintrag.",
  "After adding, configure DNS for your domain (TXT record for verification, CNAME or A record to route traffic), then press Verify.": "Nach dem Hinzufügen konfiguriere den DNS deiner Domain (TXT-Eintrag zur Verifizierung, CNAME- oder A-Eintrag zur Traffic-Weiterleitung) und klicke dann auf Verifizieren.",
  "Verified": "Verifiziert",
  "Failed": "Fehlgeschlagen",
  "Pending": "Ausstehend",
  "Default": "Standard",
  "Set default": "Als Standard setzen",
  "Verify": "Verifizieren",
  "TXT verification record": "TXT-Verifizierungseintrag",
  "Routing record (CNAME)": "Routing-Eintrag (CNAME)",
  "Copy value": "Wert kopieren",
  "Copied": "Kopiert",
  "Tracking links will use": "Tracking-Links verwenden",
  "Domain added": "Domain hinzugefügt",
  "Failed to add domain": "Domain konnte nicht hinzugefügt werden",
  "Domain verified": "Domain verifiziert",
  "Verification failed": "Verifizierung fehlgeschlagen",
  "Default domain updated": "Standarddomain aktualisiert",
  "Domain deleted": "Domain gelöscht",
  "Delete this domain?": "Diese Domain löschen?",
  "Enable HTTPS": "Enable HTTPS",
  "HTTPS active": "HTTPS aktiv",
  "Check TLS": "Check TLS",
  "TLS validation records": "TLS-Validierungseinträge",
  "TLS provisioning started": "TLS-Bereitstellung gestartet",
  "TLS provisioning failed": "TLS-Bereitstellung fehlgeschlagen",
  "Action failed": "Aktion fehlgeschlagen",
  "Loading…": "Laden…",
  "Conversion API": "Conversion API",
  "Conversion forwarders": "Conversion-Forwarder",
  "Forward conversions server-to-server to ad networks (FB CAPI, Google Ads, TikTok). Fires automatically on every postback.": "Leite Conversions Server-zu-Server an Werbenetzwerke weiter (FB CAPI, Google Ads, TikTok). Wird bei jedem Postback automatisch ausgelöst.",
  "New forwarder": "Neuer Forwarder",
  "Edit forwarder": "Forwarder bearbeiten",
  "No forwarders yet": "Noch keine Weiterleitungen",
  "Forwarder created": "Forwarder erstellt",
  "Forwarder updated": "Forwarder aktualisiert",
  "Forwarder deleted": "Forwarder gelöscht",
  "Delete forwarder?": "Forwarder löschen?",
  "Send test": "Test senden",
  "Test event sent": "Test-Event gesendet",
  "Test failed": "Test fehlgeschlagen",
  "No events yet": "Noch keine Events",
  "Provider": "Anbieter",
  "Event name": "Ereignisname",
  "Name is required": "Name ist erforderlich",
  "Missing fields": "Fehlende Felder",
  "Sent": "Gesendet",
  "Event": "Event",
  "Last sent": "Zuletzt gesendet",
  "Public API": "Public API",
  "API keys": "API-Schlüssel",
  "New key": "Neuer Schlüssel",
  "New API key": "Neuer API-Key",
  "Use API keys to call the public /v1 REST API. Pass the key as": "Verwende API-Keys, um die öffentliche /v1 REST API aufzurufen. Übergib den Key als",
  "or": "or",
  "Copy your key now — it will not be shown again": "Kopiere deinen Key jetzt — er wird nicht erneut angezeigt",
  "Copy": "Kopieren",
  "Dismiss": "Schließen",
  "Quick start": "Schnellstart",
  "Docs": "Docs",
  "No API keys yet": "Noch keine API-Keys",
  "Scopes": "Bereiche",
  "Delete this key?": "Diesen Key löschen?",
  "Key deleted": "Schlüssel gelöscht",
  "last used": "zuletzt verwendet",
  "never used": "nie verwendet",
  "Team": "Team",
  "Workspace": "Workspace",
  "Invite teammates with roles. Owner sees everything; manager/admin can edit; viewer is read-only.": "Lade Teammitglieder mit Rollen ein. Owner sieht alles; Manager/Admin können bearbeiten; Viewer hat nur Lesezugriff.",
  "Invite member": "Mitglied einladen",
  "Invite": "Einladen",
  "Invite sent": "Einladung gesendet",
  "Share this link with the invitee:": "Teile diesen Link mit der eingeladenen Person:",
  "Role": "Rolle",
  "Members": "Mitglieder",
  "Revoke access?": "Zugriff entziehen?",
  "Revoke access": "Zugriff entziehen",
  "Access revoked": "Zugriff entzogen",
  "Reset 2FA": "2FA zurücksetzen",
  "Reset this member's 2FA?": "2FA dieses Mitglieds zurücksetzen?",
  "2FA reset — member can re-enrol": "2FA zurückgesetzt — Mitglied kann sich neu registrieren",
  "Member had no 2FA configured": "Mitglied hatte keine 2FA konfiguriert",
  "2FA reset failed": "2FA-Zurücksetzung fehlgeschlagen",
  "Workspace currency": "Workspace-Währung",
  "Display currency": "Anzeigewährung",
  "Reports and dashboards will be normalised to this currency. FX rates are refreshed hourly.": "Reports und Dashboards werden auf diese Währung normalisiert. Wechselkurse werden stündlich aktualisiert.",
  "Workspace currency saved": "Workspace-Währung gespeichert",
  "Could not save currency": "Währung konnte nicht gespeichert werden",
  "Invited": "Eingeladen",
  "Shared with me": "Mit mir geteilt",
  "No shared workspaces": "Keine geteilten Workspaces",
  "Audit log": "Audit-Log",
  "Workspace-scoped trail of privileged actions. Retained for 90 days.": "Workspace-bezogener Verlauf privilegierter Aktionen. Wird 90 Tage aufbewahrt.",
  "Target type": "Zieltyp",
  "Actor ID": "Actor ID",
  "Since": "Seit",
  "Until": "Bis",
  "Apply": "Anwenden",
  "Actor": "Actor",
  "Target": "Ziel",
  "Payload": "Payload",
  "IP": "IP",
  "Load more": "Mehr laden",
  "No audit entries match the current filters.": "Keine Audit-Einträge entsprechen den aktuellen Filtern.",
  "Failed to load audit log": "Audit-Log konnte nicht geladen werden",
  "CAPI DLQ": "CAPI DLQ",
  "CAPI dead-letter queue": "CAPI Dead-Letter-Queue",
  "Conversions that exhausted the retry budget. Replay re-attempts the forwarder; discard drops the entry permanently.": "Conversions, deren Retry-Budget aufgebraucht ist. Wiederholen versucht die Weiterleitung erneut; Verwerfen entfernt den Eintrag dauerhaft.",
  "Forwarder ID": "Forwarder ID",
  "Conversion ID": "Conversion ID",
  "Since (ISO)": "Seit (ISO)",
  "Until (ISO)": "Bis (ISO)",
  "Apply filters": "Filter anwenden",
  "No DLQ entries match these filters.": "Keine DLQ-Einträge entsprechen diesen Filtern.",
  "Forwarder": "Forwarder",
  "Attempts": "Versuche",
  "Last error": "Letzter Fehler",
  "Replay": "Wiederholen",
  "Discard": "Verwerfen",
  "CAPI replay succeeded": "CAPI-Wiederholung erfolgreich",
  "Replay failed:": "Wiederholung fehlgeschlagen:",
  "Replay failed": "Wiederholung fehlgeschlagen",
  "DLQ entry discarded": "DLQ-Eintrag verworfen",
  "Discard failed": "Verwerfen fehlgeschlagen",
  "Permanently discard this DLQ entry?": "Diesen DLQ-Eintrag dauerhaft verwerfen?",
  "Failed to load CAPI DLQ": "CAPI DLQ konnte nicht geladen werden",
  "Activated {n}": "Aktiviert {n}",
  "Paused {n}": "Pausiert {n}",
  "Deleted {n}": "Gelöscht {n}",
  "Skipped {n} (no access or not found)": "{n} übersprungen (kein Zugriff oder nicht gefunden)",
  "Bulk update failed": "Massenaktualisierung fehlgeschlagen",
  "Bulk delete failed": "Massenlöschung fehlgeschlagen",
  "System health": "Systemzustand",
  "System status": "Systemstatus",
  "S2S log": "S2S-Log",
  "TLS fingerprints": "TLS-Fingerprints",
  "Aggregated CAPI / postback / FX / cost-sync state across the workspaces you administer.": "Aggregierter CAPI-/Postback-/FX-/Kostensynchronisations-Status über alle Workspaces, die du verwaltest.",
  "CAPI delivery": "CAPI-Zustellung",
  "Conversion API dispatches in the last window.": "Conversion-API-Übertragungen im letzten Zeitfenster.",
  "Total": "Gesamt",
  "Success rate": "Erfolgsquote",
  "No CAPI events in window.": "Keine CAPI-Events im Zeitfenster.",
  "Retry queue": "Wiederholungswarteschlange",
  "Pending CAPI re-attempts.": "Ausstehende CAPI-Wiederholungsversuche.",
  "Due now": "Jetzt fällig",
  "Oldest": "Älteste",
  "Dead-letter queue": "Dead-Letter-Queue",
  "Conversions that exhausted the retry budget.": "Conversions, deren Retry-Budget aufgebraucht ist.",
  "Postback delivery": "Postback-Zustellung",
  "S2S postback callouts in the last window.": "S2S-Postback-Aufrufe im letzten Zeitfenster.",
  "FX cache": "FX-Cache",
  "Per-base exchange-rate snapshot freshness.": "Aktualität des Snapshots der Wechselkurse pro Basis.",
  "Base": "Basis",
  "Refreshed": "Aktualisiert",
  "FX cache is empty.": "Der FX-Cache ist leer.",
  "stale": "veraltet",
  "fresh": "aktuell",
  "Ad cost sync": "Werbekosten-Sync",
  "Active connections, last sync time, and recent errors.": "Aktive Verbindungen, letzte Synchronisierung und aktuelle Fehler.",
  "No active ad-cost connections.": "Keine aktiven Werbekosten-Verbindungen.",
  "error": "Fehler",
  "ok": "ok",
  "Generated at": "Erstellt am",
  "Window": "Fenster",
  "Failed to load admin health": "Admin-Status konnte nicht geladen werden",
  "Export CSV": "CSV exportieren",
  "Audit log exported": "Audit-Log exportiert",
  "Audit export failed": "Audit-Export fehlgeschlagen",
  "Billing": "Abrechnung",
  "Plans & usage": "Pläne & Nutzung",
  "Current plan": "Aktueller Tarif",
  "Current": "Aktuell",
  "Clicks this month": "Klicks diesen Monat",
  "Plans & billing": "Pläne & Abrechnung",
  "Five editions: every plan includes the full tracker — pick your team size, domain scale and automation surface. Clicks are never limited.": "Fünf Editionen: Jeder Plan enthält den vollständigen Tracker — wähle Teamgröße, Domain-Skalierung und Automatisierungsumfang. Klicks werden nie limitiert.",
  "Billing is not activated on this server yet — all features are open. Plans below show what will apply once payments go live.": "Die Abrechnung ist auf diesem Server noch nicht aktiviert — alle Funktionen sind freigeschaltet. Die Pläne unten zeigen, was gilt, sobald Zahlungen live gehen.",
  "Trial": "Testphase",
  "day(s) left": "Tag(e) verbleibend",
  "choose a plan to keep your traffic flowing without interruption.": "wähle einen Plan, damit dein Traffic ohne Unterbrechung weiterläuft.",
  "Your subscription is inactive: click processing and entity creation are paused. Choose a plan to resume instantly.": "Dein Abo ist inaktiv: Click-Verarbeitung und Entitäten-Erstellung sind pausiert. Wähle einen Plan, um sofort fortzusetzen.",
  "Last payment failed — the tracker keeps working while Stripe retries. Update your card in Manage billing.": "Die letzte Zahlung ist fehlgeschlagen — der Tracker läuft weiter, während Stripe es erneut versucht. Aktualisiere deine Karte unter Abrechnung verwalten.",
  "cancels at period end": "endet am Periodenende",
  "unlimited": "unbegrenzt",
  "months": "Monate",
  "month": "Monat",
  "billed every": "Abrechnung alle",
  "user(s)": "Nutzer",
  "domain(s)": "Domain(s)",
  "Choose plan": "Plan wählen",
  "Full tracker core": "Vollständiger Tracker-Kern",
  "Unlimited clicks": "Unbegrenzte Klicks",
  "Landing page editor": "Landingpage-Editor",
  "Online support": "Online-Support",
  "Click API + API keys": "Click API + API-Schlüssel",
  "Facebook CAPI": "Facebook CAPI",
  "All 9 CAPI providers": "Alle 9 CAPI-Anbieter",
  "Report by conversion date": "Bericht nach Conversion-Datum",
  "White label branding": "White-Label-Branding",
  "Personal manager": "Persönlicher Manager",
  "Priority support": "Priorisierter Support",
  "Onboarding call": "Onboarding-Call",
  "trialing": "in Testphase",
  "active": "aktiv",
  "past_due": "überfällig",
  "expired": "abgelaufen",
  "canceled": "gekündigt",
  "exempt": "befreit",
  "Manage billing": "Abrechnung verwalten",
  "Manage": "Verwalten",
  "Upgrade": "Upgrade",
  "Free forever": "Für immer kostenlos",
  "clicks/mo": "Klicks/Monat",
  "campaigns": "Kampagnen",
  "team members": "Teammitglieder",
  "Campaign parameters": "Kampagnenparameter",
  "Declare the URL parameters you pass through ad networks. Each row becomes a macro like {key} available in postbacks and CAPI payloads.": "Lege die URL-Parameter fest, die du über Traffic-Quellen durchreichst. Jede Zeile wird zu einem Makro wie {key}, verfügbar in Postbacks und CAPI-Payloads.",
  "URL key": "URL-Schlüssel",
  "Placeholder / default": "Placeholder / Standardwert",
  "Google Ads tag": "Google-Ads-Tag",
  "No parameters yet": "Noch keine Parameter",
  "Parameters have unsaved changes — clicks keep using the saved set until you save.": "Die Parameter haben ungespeicherte Änderungen — Klicks verwenden weiterhin den gespeicherten Stand, bis du speicherst.",
  "Value written into the tracking link for this key: an ad-network macro such as {campaignid}, or a fixed value such as MCLV. A fixed value is also stored on clicks that arrive without the key; a macro in braces is not. Leave empty for keys the ad sets per account, such as tm and tml.": "Wert, der für diesen Schlüssel in den Tracking-Link geschrieben wird: eine Ad-Network-Macro wie {campaignid} oder ein fester Wert wie MCLV. Ein fester Wert wird auch bei Klicks gespeichert, die ohne den Schlüssel ankommen; eine Macro in geschweiften Klammern nicht. Lass das Feld leer für Schlüssel, die die Anzeige pro Konto festlegt, wie tm und tml.",
  "Macro: filled by the ad network, not stored on clicks without this key": "Macro: wird von der Traffic-Quelle gefüllt, wird bei Klicks ohne diesen Schlüssel nicht gespeichert",
  "Google Ads conversion keys": "Google-Ads-Conversion-Schlüssel",
  "Break down clicks and conversions by sub1–sub30 or any parameter declared in a campaign": "Klicks und Conversions nach sub1–sub30 oder einem beliebigen in einer Kampagne deklarierten Parameter aufschlüsseln",
  "Sub slot": "Sub-Slot",
  "Optional: the value is also stored as sub1…sub30 or a named field (external_id, creative_id…). Map the same thing to the same slot in every campaign (e.g. team -> sub8) and one report column and the {sub_id_8} macro cover all buyers; external_id feeds {external_id} in the source postback.": "Optional: Der Wert wird außerdem als sub1…sub30 oder als benanntes Feld (external_id, creative_id…) gespeichert. Ordne dasselbe in jeder Kampagne demselben Slot zu (z. B. team -> sub8), dann decken eine Report-Spalte und das {sub_id_8}-Makro alle Buyer ab; external_id speist {external_id} im Postback der Traffic-Quelle.",
  "Source postback": "Postback der Traffic-Quelle",
  "This source postback is already added": "Dieses Postback der Traffic-Quelle wurde bereits hinzugefügt",
  "Source postback added — check its placeholders (REPLACE, XXXX…) and press Save": "Postback der Traffic-Quelle hinzugefügt – prüfe die Platzhalter (REPLACE, XXXX…) und klicke auf Speichern",
  "Sale also fires for deposits (ftd, dep, deposit) and Lead also for registrations (reg, signup), whatever the broker calls them.": "Sale wird auch bei Einzahlungen (ftd, dep, deposit) ausgelöst und Lead auch bei Registrierungen (reg, signup), egal wie der Broker sie nennt.",
  "Keys without a default value (tm, tml, a…) are left out of the link: pass them in the ad, e.g. in the Google Ads Final URL suffix.": "Keys ohne Standardwert (tm, tml, a…) werden im Link weggelassen: übergib sie im Anzeigen-Setup, z. B. im Google Ads Final-URL-Suffix.",
  "= Submit Lead Form label — set this conversion as Primary. Fired from the visitor’s browser after a successful lead.": "= Label für Submit Lead Form – setze diese Conversion als Primary. Wird nach einem erfolgreichen Lead vom Browser des Besuchers ausgelöst.",
  "= Purchase / deposit label — set this conversion as Secondary. Sent by the \"Deposit → Purchase\" S2S rule; do not add an S2S rule for lead.": "= Label für Purchase/Deposit – setze diese Conversion als Secondary. Wird von der S2S-Regel \"Deposit → Purchase\" gesendet; lege keine eigene S2S-Regel für Lead an.",
  "Put both in the Final URL suffix of each Google Ads account (tml=AW-…/lead-label&tm=AW-…/purchase-label) and leave their default empty here.": "Trage beide in das Final-URL-Suffix jedes Google-Ads-Kontos ein (tml=AW-…/lead-label&tm=AW-…/purchase-label) und lass den Standardwert hier leer.",
  "Keys are case-sensitive. Any key (a, b, s, c…) is stored on the click, works as a {key} macro and can be picked as a grouping in Reports and Sub-ID reports, next to sub1…sub30. Map it to a sub slot to line it up across campaigns.": "Keys unterscheiden zwischen Groß- und Kleinschreibung. Jeder Key (a, b, s, c…) wird am Klick gespeichert, funktioniert als {key}-Makro und kann in Reports und Sub-ID-Reports als Gruppierung ausgewählt werden, neben sub1…sub30. Ordne ihn einem Sub-Slot zu, um ihn kampagnenübergreifend auszurichten.",
  "Use lowercase keys — the tracker does not read:": "Verwende Keys in Kleinbuchstaben – der Tracker liest nicht:",
  "Tracking URL preview": "Vorschau der Tracking-URL",
  "Paste this as Final URL (Google Ads) or tracking link (Facebook). Replace {key} placeholders with real ad-network macros as needed.": "Füge dies als Final URL (Google Ads) oder Tracking-Link (Facebook) ein. Ersetze die {key}-Platzhalter bei Bedarf durch echte Makros des Werbenetzwerks.",
  "Fire Google Ads gtag on redirect": "Google Ads gtag bei Weiterleitung auslösen",
  "When on, /r/ returns a tiny HTML page that calls gtag(\"event\",\"conversion\", …) with your simple-mode tag before redirecting. Use this if you do not configure the Final URL suffix on the Google Ads side.": "Wenn aktiviert, liefert /r/ vor der Weiterleitung eine kleine HTML-Seite aus, die gtag(\"event\",\"conversion\", …) mit deinem Simple-Mode-Tag aufruft. Nutze das, wenn du das Final-URL-Suffix nicht auf der Google-Ads-Seite konfigurierst.",
  "S2S postbacks": "S2S-Postbacks",
  "Outbound HTTP calls fired whenever a conversion postback is received. Supports macros like {click_id}, {payout}, and every campaign parameter declared above.": "Ausgehende HTTP-Aufrufe, die ausgelöst werden, sobald ein Conversion-Postback empfangen wird. Unterstützt Makros wie {click_id}, {payout} und alle oben angegebenen Kampagnenparameter.",
  "No postbacks yet": "Noch keine Postbacks",
  "Method": "Methode",
  "Statuses": "Status",
  "Add postback": "Postback hinzufügen",
  "Show recent log": "Aktuelles Log anzeigen",
  "Available macros": "Verfügbare Makros",
  "Campaign saved": "Kampagne gespeichert",
  "Postback fired": "Postback ausgelöst",
  "Mode": "Modus",
  "Simple": "Einfach",
  "Advanced": "Erweitert",
  "Conversion tag": "Conversion-Tag",
  "Conversion tag is required": "Conversion-Tag ist erforderlich",
  "Paste the \"send_to\" value from your Google Ads conversion snippet (e.g. AW-123456789/AbCdEf). No OAuth needed. The tracker stores it and fires it via Final URL suffix or on-redirect gtag.": "Füge den \"send_to\"-Wert aus deinem Google Ads Conversion-Snippet ein (z. B. AW-123456789/AbCdEf). Kein OAuth nötig. Der Tracker speichert ihn und löst ihn über das Final-URL-Suffix oder per gtag bei der Weiterleitung aus.",
  "OAuth-based Click Conversions Upload — requires developer token, customer ID and a refresh token. Use only if you need server-side uploads with gclid.": "OAuth-basierter Click-Conversions-Upload — erfordert Developer Token, Customer ID und einen Refresh Token. Nur verwenden, wenn du serverseitige Uploads mit gclid benötigst.",
  "Campaign": "Kampagne",
  "Create a new xpnsr.tech account": "Neues xpnsr.tech-Konto erstellen",
  "Already have an account? Sign in": "Du hast schon ein Konto? Anmelden",
  "Only ZIP files are supported": "Nur ZIP-Dateien werden unterstützt",
  "Please enter a name for the landing page": "Bitte gib einen Namen für die Landingpage ein",
  "Please select a ZIP file": "Bitte wähle eine ZIP-Datei aus",
  "Landing page uploaded successfully": "Landingpage erfolgreich hochgeladen",
  "Error uploading landing page": "Fehler beim Hochladen der Landingpage",
  "Upload ZIP": "ZIP hochladen",
  "Upload Landing Page": "Landingpage hochladen",
  "Upload a ZIP file containing your landing page files (max 50MB)": "Lade eine ZIP-Datei mit deinen Landingpage-Dateien hoch (max. 50 MB)",
  "My landing page": "Meine Landingpage",
  "tag1, tag2, tag3": "Tag1, Tag2, Tag3",
  "Separate tags with commas": "Tags durch Kommas trennen",
  "ZIP File": "ZIP-Datei",
  "Drag & drop or click to select": "Ziehen & ablegen oder zum Auswählen klicken",
  "Select ZIP File": "ZIP-Datei auswählen",
  "Uploading...": "Wird hochgeladen...",
  "Upload": "Hochladen",
  "History": "Verlauf",
  "Notification settings": "Benachrichtigungseinstellungen",
  "Please fill in name and select ZIP file": "Bitte gib einen Namen ein und wähle eine ZIP-Datei aus",
  "Offer uploaded successfully": "Offer erfolgreich hochgeladen",
  "Error uploading offer": "Fehler beim Hochladen des Offers",
  "Upload Offer ZIP": "Offer-ZIP hochladen",
  "Upload a ZIP file containing offer files": "Lade eine ZIP-Datei mit Offer-Dateien hoch",
  "Countries (comma-separated ISO codes, e.g. US,RU,DE)": "Länder (kommagetrennte ISO-Codes, z. B. US,RU,DE)",
  "ZIP File (max 100MB)": "ZIP-Datei (max. 100 MB)",
  "Change": "Ändern",
  "Select ZIP file": "ZIP-Datei auswählen",
  "Upload a ZIP file containing HTML pages, images, and other assets. Supported: _preview.png for preview, PHP scripts for processing.": "Lade eine ZIP-Datei mit HTML-Seiten, Bildern und anderen Assets hoch. Unterstützt: _preview.png für die Vorschau, PHP-Skripte zur Verarbeitung.",
  "Upload Offer": "Offer hochladen",
  "pages": "Seiten",
  "Choose entry point": "Einstiegspunkt wählen",
  "Multiple HTML pages detected. Select the main page visitors will land on.": "Mehrere HTML-Seiten erkannt. Wähle die Hauptseite, auf der Besucher landen sollen.",
  "Skip (use auto-detected)": "Überspringen (automatisch erkannte verwenden)",
  "Confirm": "Bestätigen",
  "Edit files": "Dateien bearbeiten",
  "File editor": "Dateieditor",
  "Edit HTML, CSS, JS and other text files inside the uploaded archive": "Bearbeite HTML-, CSS-, JS- und andere Textdateien innerhalb des hochgeladenen Archivs",
  "Files": "Dateien",
  "Select a file from the sidebar to edit": "Wähle eine Datei aus der Seitenleiste, um sie zu bearbeiten",
  "Binary file — not editable": "Binärdatei — nicht bearbeitbar",
  "File saved": "Datei gespeichert",
  "Error loading files": "Fehler beim Laden der Dateien",
  "Error loading file": "Fehler beim Laden der Datei",
  "Error saving file": "Fehler beim Speichern der Datei",
  "Discard unsaved changes?": "Ungespeicherte Änderungen verwerfen?",
  "Saving...": "Wird gespeichert...",
  "Bulk create": "Massenanlage",
  "Bulk create Google Ads forwarders": "Google-Ads-Forwarder im Bulk erstellen",
  "Conversion tags (one per line)": "Conversion-Tags (eins pro Zeile)",
  "Paste AW-XXX/YYY tags, one per line. Each creates a separate forwarder.": "Füge AW-XXX/YYY-Tags ein, eins pro Zeile. Jedes erstellt einen eigenen Forwarder.",
  "Bind to campaigns": "An Kampagnen binden",
  "Leave empty to fire on all campaigns": "Leer lassen, um bei allen Kampagnen auszulösen",
  "Add campaign…": "Kampagne hinzufügen…",
  "Create all": "Alle erstellen",
  "Creating…": "Wird erstellt…",
  "{count} forwarders created": "{count} Forwarder erstellt",
  "campaign": "Kampagne",
  "Linked forwarders": "Verknüpfte Forwarder",
  "Conversion forwarders that fire for this campaign": "Conversion-Forwarder, die für diese Kampagne ausgelöst werden",
  "Heatmap": "Heatmap",
  "Funnel": "Funnel",
  "Activity heatmap": "Aktivitäts-Heatmap",
  "Day-of-week x hour-of-day breakdown": "Aufschlüsselung nach Wochentag x Tageszeit",
  "Less": "Weniger",
  "More": "Mehr",
  "Peak": "Spitzenwert",
  "No heatmap data": "Keine Heatmap-Daten",
  "Conversion funnel": "Conversion-Funnel",
  "Click-to-conversion pipeline with status breakdown": "Click-to-Conversion-Pipeline mit Status-Aufschlüsselung",
  "Status breakdown": "Aufschlüsselung nach Status",
  "No funnel data": "Keine Funnel-Daten",
  "Mon": "Mon",
  "Tue": "Tue",
  "Wed": "Wed",
  "Thu": "Thu",
  "Fri": "Fri",
  "Sat": "Sat",
  "Sun": "Sun",
  "Ad-Account Connections": "Ad-Account-Verbindungen",
  "Connect FB / Google Ads accounts so cost data is pulled into campaigns automatically.": "Verbinde FB-/Google-Ads-Konten, damit Kostendaten automatisch in Kampagnen übernommen werden.",
  "Connect with Facebook": "Mit Facebook verbinden",
  "Connect with Google Ads": "Mit Google Ads verbinden",
  "Ad account connected via OAuth": "Werbekonto über OAuth verbunden",
  "OAuth error: ": "OAuth-Fehler: ",
  "Failed to start OAuth": "OAuth konnte nicht gestartet werden",
  "Token refreshed": "Token erneuert",
  "Refresh failed": "Erneuerung fehlgeschlagen",
  "Refresh token": "Token erneuern",
  "Connect ad account": "Werbekonto verbinden",
  "Tokens are encrypted at rest. Use OAuth buttons above for FB / Google, or enter tokens manually below.": "Tokens werden verschlüsselt gespeichert. Nutze die OAuth-Buttons oben für FB / Google, oder gib Tokens unten manuell ein.",
  "Sync now": "Jetzt synchronisieren",
  "Connect": "Verbinden",
  "Failed to load connections": "Verbindungen konnten nicht geladen werden",
  "Connection created": "Verbindung erstellt",
  "Connection deleted": "Verbindung gelöscht",
  "Delete this connection?": "Diese Verbindung löschen?",
  "Delete failed": "Löschen fehlgeschlagen",
  "Sync complete": "Synchronisierung abgeschlossen",
  "Sync failed": "Synchronisierung fehlgeschlagen",
  "No connections yet. Connect FB or Google Ads to start importing cost.": "Noch keine Verbindungen. Verbinde FB oder Google Ads, um mit dem Kostenimport zu starten.",
  "Refresh token (optional)": "Refresh-Token (optional)",
  "Display name": "Anzeigename",
  "Account ID": "Account ID",
  "Access token": "Zugriffstoken",
  "Save failed": "Speichern fehlgeschlagen",
  "Permissions": "Berechtigungen",
  "Permission matrix": "Berechtigungsmatrix",
  "Permission matrix saved": "Berechtigungsmatrix gespeichert",
  "Failed to load permission matrix": "Berechtigungsmatrix konnte nicht geladen werden",
  "Failed to save permission matrix": "Berechtigungsmatrix konnte nicht gespeichert werden",
  "Override the minimum role required for each action in this workspace. Only cells that differ from the default are persisted.": "Überschreibe die Mindestrolle für jede Aktion in diesem Workspace. Nur Zellen, die vom Standard abweichen, werden gespeichert.",
  "overrides": "Überschreibungen",
  "Read-only — only the workspace owner can edit the matrix.": "Nur lesbar — nur der Workspace-Owner kann die Matrix bearbeiten.",
  "Reset all to defaults": "Alles auf Standard zurücksetzen",
  "Custom": "Benutzerdefiniert",
  "Reset to default": "Auf Standard zurücksetzen",
  "owner": "owner",
  "admin": "admin",
  "manager": "manager",
  "viewer": "viewer",
  "Landings & offers": "Landingpages & Offers",
  "Reports": "Berichte",
  "Audit": "Audit",
  "Toggle navigation hints": "Navigationshinweise ein-/ausblenden",
  "Show hints": "Hinweise anzeigen",
  "Hide hints": "Hinweise ausblenden",
  "Tools": "Tools",
  "Admin": "Admin",
  "Resources": "Ressourcen",
  "Pre-landings": "Prelander",
  "Book demo": "Demo buchen",
  "Overview of clicks, conversions and active campaigns": "Überblick über Klicks, Conversions und aktive Kampagnen",
  "Create ad campaigns and get tracking links": "Erstelle Werbekampagnen und erhalte Tracking-Links",
  "Upload landing pages (ZIP) or set a URL for split-tests": "Lade Landingpages (ZIP) hoch oder gib eine URL für Split-Tests an",
  "Warm-up pages shown before the offer": "Prelander, die vor dem Offer angezeigt werden",
  "Connect Facebook, Google, TikTok ad accounts": "Verbinde Facebook-, Google-, TikTok-Werbekonten",
  "Two-factor auth, sessions and password": "Zwei-Faktor-Authentifizierung, Sitzungen und Passwort",
  "Uploaded offers/funnels + API routing to partners (weights, failover) + lead forms": "Hochgeladene Offers/Funnels + API-Routing zu Partnern (Gewichtung, Failover) + Lead-Formulare",
  "Traffic sources with presets (Google Ads with tm & macros, etc.)": "Traffic-Quellen mit Vorlagen (Google Ads mit tm & Makros usw.)",
  "Manage flows and traffic distribution rules": "Verwalte Flows und Regeln zur Traffic-Verteilung",
  "Split-test landings and offers with auto-distribution": "Split-Tests für Landingpages und Offers mit automatischer Verteilung",
  "Block bots, fraud and suspicious clicks": "Blockiere Bots, Betrug und verdächtige Klicks",
  "Detailed reports: charts, geo, devices, ROI": "Detaillierte Berichte: Diagramme, GEO, Geräte, ROI",
  "Full click log with IP, UserAgent, GEO and time": "Vollständiges Click-Log mit IP, UserAgent, GEO und Uhrzeit",
  "Auto-rules: pause campaigns on low ROI, etc.": "Auto-Regeln: Kampagnen bei niedrigem ROI pausieren usw.",
  "Partner CRMs (TrackBox, Custom API) for API lead injection + notifications": "Partner-CRMs (TrackBox, Custom API) für API-Lead-Übertragung + Benachrichtigungen",
  "Add your own domains for tracking links": "Füge eigene Domains für Tracking-Links hinzu",
  "Online conversions to Google/FB/TikTok (S2S). Google — simple, no OAuth": "Online-Conversions an Google/FB/TikTok (S2S). Google — einfacher Modus, ohne OAuth",
  "Keys to access the tracker REST API": "Keys für den Zugriff auf die REST API des Trackers",
  "Invite your team, assign roles and permissions": "Lade dein Team ein, vergib Rollen und Berechtigungen",
  "Action log of all users for 90 days": "Aktionsprotokoll aller Nutzer für 90 Tage",
  "Cookie consent banner for GDPR compliance": "Cookie-Consent-Banner für DSGVO-Konformität",
  "Ready-made templates and integrations": "Fertige Vorlagen und Integrationen",
  "Swagger REST API docs (opens in new tab)": "Swagger-REST-API-Dokumentation (öffnet in neuem Tab)",
  "Failed conversion dispatches — can be retried": "Fehlgeschlagene Conversion-Übertragungen — können erneut versucht werden",
  "Server, queue and database status": "Status von Servern, Queues und Datenbanken",
  "Plan, payment and usage limits": "Plan, Zahlung und Nutzungslimits",
  "Profile, language, timezone and notifications": "Profil, Sprache, Zeitzone und Benachrichtigungen",
  "(no label)": "(keine Bezeichnung)",
  "180 days": "180 Tage",
  "2FA disabled": "2FA deaktiviert",
  "2FA enabled": "2FA aktiviert",
  "2FA is currently enabled": "2FA ist derzeit aktiviert",
  "302 redirect (default)": "302-Weiterleitung (Standard)",
  "365 days": "365 Tage",
  "A campaign groups your traffic sources and tracking links under one name.": "Eine Kampagne fasst deine Traffic-Quellen und Tracking-Links unter einem Namen zusammen.",
  "AI Optimizer": "KI-Optimierer",
  "Accept button label": "Text der Akzeptieren-Schaltfläche",
  "Accepted": "Akzeptiert",
  "Accepting invitation…": "Einladung wird angenommen…",
  "Action on trigger": "Aktion beim Auslösen",
  "Activate": "Aktivieren",
  "Activate 2FA": "2FA aktivieren",
  "Add a forwarder to push conversions to ad networks automatically.": "Füge einen Forwarder hinzu, um Conversions automatisch an Werbenetzwerke zu senden.",
  "Add forwarder": "Forwarder hinzufügen",
  "Add the CNAME record shown on the Domains page, then click verify.": "Füge den auf der Seite Domains angezeigten CNAME-Eintrag hinzu und klicke dann auf Verifizieren.",
  "Add vendor": "Anbieter hinzufügen",
  "Aggressive: blocks any click whose JA3/JA4 is missing or not yet classified. Tag corporate-proxy hashes first via Workspace Overrides.": "Aggressiv: blockiert jeden Klick, dessen JA3/JA4 fehlt oder noch nicht klassifiziert ist. Markiere Corporate-Proxy-Hashes zuerst über die Workspace-Overrides.",
  "Alert if ROI drops below this %": "Alarm, wenn der ROI unter diesen % fällt",
  "Algorithm": "Algorithmus",
  "All groups": "Alle Gruppen",
  "All statuses": "Alle Status",
  "Allowed metrics": "Erlaubte Metriken",
  "Always block these JA3 / JA4 hashes regardless of classification.": "Diese JA3-/JA4-Hashes immer blockieren, unabhängig von der Klassifizierung.",
  "Anonymous": "Anonym",
  "Any type": "Beliebiger Typ",
  "Anyone with this link will lose access to the shared dashboard immediately.": "Jeder mit diesem Link verliert sofort den Zugriff auf das geteilte Dashboard.",
  "Applied {n} weight changes": "{n} Gewichtungsänderungen angewendet",
  "Archive": "Archiv",
  "Archived": "Archiviert",
  "Auto": "Auto",
  "Auto-refresh every 30s": "Automatische Aktualisierung alle 30s",
  "Available on enterprise plans. Hides the \"Powered by xpnsr\" footer.": "Verfügbar in Enterprise-Plänen. Blendet den Footer \"Powered by xpnsr\" aus.",
  "Back to sign-in": "Zurück zur Anmeldung",
  "Backup codes (save now)": "Backup-Codes (jetzt speichern)",
  "Bangkok (UTC+7)": "Bangkok (UTC+7)",
  "Banned": "Gesperrt",
  "Banner copy": "Banner-Text",
  "Banner status": "Banner-Status",
  "Berlin (UTC+1)": "Berlin (UTC+1)",
  "Best cohort": "Beste Kohorte",
  "Block classification": "Klassifizierung blockieren",
  "Block fingerprints classified as bad": "Als schädlich eingestufte Fingerprints blockieren",
  "Block unknown fingerprints": "Unbekannte Fingerprints blockieren",
  "Block when the blended TLS+UA+IP risk score exceeds this threshold. Default 0.7.": "Blockieren, wenn der kombinierte TLS+UA+IP-Risikoscore diesen Schwellenwert überschreitet. Standard 0.7.",
  "Body": "Body",
  "Body (JSON)": "Body (JSON)",
  "Body copied to clipboard.": "Body in die Zwischenablage kopiert.",
  "Body must be valid JSON.": "Body muss gültiges JSON sein.",
  "Branding": "Branding",
  "Branding cleared": "Branding entfernt",
  "Branding saved": "Branding gespeichert",
  "Break down clicks and conversions by sub-ID parameters (sub1–sub15)": "Clicks und Conversions nach Sub-ID-Parametern aufschlüsseln (sub1–sub15)",
  "Browse and install community-contributed templates for postbacks, macros, anti-fraud rules, and pre-landings. Submissions auto-publish — the community self-polices via the delete action.": "Durchsuche und installiere von der Community beigesteuerte Templates für Postbacks, Makros, Anti-Fraud-Regeln und Pre-Landings. Einreichungen werden automatisch veröffentlicht — die Community reguliert sich selbst über die Löschfunktion.",
  "Browser": "Browser",
  "Build traffic rules, rotate landings and split-test offers for any campaign.": "Erstelle Traffic-Regeln, rotiere Landingpages und führe Split-Tests für Offers in jeder Kampagne durch.",
  "Bundle verified domains into a pool and rotate tracking links across them. Pull a banned domain out of rotation in one click without redeploying ad copies.": "Fasse verifizierte Domains in einem Pool zusammen und rotiere Tracking-Links über sie. Nimm eine gesperrte Domain mit einem Klick aus der Rotation, ohne die Anzeigentexte neu auszurollen.",
  "By browser": "Nach Browser",
  "By device": "Nach Gerät",
  "By {author}": "Von {author}",
  "CR %": "CR %",
  "CR%": "CR%",
  "Campaign ID": "Campaign ID",
  "Campaign activated": "Kampagne aktiviert",
  "Campaign archived": "Kampagne archiviert",
  "Campaign cloned successfully!": "Kampagne erfolgreich geklont!",
  "Campaign comparison": "Kampagnenvergleich",
  "Campaign created": "Kampagne erstellt",
  "Campaign dashboard": "Kampagnen-Dashboard",
  "Campaign restored": "Kampagne wiederhergestellt",
  "Cap": "Cap",
  "Cap timezone": "Cap-Zeitzone",
  "Catalog": "Katalog",
  "Chicago (UTC-6)": "Chicago (UTC-6)",
  "Choose a preset and optionally extend it with extra ISO-3166 country codes (comma-separated, e.g. BR, MX, AR).": "Wähle ein Preset und erweitere es optional mit zusätzlichen ISO-3166-Ländercodes (kommagetrennt, z. B. BR, MX, AR).",
  "Clear": "Leeren",
  "Click ID forward parameter": "Click-ID-Weiterleitungsparameter",
  "Click detail": "Klickdetails",
  "Click to activate": "Klicken zum Aktivieren",
  "Click to pause": "Klicken zum Pausieren",
  "Clicks log": "Klick-Log",
  "Clipboard unavailable — copy the URL manually": "Zwischenablage nicht verfügbar — kopiere die URL manuell",
  "Cloaked (iframe)": "Cloaked (iframe)",
  "Cloaked iframe keeps the tracker domain in the address bar — only works for destinations that allow framing.": "Das gecloakte iFrame behält die Tracker-Domain in der Adressleiste — funktioniert nur bei Zielen, die Framing erlauben.",
  "Clone": "Klonen",
  "Close navigation": "Navigation schließen",
  "Cohort": "Kohorte",
  "Cohort retention": "Kohortenbindung",
  "Comma-separated list of IPs allowed to send postbacks. Leave empty to allow all.": "Kommagetrennte Liste von IPs, die Postbacks senden dürfen. Leer lassen, um alle zuzulassen.",
  "Compare": "Vergleichen",
  "Compare current to proposed weights. Apply persists the proposed column to the streams.": "Vergleiche aktuelle mit vorgeschlagenen Gewichtungen. \"Anwenden\" speichert die vorgeschlagene Spalte dauerhaft in den Streams.",
  "Comparing…": "Wird verglichen…",
  "Compliance": "Compliance",
  "Configure UTM templates and conversion postbacks for every ad network you run.": "Konfiguriere UTM-Templates und Conversion-Postbacks für jedes von dir genutzte Werbenetzwerk.",
  "Configure offers, payouts and target geos. Upload ZIPs or link external networks.": "Konfiguriere Offers, Payouts und Ziel-GEOs. Lade ZIPs hoch oder verknüpfe externe Affiliate-Netzwerke.",
  "Configure stream": "Stream konfigurieren",
  "Configure the GDPR / CCPA cookie banner that runs on your tracker landing pages. The banner is region-aware — visitors outside the configured regions never see it.": "Konfiguriere das DSGVO- / CCPA-Cookie-Banner, das auf deinen Tracker-Landingpages läuft. Das Banner erkennt die Region — Besucher außerhalb der konfigurierten Regionen sehen es nie.",
  "Confirm action": "Aktion bestätigen",
  "Connect external services and webhooks": "Externe Dienste und Webhooks verbinden",
  "Connect external services and webhooks to automate workflows.": "Verbinde externe Dienste und Webhooks, um Workflows zu automatisieren.",
  "Connection restored": "Verbindung wiederhergestellt",
  "Connections": "Verbindungen",
  "Consent banner": "Consent-Banner",
  "Consent banner saved": "Consent-Banner gespeichert",
  "Conv": "Conv",
  "Conv.": "Conv.",
  "Conversion rate comparison": "Vergleich der Conversion-Rate",
  "Cookieless mode (skip xpnsr_vid first-party cookie)": "Cookieless-Modus (xpnsr_vid First-Party-Cookie überspringen)",
  "Copied to clipboard.": "In die Zwischenablage kopiert.",
  "Copy link (/r/)": "Link kopieren (/r/)",
  "Copy link (/{alias}/)": "Link kopieren (/{alias}/)",
  "Cost": "Kosten",
  "Cost value": "Kostenwert",
  "Could not accept invitation": "Einladung konnte nicht angenommen werden",
  "Could not copy — please copy the link manually.": "Kopieren fehlgeschlagen — bitte kopiere den Link manuell.",
  "Could not create public link": "Öffentlicher Link konnte nicht erstellt werden",
  "Could not load branding": "Branding konnte nicht geladen werden",
  "Could not load marketplace templates.": "Marketplace-Vorlagen konnten nicht geladen werden.",
  "Could not load template detail.": "Vorlagendetails konnten nicht geladen werden.",
  "Could not load the shared dashboard.": "Das geteilte Dashboard konnte nicht geladen werden.",
  "Could not reset branding": "Branding konnte nicht zurückgesetzt werden",
  "Could not save branding": "Branding konnte nicht gespeichert werden",
  "Country (ISO-2)": "Land (ISO-2)",
  "Create a campaign first": "Erstelle zuerst eine Kampagne",
  "Create key": "Schlüssel erstellen",
  "Create landing page": "Landingpage erstellen",
  "Create link": "Link erstellen",
  "Create new landing page": "Neue Landingpage erstellen",
  "Create new offer": "Neuen Offer erstellen",
  "Create offer": "Offer erstellen",
  "Create pool": "Pool erstellen",
  "Custom domain": "Eigene Domain",
  "Custom range": "Benutzerdefinierter Zeitraum",
  "Customise the dashboard for your agency or sub-account": "Passe das Dashboard für deine Agentur oder Subaccount an",
  "Daily cap": "Tages-Cap",
  "Dashboard hostname": "Dashboard-Hostname",
  "Decision": "Entscheidung",
  "Default offer URL": "Standard-Offer-URL",
  "Defense": "Schutz",
  "Delete A/B test": "A/B-Test löschen",
  "Delete API key": "API-Key löschen",
  "Delete automation rule": "Automatisierungsregel löschen",
  "Delete campaign": "Kampagne löschen",
  "Delete campaigns": "Kampagnen löschen",
  "Delete connection": "Verbindung löschen",
  "Delete domain": "Domain löschen",
  "Delete domain pool": "Domain-Pool löschen",
  "Delete failed.": "Löschen fehlgeschlagen.",
  "Delete forwarder": "Forwarder löschen",
  "Delete integration": "Integration löschen",
  "Delete landing page": "Landingpage löschen",
  "Delete offer": "Offer löschen",
  "Delete pre-landing": "Prelander löschen",
  "Delete stream": "Stream löschen",
  "Delete traffic source": "Traffic-Quelle löschen",
  "Delete webhook": "Webhook löschen",
  "Delete {n} selected campaign(s)? This cannot be undone.": "{n} ausgewählte Kampagne(n) löschen? Dies kann nicht rückgängig gemacht werden.",
  "Denver (UTC-7)": "Denver (UTC-7)",
  "Deselect all": "Auswahl aufheben",
  "Device": "Gerät",
  "Disable 2FA": "2FA deaktivieren",
  "Disable 2FA — enter a current code": "2FA deaktivieren — gib einen aktuellen Code ein",
  "Disable auto-refresh": "Auto-Aktualisierung deaktivieren",
  "Disable failed": "Deaktivieren fehlgeschlagen",
  "Disabled": "Deaktiviert",
  "Discard DLQ entry": "DLQ-Eintrag verwerfen",
  "Dismissed": "Verworfen",
  "Do not block by classification": "Nicht nach Klassifizierung blockieren",
  "Domain marked healthy": "Domain als gesund markiert",
  "Domain not verified yet — check the DNS record.": "Domain noch nicht verifiziert — überprüfe den DNS-Eintrag.",
  "Domain pool created": "Domain-Pool erstellt",
  "Domain pool deleted": "Domain-Pool gelöscht",
  "Domain pools": "Domain-Pools",
  "Domain pulled from rotation": "Domain aus der Rotation entfernt",
  "Domain registered. Add the DNS record, then verify.": "Domain registriert. Füge den DNS-Eintrag hinzu und verifiziere anschließend.",
  "Done": "Fertig",
  "Dubai (UTC+4)": "Dubai (UTC+4)",
  "EPC": "EPC",
  "Each row is a day's first-time visitors. Columns track cumulative conversion rate by day-offset.": "Jede Zeile zeigt die Erstbesucher eines Tages. Die Spalten verfolgen die kumulative Conversion-Rate nach Tagesversatz.",
  "Earnings per click": "Earnings per Click",
  "Edit pre-landing": "Prelander bearbeiten",
  "Enable 2FA": "2FA aktivieren",
  "Enabled": "Aktiviert",
  "Enter a code from the app to confirm": "Gib zur Bestätigung einen Code aus der App ein",
  "Enter a hostname": "Gib einen Hostnamen ein",
  "Enter an offer URL": "Gib eine Offer-URL ein",
  "Enter the 6-digit code from your authenticator app, or one of your backup codes.": "Gib den 6-stelligen Code aus deiner Authenticator-App ein oder einen deiner Backup-Codes.",
  "Epsilon (ε)": "Epsilon (ε)",
  "Error archiving campaign": "Fehler beim Archivieren der Kampagne",
  "Error cloning campaign": "Fehler beim Klonen der Kampagne",
  "Expires": "Läuft ab",
  "Expires after (days)": "Läuft ab nach (Tagen)",
  "Explicit blocked fingerprints (comma-separated)": "Explizit blockierte Fingerprints (kommagetrennt)",
  "Export JSON": "Export JSON",
  "Export XLSX": "XLSX exportieren",
  "Extra countries (ISO-3166 alpha-2)": "Zusätzliche Länder (ISO-3166 alpha-2)",
  "Failed to accept invite": "Einladung konnte nicht angenommen werden",
  "Failed to apply optimization": "Optimierung konnte nicht angewendet werden",
  "Failed to compare": "Vergleich fehlgeschlagen",
  "Failed to copy tracking link": "Tracking-Link konnte nicht kopiert werden",
  "Failed to create campaign": "Kampagne konnte nicht erstellt werden",
  "Failed to create pool": "Pool konnte nicht erstellt werden",
  "Failed to delete key": "Schlüssel konnte nicht gelöscht werden",
  "Failed to load campaigns": "Kampagnen konnten nicht geladen werden",
  "Failed to load clicks log": "Klick-Log konnte nicht geladen werden",
  "Failed to load consent config": "Consent-Konfiguration konnte nicht geladen werden",
  "Failed to load conversions": "Conversions konnten nicht geladen werden",
  "Failed to load pre-landings": "Prelander konnten nicht geladen werden",
  "Failed to load profile": "Profil konnte nicht geladen werden",
  "Failed to load sub-ID report": "Sub-ID-Report konnte nicht geladen werden",
  "Failed to preview optimization": "Optimierungsvorschau fehlgeschlagen",
  "Failed to register domain": "Domain konnte nicht registriert werden",
  "Failed to revoke access": "Zugriff konnte nicht entzogen werden",
  "Failed to save": "Speichern fehlgeschlagen",
  "Failed to update status": "Status konnte nicht aktualisiert werden",
  "Fallback offer": "Ersatz-Offer",
  "Filter junk traffic, block malicious IPs and review suspicious activity in one place.": "Filtere Junk-Traffic, blockiere schädliche IPs und prüfe verdächtige Aktivitäten an einem Ort.",
  "From (ISO-8601)": "Von (ISO-8601)",
  "GDPR: pseudonymize visitor IPs (hash before storage)": "DSGVO: Besucher-IPs pseudonymisieren (Hash vor dem Speichern)",
  "Generate a key to call the public REST API.": "Generiere einen Key, um die öffentliche REST-API aufzurufen.",
  "Go back": "Zurück",
  "Go to Workspace": "Zum Workspace",
  "Group (optional)": "Gruppe (optional)",
  "Group by:": "Gruppieren nach:",
  "Healthy": "Fehlerfrei",
  "Hide xpnsr branding": "XPNSR-Branding ausblenden",
  "Hosted pages and uploads": "Gehostete Seiten und Uploads",
  "Hostname": "Hostname",
  "Install": "Installieren",
  "Install failed.": "Installation fehlgeschlagen.",
  "Invalid 2FA code": "Ungültiger 2FA-Code",
  "Invalid SSO session": "Ungültige SSO-Sitzung",
  "Invitation accepted!": "Einladung angenommen!",
  "JS redirect (location.replace)": "JS-Redirect (location.replace)",
  "Keyboard shortcuts": "Tastenkürzel",
  "Keyboard shortcuts (?)": "Tastenkürzel (?)",
  "Keyword exclude": "Keyword ausschließen",
  "Keyword include": "Keyword einschließen",
  "Label (operator-only)": "Bezeichnung (nur Betreiber)",
  "Last 200 consent records in this workspace. Used as the audit trail for DSAR / regulator inquiries.": "Die letzten 200 Consent-Einträge in diesem Workspace. Dienen als Audit-Trail für DSAR-/Behördenanfragen.",
  "Last viewed": "Zuletzt angesehen",
  "Layout": "Layout",
  "Layout & retention": "Layout und Aufbewahrung",
  "Live": "Live",
  "Live KPIs and breakdowns across campaigns, geos, devices.": "Live-KPIs und Auswertungen nach Kampagnen, GEOs und Geräten.",
  "Loading marketplace…": "Marketplace wird geladen…",
  "Loading...": "Laden...",
  "Login page subtitle": "Untertitel der Anmeldeseite",
  "Logo URL": "Logo URL",
  "London (UTC+0)": "London (UTC+0)",
  "Lookback (days)": "Rückblick (Tage)",
  "Los Angeles (UTC-8)": "Los Angeles (UTC-8)",
  "Make sure your tracking URLs include {key}=... parameter": "Stelle sicher, dass deine Tracking-URLs den Parameter {key}=... enthalten",
  "Manage profile, preferences, notifications and system configuration.": "Verwalte Profil, Einstellungen, Benachrichtigungen und Systemkonfiguration.",
  "Manage your offers and creatives": "Verwalte deine Offers und Creatives",
  "Manual entry secret": "Secret für manuelle Eingabe",
  "Mark all read": "Alle als gelesen markieren",
  "Mark read": "Als gelesen markieren",
  "Marketplace": "Marktplatz",
  "Match if referrer/params contain a keyword": "Trifft zu, wenn Referrer/Parameter ein Schlüsselwort enthalten",
  "Meta refresh": "Meta refresh",
  "Metric": "Metrik",
  "Min clicks per stream": "Min. Klicks pro Stream",
  "Minimum ROI (%)": "Mindest-ROI (%)",
  "Missing SSO session token": "SSO-Sitzungstoken fehlt",
  "Missing invite token": "Einladungstoken fehlt",
  "Most clicks": "Meiste Klicks",
  "Most revenue": "Höchster Umsatz",
  "Mumbai (UTC+5:30)": "Mumbai (UTC+5:30)",
  "Must be an https:// URL. Leave blank to fall back to the xpnsr logo.": "Muss eine https://-URL sein. Leer lassen, um auf das xpnsr-Logo zurückzugreifen.",
  "Name A→Z": "Name A→Z",
  "Name Z→A": "Name Z→A",
  "Name and target URL are required": "Name und Ziel-URL sind erforderlich",
  "Name is required.": "Name ist erforderlich.",
  "New": "Neu",
  "New pre-landing": "Neuer Prelander",
  "New public dashboard link": "Neuer öffentlicher Dashboard-Link",
  "Newest first": "Neueste zuerst",
  "Next": "Weiter",
  "No active streams to optimize.": "Keine aktiven Streams zu optimieren.",
  "No clicks match these filters.": "Keine Klicks entsprechen diesen Filtern.",
  "No cohort data": "Keine Kohortendaten",
  "No consent records yet.": "Noch keine Consent-Einträge.",
  "No conversions yet": "Noch keine Conversions",
  "No data found for {key}": "Keine Daten gefunden für {key}",
  "No data yet.": "Noch keine Daten.",
  "No description provided.": "Keine Beschreibung angegeben.",
  "No internet connection": "Keine Internetverbindung",
  "No notifications yet": "Noch keine Benachrichtigungen",
  "No performance data yet": "Noch keine Performance-Daten",
  "No pre-landings yet. Create one to start chaining traffic.": "Noch keine Prelander. Erstelle einen, um Traffic zu verketten.",
  "No public links yet. Create one to share read-only stats with advertisers.": "Noch keine öffentlichen Links. Erstelle einen, um schreibgeschützte Statistiken mit Advertisern zu teilen.",
  "No results.": "Keine Ergebnisse.",
  "No templates match these filters.": "Keine Vorlage entspricht diesen Filtern.",
  "No vendors disclosed.": "Keine Anbieter angegeben.",
  "No verified custom domains. Add one in Domains → Settings.": "Keine verifizierten eigenen Domains. Füge eine unter Domains → Einstellungen hinzu.",
  "None": "Keine",
  "Notify only": "Nur benachrichtigen",
  "Oldest first": "Älteste zuerst",
  "Onboarding complete!": "Onboarding abgeschlossen!",
  "Only match if referrer contains one of these": "Nur übereinstimmen, wenn der Referrer eines davon enthält",
  "Open Campaigns": "Kampagnen öffnen",
  "Open Domains page": "Domains-Seite öffnen",
  "Open command palette": "Befehlspalette öffnen",
  "Open landing pages": "Landingpages öffnen",
  "Open my tracking link": "Meinen Tracking-Link öffnen",
  "Operators host the static page; the tracker just routes clicks here first.": "Die Betreiber hosten die statische Seite; der Tracker leitet Klicks hier nur zuerst hin.",
  "Optimization": "Optimierung",
  "Optional": "Optional",
  "Pages library": "Seitenbibliothek",
  "Parameter name, e.g. sub1": "Parametername, z. B. sub1",
  "Pause": "Pausieren",
  "Performance": "Performance",
  "Performance overview": "Performance-Übersicht",
  "Permanently discard this dead-letter entry? This cannot be undone.": "Diesen Dead-Letter-Eintrag dauerhaft verwerfen? Das kann nicht rückgängig gemacht werden.",
  "Please sign in first, then open the invite link again.": "Bitte melde dich zuerst an und öffne dann den Einladungslink erneut.",
  "Please wait…": "Bitte warten…",
  "Point this hostname at the tracker via DNS. Visitors hitting it will see your branding before they sign in.": "Richte diesen Hostnamen per DNS auf den Tracker. Besucher, die ihn aufrufen, sehen dein Branding, bevor sie sich anmelden.",
  "Pool name": "Pool-Name",
  "Postback IP whitelist": "Postback-IP-Whitelist",
  "Pre-Landings": "Pre-Landings",
  "Pre-landing created": "Pre-Landing erstellt",
  "Pre-landing deleted": "Pre-Landing gelöscht",
  "Pre-landing updated": "Pre-Landing aktualisiert",
  "Pre-landings give you a faster, more compliant entry page before sending visitors to the offer. You can add one any time.": "Pre-Landings bieten dir eine schnellere, regelkonformere Einstiegsseite, bevor Besucher zum Offer weitergeleitet werden. Du kannst jederzeit eine hinzufügen.",
  "Preview": "Vorschau",
  "Previous": "Zurück",
  "Primary colour": "Primärfarbe",
  "Privacy policy URL": "URL der Datenschutzerklärung",
  "Products": "Produkte",
  "Proposed": "Vorgeschlagen",
  "Proposed drift": "Vorgeschlagener Drift",
  "Proposed weights": "Vorgeschlagene Gewichtungen",
  "Protect your account with a TOTP code from an authenticator app. Backup codes let you log in if you lose your device.": "Schütze dein Konto mit einem TOTP-Code aus einer Authenticator-App. Backup-Codes ermöglichen dir die Anmeldung, falls du dein Gerät verlierst.",
  "Public link created — copy it now, it won't be shown again.": "Öffentlicher Link erstellt — kopiere ihn jetzt, er wird nicht erneut angezeigt.",
  "Public link revoked.": "Öffentlicher Link widerrufen.",
  "Public read-only links": "Öffentliche Links mit Nur-Lese-Zugriff",
  "Publish": "Veröffentlichen",
  "Publishing…": "Wird veröffentlicht…",
  "Pull out of rotation": "Aus der Rotation nehmen",
  "Purpose (e.g. Analytics)": "Zweck (z. B. Analytics)",
  "Quick start from template": "Schnellstart aus Vorlage",
  "Quiz / review / bonus pages that intercept the click before the final landing or offer.": "Quiz-/Review-/Bonusseiten, die den Klick vor der finalen Landingpage oder dem Offer abfangen.",
  "ROI": "ROI",
  "ROI alert": "ROI-Warnung",
  "Random seed (optional)": "Zufalls-Seed (optional)",
  "Read-only public view — generated by xpnsr-tracker.": "Öffentliche Nur-Lese-Ansicht — generiert von xpnsr-tracker.",
  "Rebalance stream weights based on historical conversion rate using a multi-armed bandit.": "Gewichte der Streams anhand der historischen Conversion-Rate mit einem Multi-Armed Bandit neu ausbalancieren.",
  "Recent decisions": "Letzte Entscheidungen",
  "Record retention (days)": "Aufbewahrung der Datensätze (Tage)",
  "Redirect method": "Weiterleitungsmethode",
  "Redirect mode": "Weiterleitungsmodus",
  "Referrer / Keyword filters": "Referrer-/Keyword-Filter",
  "Referrer exclude": "Referrer ausschließen",
  "Referrer include": "Referrer einschließen",
  "Region preset": "Regions-Preset",
  "Region scope": "Regionsumfang",
  "Register a custom hostname so your tracking links resolve under your own brand.": "Registriere einen eigenen Hostnamen, damit deine Tracking-Links unter deiner eigenen Marke aufgelöst werden.",
  "Register hostname": "Hostname registrieren",
  "Reject button label": "Beschriftung des Ablehnen-Buttons",
  "Rejected": "Abgelehnt",
  "Remove": "Entfernen",
  "Remove template": "Vorlage entfernen",
  "Remove this template? This cannot be undone.": "Diese Vorlage entfernen? Das kann nicht rückgängig gemacht werden.",
  "Reset branding": "Branding zurücksetzen",
  "Reset to defaults": "Auf Standardwerte zurücksetzen",
  "Resetting…": "Wird zurückgesetzt…",
  "Restore": "Wiederherstellen",
  "Restore to rotation": "In Rotation zurückgeben",
  "Return on investment": "Return on Investment",
  "Rev.": "Ums.",
  "Revenue comparison": "Umsatzvergleich",
  "Revoke": "Widerrufen",
  "Revoke failed": "Widerrufen fehlgeschlagen",
  "Revoke public link": "Öffentlichen Link widerrufen",
  "Risk score threshold (0.0 – 1.0)": "Risikowert-Schwelle (0,0 – 1,0)",
  "Round robin": "Round Robin",
  "Routing": "Routing",
  "Row-level drill-down into incoming clicks: country, device, stream, and variant.": "Zeilengenaue Detailansicht der eingehenden Clicks: Land, Gerät, Stream und Variante.",
  "Run a preview to see proposed weights.": "Führe eine Vorschau aus, um die vorgeschlagenen Gewichtungen zu sehen.",
  "SSO failed": "SSO fehlgeschlagen",
  "SSO is not configured": "SSO ist nicht konfiguriert",
  "SSO sign-in failed": "SSO-Anmeldung fehlgeschlagen",
  "Save branding": "Branding speichern",
  "Scan the QR code with your authenticator app": "Scanne den QR-Code mit deiner Authenticator-App",
  "Search": "Suchen",
  "Search by name, description, or slug. Filter by type or tag.": "Suche nach Name, Beschreibung oder Slug. Filtere nach Typ oder Tag.",
  "Search…": "Suchen…",
  "Secondary colour": "Sekundärfarbe",
  "Select all": "Alle auswählen",
  "Select at least 2 campaigns": "Wähle mindestens 2 Kampagnen aus",
  "Select campaigns (2–10)": "Kampagnen auswählen (2–10)",
  "Sending…": "Wird gesendet…",
  "Set up rules, notifications and triggered actions for your campaigns.": "Richte Regeln, Benachrichtigungen und automatisierte Aktionen für deine Kampagnen ein.",
  "Set up your tracker": "Richte deinen Tracker ein",
  "Setup failed": "Einrichtung fehlgeschlagen",
  "Share a token-gated dashboard URL with advertisers without giving them an account.": "Teile eine durch Token geschützte Dashboard-URL mit Werbetreibenden, ohne ihnen ein Konto zu geben.",
  "Shareable URL": "Teilbare URL",
  "Shared dashboard": "Geteiltes Dashboard",
  "Side-by-side metrics for selected campaigns": "Metriken der ausgewählten Kampagnen im direkten Vergleich",
  "Sign in with Google": "Mit Google anmelden",
  "Sign in with Microsoft": "Mit Microsoft anmelden",
  "Singapore (UTC+8)": "Singapur (UTC+8)",
  "Size": "Größe",
  "Skip for now": "Vorerst überspringen",
  "Skip if referrer contains one of these": "Überspringen, wenn der Referrer einen dieser Begriffe enthält",
  "Skip if referrer/params contain a keyword": "Überspringen, wenn Referrer/Parameter ein Schlüsselwort enthalten",
  "Skip this step until you have a campaign — you can finish setup from the Campaigns page.": "Überspringe diesen Schritt, bis du eine Kampagne hast — du kannst die Einrichtung später über die Seite Kampagnen abschließen.",
  "Skipped (below min_clicks_per_stream)": "Übersprungen (unter min_clicks_per_stream)",
  "Smoothed CR": "Geglättete CR",
  "Sort by": "Sortieren nach",
  "Split traffic across variants to find what converts best.": "Verteile den Traffic auf Varianten, um herauszufinden, was am besten konvertiert.",
  "Step {step} of {total}": "Schritt {step} von {total}",
  "Sticky (per-visitor)": "Persistent (pro Besucher)",
  "Stream": "Stream",
  "Stream ID": "Stream-ID",
  "Stream configured": "Stream konfiguriert",
  "Streams decide which offer each visitor lands on. Configure your default stream and you\\'ll have a working tracking link.": "Streams entscheiden, auf welchem Offer jeder Besucher landet. Konfiguriere deinen Standard-Stream und du hast einen funktionierenden Tracking-Link.",
  "Sub-ID drill-down": "Sub-ID-Detailansicht",
  "Submission failed.": "Übermittlung fehlgeschlagen.",
  "Submissions auto-publish. The slug is derived from the name; if it collides with an existing template, a numeric suffix is appended.": "Einreichungen werden automatisch veröffentlicht. Der Slug wird aus dem Namen abgeleitet; falls er mit einer bestehenden Vorlage kollidiert, wird ein numerisches Suffix angehängt.",
  "Submit a template": "Vorlage einreichen",
  "Submit template": "Vorlage einreichen",
  "Sydney (UTC+11)": "Sydney (UTC+11)",
  "São Paulo (UTC-3)": "São Paulo (UTC-3)",
  "TLS fingerprint (JA3 / JA4)": "TLS-Fingerabdruck (JA3 / JA4)",
  "Tags (comma-separated)": "Tags (kommagetrennt)",
  "Tags:": "Tags:",
  "Template": "Vorlage",
  "Template body copied to clipboard.": "Vorlagentext in die Zwischenablage kopiert.",
  "Template installed. Body shown in detail dialog.": "Vorlage installiert. Der Text wird im Detaildialog angezeigt.",
  "Template marketplace": "Vorlagen-Marktplatz",
  "Template published as {slug}.": "Vorlage veröffentlicht als {slug}.",
  "Template removed.": "Vorlage entfernt.",
  "The token will only be shown once after creation — copy it immediately.": "Der Token wird nach der Erstellung nur einmal angezeigt — kopiere ihn sofort.",
  "Third-party processors disclosed to the visitor (max 50).": "Drittanbieter-Dienstleister, die dem Besucher offengelegt werden (max. 50).",
  "This link is unauthenticated. Anyone with it can view the selected metrics until it expires or is revoked.": "Dieser Link ist nicht authentifiziert. Jeder, der ihn hat, kann die ausgewählten Metriken einsehen, bis er abläuft oder widerrufen wird.",
  "This member will lose access to this workspace immediately.": "Dieses Mitglied verliert sofort den Zugriff auf diesen Workspace.",
  "This shared link has expired or been revoked.": "Dieser geteilte Link ist abgelaufen oder wurde widerrufen.",
  "This shared link is not valid.": "Dieser geteilte Link ist ungültig.",
  "This will permanently delete \"{name}\" and all associated clicks, conversions and postback events. This cannot be undone.": "Dadurch werden \"{name}\" und alle zugehörigen Klicks, Conversions und Postback-Events dauerhaft gelöscht. Dies kann nicht rückgängig gemacht werden.",
  "This will permanently delete \"{name}\" and all its variants.": "Dadurch werden \"{name}\" und alle Varianten dauerhaft gelöscht.",
  "This will permanently delete \"{name}\" and remove it from all campaigns.": "Dadurch wird \"{name}\" dauerhaft gelöscht und aus allen Kampagnen entfernt.",
  "This will permanently delete \"{name}\".": "Dadurch wird \"{name}\" dauerhaft gelöscht.",
  "This will permanently delete \"{name}\". Campaigns using this domain will fall back to the default domain.": "Dadurch wird \"{name}\" dauerhaft gelöscht. Kampagnen, die diese Domain nutzen, wechseln zur Standard-Domain.",
  "This will permanently delete \"{name}\". Campaigns using this source will lose their tracking parameters.": "Dadurch wird \"{name}\" dauerhaft gelöscht. Kampagnen, die diese Traffic-Quelle nutzen, verlieren ihre Tracking-Parameter.",
  "This will permanently delete pool \"{name}\".": "Dadurch wird der Pool \"{name}\" dauerhaft gelöscht.",
  "This will permanently delete rule \"{name}\".": "Dadurch wird die Regel \"{name}\" dauerhaft gelöscht.",
  "This will permanently delete stream \"{name}\".": "Dadurch wird der Stream \"{name}\" dauerhaft gelöscht.",
  "This will permanently delete this ad account connection. Cost syncing will stop.": "Dadurch wird diese Werbekonto-Verbindung dauerhaft gelöscht. Die Kostensynchronisierung wird gestoppt.",
  "This will permanently delete this conversion forwarder.": "Dadurch wird dieser Conversion-Forwarder dauerhaft gelöscht.",
  "This will permanently delete webhook \"{name}\". Events will no longer be forwarded.": "Dadurch wird der Webhook \"{name}\" dauerhaft gelöscht. Events werden nicht mehr weitergeleitet.",
  "This will permanently revoke this API key. Any integrations using it will stop working.": "Dadurch wird dieser API-Schlüssel dauerhaft widerrufen. Integrationen, die ihn nutzen, funktionieren dann nicht mehr.",
  "This will reset all branding settings to defaults. Logo, colors, and custom domain will be removed.": "Dadurch werden alle Branding-Einstellungen auf die Standardwerte zurückgesetzt. Logo, Farben und eigene Domain werden entfernt.",
  "This will reset two-factor authentication for this member. They will need to re-enrol.": "Dadurch wird die Zwei-Faktor-Authentifizierung für dieses Mitglied zurückgesetzt. Es muss sie neu einrichten.",
  "Title": "Titel",
  "Title, body, and button labels shown to the visitor.": "Titel, Text und Button-Beschriftungen, die dem Besucher angezeigt werden.",
  "To (ISO-8601)": "Bis (ISO-8601)",
  "Toggle navigation": "Navigation umschalten",
  "Tokyo (UTC+9)": "Tokio (UTC+9)",
  "Too many requests — please retry in a moment.": "Zu viele Anfragen — bitte versuche es gleich noch einmal.",
  "Track click usage and switch plans. Billing renews monthly.": "Behalte die Klicknutzung im Blick und wechsle den Plan. Die Abrechnung erneuert sich monatlich.",
  "Tracking domain": "Tracking-Domain",
  "Tracking link copied to clipboard": "Tracking-Link in die Zwischenablage kopiert",
  "Tune the bandit before running a preview. Apply only writes weights to active streams.": "Justiere den Bandit, bevor du eine Vorschau ausführst. „Anwenden“ schreibt die Gewichtungen nur in aktive Streams.",
  "Two-factor authentication": "Zwei-Faktor-Authentifizierung",
  "Two-factor code": "Zwei-Faktor-Code",
  "Type": "Typ",
  "Type a command or search…": "Befehl eingeben oder suchen…",
  "Ungrouped": "Nicht gruppiert",
  "Unlimited": "Unbegrenzt",
  "Upload a landing-page bundle (.zip) or pick a hosted pre-landing template from the library.": "Lade ein Landingpage-Paket (.zip) hoch oder wähle eine gehostete Prelander-Vorlage aus der Bibliothek.",
  "Upload, organize and reuse landing pages across your campaigns.": "Lade Landingpages hoch, organisiere sie und nutze sie in all deinen Kampagnen wieder.",
  "Uses the seed list (Python requests, Go net/http, curl, headless Chrome) plus your workspace overrides.": "Nutzt die Seed-Liste (Python requests, Go net/http, curl, Headless Chrome) plus deine Workspace-Overrides.",
  "Vendor list": "Anbieterliste",
  "Vendor name (e.g. Google Analytics)": "Anbietername (z. B. Google Analytics)",
  "Verify now": "Jetzt verifizieren",
  "Verifying…": "Wird geprüft…",
  "View": "View",
  "Views": "Aufrufe",
  "Visible metrics": "Sichtbare Metriken",
  "Visitor": "Visitor",
  "Visual identity": "Visuelle Identität",
  "Weight floor (%)": "Mindestgewicht (%)",
  "Weighted": "Gewichtet",
  "Welcome to ACME Tracker — sign in to continue": "Willkommen bei ACME Tracker — melde dich an, um fortzufahren",
  "When disabled, the public widget responds with required:false so landing pages skip rendering entirely.": "Wenn deaktiviert, antwortet das öffentliche Widget mit required:false, sodass Landingpages das Rendering komplett überspringen.",
  "When set, the tracker auto-appends ?<param>=<click_id> to redirect URLs. Leave empty to disable. Use {click_id} in the target URL for full control.": "Wenn gesetzt, hängt der Tracker automatisch ?<param>=<click_id> an Redirect-URLs an. Leer lassen zum Deaktivieren. Nutze {click_id} in der Ziel-URL für volle Kontrolle.",
  "Workflows": "Workflows",
  "Workspace default domain": "Standarddomain des Workspace",
  "Your tracking link": "Dein Tracking-Link",
  "clear tag": "Tag entfernen",
  "clicks": "Klicks",
  "connections": "Verbindungen",
  "domains": "Domains",
  "e.g. 185.45.12.1, 91.108.0.0": "z. B. 185.45.12.1, 91.108.0.0",
  "e.g. Facebook, Google, Tier 1": "z. B. Facebook, Google, Tier 1",
  "e.g. MaxBounty CPA": "z. B. MaxBounty CPA",
  "e.g. adcombo, cpa, status": "z. B. adcombo, cpa, status",
  "group.<key>": "group.<key>",
  "installs": "Installationen",
  "live": "live",
  "logo": "Logo",
  "max change": "max. Änderung",
  "no": "no",
  "or continue with": "oder weiter mit",
  "revoked": "widerrufen",
  "rows": "Zeilen",
  "to close": "zum Schließen",
  "to navigate": "zum Navigieren",
  "to select": "zum Auswählen",
  "weight units": "Gewichtseinheiten",
  "yes": "ja",
  "{count} conversions": "{count} Conversions",
  "{key} breakdown": "Aufschlüsselung nach {key}",
  "{n} selected": "{n} ausgewählt",
  "Δ": "Δ",
  "Sub-ID reports": "Sub-ID-Reports",
  "Ad accounts": "Werbekonten",
  "API docs": "API-Doku",
  "Drill-down by sub1–sub15: clicks, conversions, CR": "Drilldown nach Sub1–Sub15: Klicks, Conversions, CR",
  "Side-by-side metrics for multiple campaigns": "Metriken mehrerer Kampagnen im direkten Vergleich",
  "Step-by-step user guide for every feature": "Schritt-für-Schritt-Anleitung für jede Funktion",
  "Switch to dark theme": "Zum dunklen Theme wechseln",
  "Switch to light theme": "Zum hellen Theme wechseln",
  "Page not found": "Seite nicht gefunden",
  "The page you are looking for does not exist or has been moved.": "Die gesuchte Seite existiert nicht oder wurde verschoben.",
  "Access denied": "Zugriff verweigert",
  "You do not have permission to view this page. Contact your workspace admin if you believe this is a mistake.": "Du hast keine Berechtigung, diese Seite anzuzeigen. Wende dich an deinen Workspace-Admin, falls das ein Irrtum ist.",
  "Server error": "Serverfehler",
  "Something went wrong on our end. Please try again later or contact support.": "Bei uns ist etwas schiefgelaufen. Bitte versuche es später erneut oder kontaktiere den Support.",
  "View campaigns": "Kampagnen ansehen",
  "List and open campaigns and their stats.": "Kampagnen und ihre Statistiken auflisten und öffnen.",
  "Create campaigns": "Kampagnen erstellen",
  "Add new campaigns and their default streams.": "Neue Kampagnen und ihre Standard-Streams hinzufügen.",
  "Edit campaigns": "Kampagnen bearbeiten",
  "Change campaign settings, target URL, status.": "Kampagneneinstellungen, Ziel-URL und Status ändern.",
  "Permanently remove a campaign and its history.": "Eine Kampagne und ihre Historie dauerhaft entfernen.",
  "View landings": "Landingpages ansehen",
  "Browse the landing-page library.": "Die Landingpage-Bibliothek durchsuchen.",
  "Edit landings": "Landingpages bearbeiten",
  "Upload, edit, and delete landings.": "Landingpages hochladen, bearbeiten und löschen.",
  "View offers": "Offers ansehen",
  "Browse the offer library.": "Die Offer-Bibliothek durchsuchen.",
  "Edit offers": "Offers bearbeiten",
  "Create, edit, and delete offers.": "Offers erstellen, bearbeiten und löschen.",
  "View anti-fraud": "Betrugsschutz ansehen",
  "Read filter list, blocked samples, audit feed.": "Filterliste, blockierte Beispiele und Audit-Feed einsehen.",
  "Edit anti-fraud filters": "Anti-Fraud-Filter bearbeiten",
  "Create / update / delete fraud filters and IP lists.": "Fraud-Filter und IP-Listen erstellen / aktualisieren / löschen.",
  "Manage TLS fingerprint overrides": "TLS-Fingerprint-Overrides verwalten",
  "Pin JA3 / JA4 hashes per-workspace (overrides the seed list).": "JA3-/JA4-Hashes pro Workspace fixieren (überschreibt die Seed-Liste).",
  "View reports": "Reports ansehen",
  "Open the analytics dashboard and saved reports.": "Öffnet das Analytics-Dashboard und gespeicherte Reports.",
  "Export reports": "Reports exportieren",
  "Download CSV / JSON report exports.": "CSV-/JSON-Report-Exporte herunterladen.",
  "View automation rules": "Automatisierungsregeln ansehen",
  "Read the rules engine and execution history.": "Liest die Regel-Engine und den Ausführungsverlauf.",
  "Edit automation rules": "Automatisierungsregeln bearbeiten",
  "Create / update / delete automation rules.": "Automatisierungsregeln erstellen / aktualisieren / löschen.",
  "View integrations": "Integrationen ansehen",
  "Browse integration configurations.": "Integrationskonfigurationen durchsuchen.",
  "Edit integrations": "Integrationen bearbeiten",
  "Connect / disconnect ad accounts and webhooks.": "Werbekonten und Webhooks verbinden / trennen.",
  "View postbacks": "Postbacks ansehen",
  "Browse postbacks and the CAPI dead-letter queue.": "Postbacks und die CAPI-Dead-Letter-Queue durchsuchen.",
  "Edit postbacks": "Postbacks bearbeiten",
  "Configure postbacks, replay / discard CAPI DLQ entries.": "Postbacks konfigurieren, CAPI-DLQ-Einträge erneut senden / verwerfen.",
  "Invite members": "Mitglieder einladen",
  "Send invite links to new teammates.": "Einladungslinks an neue Teammitglieder senden.",
  "Change member role": "Mitgliedsrolle ändern",
  "Promote / demote existing members.": "Bestehende Mitglieder befördern / degradieren.",
  "Remove members": "Mitglieder entfernen",
  "Revoke a teammate's access.": "Zugriff eines Teammitglieds entziehen.",
  "Edit workspace settings": "Workspace-Einstellungen bearbeiten",
  "Change workspace currency, timezone, branding.": "Währung, Zeitzone und Branding des Workspace ändern.",
  "Edit permission matrix": "Berechtigungsmatrix bearbeiten",
  "Override the default permission matrix for this workspace.": "Überschreibt die Standard-Berechtigungsmatrix für diesen Workspace.",
  "View billing": "Abrechnung ansehen",
  "See plan, invoices, payment method.": "Plan, Rechnungen und Zahlungsmethode ansehen.",
  "Change plan, update payment method.": "Plan ändern, Zahlungsmethode aktualisieren.",
  "View audit log": "Audit-Log ansehen",
  "Read the workspace audit feed.": "Liest den Audit-Feed des Workspace.",
  "View tracking domains": "Tracking-Domains ansehen",
  "Browse the tracking-domain list.": "Liste der Tracking-Domains durchsuchen.",
  "Edit tracking domains": "Tracking-Domains bearbeiten",
  "Add / remove tracking domains.": "Tracking-Domains hinzufügen / entfernen.",
  "View API keys": "API-Keys ansehen",
  "List existing API keys (does not reveal the secret).": "Listet bestehende API-Keys auf (zeigt das Secret nicht).",
  "Manage API keys": "API-Keys verwalten",
  "Create / revoke API keys.": "API-Keys erstellen / widerrufen.",
  "Cloaking — send bots to a safe page": "Cloaking — Bots auf eine sichere Seite leiten",
  "Self-hosted cloaking. Bots, ad-network moderators, datacenter/proxy IPs and search crawlers see the safe (white) page; genuine humans go to the real offer. Classification uses the tracker's own bot / IP / crawler-DNS checks — no third-party service.": "Selbst gehostetes Cloaking. Bots, Moderatoren von Werbenetzwerken, Datacenter-/Proxy-IPs und Suchmaschinen-Crawler sehen die sichere (White-)Seite; echte Menschen gelangen zum echten Offer. Die Klassifizierung nutzt die eigenen Bot-/IP-/Crawler-DNS-Prüfungen des Trackers — kein Drittanbieter-Dienst.",
  "Safe page URL": "URL der sicheren Seite",
  "The compliant page shown to bots/crawlers. Must be an absolute http(s) URL. In SEO mode this is the page verified search crawlers index.": "Die konforme Seite, die Bots/Crawlern angezeigt wird. Muss eine absolute http(s)-URL sein. Im SEO-Modus ist dies die Seite, die verifizierte Such-Crawler indexieren.",
  "Bots & spoofed crawlers": "Bots & gefälschte Crawler",
  "Verified search crawlers": "Verifizierte Such-Crawler",
  "Datacenter / Tor IPs": "Datacenter-/Tor-IPs",
  "Proxy / VPN IPs": "Proxy-/VPN-IPs",
  "Enter a valid http(s) Safe page URL for cloaking": "Gib eine gültige http(s)-URL der Safe Page für Cloaking ein",
  "Cloaked": "Cloaked",
  "All traffic": "Gesamter Traffic",
  "Cloaked only": "Nur Cloaked",
  "Real only": "Nur Echte",
  "Cloaking": "Cloaking",
  "Bots and crawlers sent to the safe page vs humans to the offer": "Bots und Crawler zur Safe Page vs. Menschen zum Offer",
  "last {n} days": "letzte {n} Tage",
  "Cloaked → safe page": "Cloaked → Safe Page",
  "Real → offer": "Echt → Offer",
  "Cloak rate": "Cloak-Rate",
  "Spoofed crawlers": "Gefälschte Crawler",
  "Verified crawlers": "Verifizierte Crawler",
  "Datacenter / Tor": "Datacenter / Tor",
  "SEO split (crawlers → index, humans → funnel)": "SEO-Split (Crawler → Index, Menschen → Funnel)",
  "SEO crawler split on: verified crawlers index the page, humans go to the funnel": "SEO-Crawler-Split aktiviert: Verifizierte Crawler indexieren die Seite, Menschen gelangen zum Funnel",
  "SEO crawler split off": "SEO-Crawler-Split deaktiviert",
  "When on, DNS-verified search crawlers get the index page (for ranking) and humans are sent to the bound campaign funnel. Needs an index page + a campaign bound to this domain.": "Wenn aktiviert, erhalten DNS-verifizierte Such-Crawler die Index-Seite (fürs Ranking) und Menschen werden zum verknüpften Kampagnen-Funnel geleitet. Erfordert eine Index-Seite + eine mit dieser Domain verknüpfte Kampagne.",
  "Fallback robots/sitemap": "Fallback robots/sitemap",
  "Serve a generated robots.txt / sitemap.xml at the domain root ONLY when your uploaded bundle has none. Your own SEO files always take priority.": "Liefert ein generiertes robots.txt / sitemap.xml an der Domain-Root NUR, wenn dein hochgeladenes Bundle keines enthält. Deine eigenen SEO-Dateien haben immer Vorrang.",
  "Fallback robots.txt/sitemap.xml on (only when your bundle has none)": "Fallback robots.txt/sitemap.xml aktiviert (nur wenn dein Bundle keines enthält)",
  "Fallback robots.txt/sitemap.xml off": "Fallback robots.txt/sitemap.xml deaktiviert",
  "Root: stable index": "Root: stabiler Index",
  "Root: SEO split": "Root: SEO-Split",
  "Root: funnel": "Root: Funnel",
  "Root: 404": "Root: 404",
  "own": "eigene",
  "fallback": "Fallback",
  "none": "keine",
  "indexable": "indexierbar",
  "no-index": "no-index",
  "Registration": "Registrierung",
  "Deposit": "Einzahlung",
  "Trash": "Papierkorb",
  "Hide": "Ausblenden",
  "Show": "Anzeigen",
  "Import from source": "Aus Quelle importieren",
  "Postback token": "Postback-Token",
  "Require postback token": "Postback-Token erforderlich",
  "Network macros": "Netzwerk-Makros",
  "FTD · Deposit (sale)": "FTD · Einzahlung (Sale)",
  "Chargeback (reject)": "Chargeback (Reject)",
  "This campaign has no source with parameters": "Diese Kampagne hat keine Traffic-Quelle mit Parametern",
  "Macros imported from the source — click Save": "Makros aus der Quelle importiert — klicke auf Speichern",
  "Save the campaign once to generate the token.": "Speichere die Kampagne einmal, um den Token zu generieren.",
  "When ON, incoming postbacks must carry this campaign's token, otherwise they are rejected (401). Turn OFF if the network (e.g. TrackBox) sends ONE shared postback for all campaigns: remove &token=… from this URL and conversions are matched by click_id.": "Wenn AKTIVIERT, müssen eingehende Postbacks den Token dieser Kampagne enthalten, andernfalls werden sie abgelehnt (401). Deaktiviere dies, wenn das Netzwerk (z. B. TrackBox) EINEN gemeinsamen Postback für alle Kampagnen sendet: Entferne &token=… aus dieser URL, und Conversions werden per click_id zugeordnet.",
  "Token check disabled — postbacks are accepted by click_id without a token (remove &token=… from the URL in your network).": "Token-Prüfung deaktiviert — Postbacks werden per click_id ohne Token akzeptiert (entferne &token=… aus der URL in deinem Netzwerk).",
  "TrackBox: pass your click_id in the offer link's Affclickid parameter so {affclickid} comes back to this campaign. Method GET.": "TrackBox: Übergib deine click_id im Affclickid-Parameter des Offer-Links, damit {affclickid} zu dieser Kampagne zurückkommt. Methode GET.",
  "Generic: pass your click_id in the offer link so it comes back to this campaign as {click_id}. Method GET.": "Generic: Übergib deine click_id im Offer-Link, damit sie als {click_id} zu dieser Kampagne zurückkommt. Methode GET.",
  "Subid: pass your click_id in the offer link's subid parameter so {subid} comes back to this campaign. Method GET.": "Subid: Übergib deine click_id im subid-Parameter des Offer-Links, damit {subid} zu dieser Kampagne zurückkommt. Methode GET.",
  "Enter the bot token and chat_id — Lead and Deposit postbacks with a ready-made message (Campaign, Sub1..4, Source, Payout) will be added. Then press Save.": "Gib den Bot-Token und die chat_id ein — Lead- und Deposit-Postbacks mit einer fertigen Nachricht (Kampagne, Sub1..4, Quelle, Payout) werden hinzugefügt. Klicke dann auf Speichern.",
  "What is XPNSR Tracker": "Was ist XPNSR Tracker",
  "Links & aliases": "Links & Aliase",
  "Postbacks": "Postbacks",
  "Macros": "Macros",
  "Redirect modes": "Weiterleitungsmodi",
  "A/B tests": "A/B-Tests",
  "Glossary": "Glossar",
  "Partners & lead forms": "Partner & Lead-Formulare",
  "Google Ads & conversions": "Google Ads & Conversions",
  "Reports (Report Builder)": "Berichte (Report Builder)",
  "Failed to copy": "Kopieren fehlgeschlagen",
  "Domain opened for indexing": "Domain für Indexierung geöffnet",
  "Domain closed from indexing": "Domain für Indexierung geschlossen",
  "Index page set": "Index-Seite festgelegt",
  "Index page cleared": "Index-Seite entfernt",
  "Server migration (admin only)": "Servermigration (nur Admin)",
  "Current server IP:": "Aktuelle Server-IP:",
  "Step 1. Provision a new server": "Schritt 1. Neuen Server bereitstellen",
  "Create an EC2 instance in AWS (Ubuntu, open ports 80 and 443), SSH into it and paste this entire command. It prints the new server IP at the end.": "Erstelle eine EC2-Instance in AWS (Ubuntu, Ports 80 und 443 offen), verbinde dich per SSH und füge diesen gesamten Befehl ein. Am Ende wird die neue Server-IP ausgegeben.",
  "Step 2. Enter the new IP": "Schritt 2. Neue IP eingeben",
  "Paste the IP from Step 1 and press Save. Every client immediately gets the new IP for their A record — no restart needed.": "Füge die IP aus Schritt 1 ein und klicke auf Speichern. Jeder Client erhält sofort die neue IP für seinen A-Record — kein Neustart nötig.",
  "Tip: if you reassign the old Elastic IP to the new server in AWS, nothing needs to change here — nor for clients.": "Tipp: Wenn du die alte Elastic IP in AWS dem neuen Server neu zuweist, muss hier nichts geändert werden — auch nicht bei den Clients.",
  "Open for search engines — click to close": "Offen für Suchmaschinen — zum Schließen klicken",
  "Closed from search engines — click to open": "Geschlossen für Suchmaschinen — zum Öffnen klicken",
  "Indexable": "Indexierbar",
  "No-index": "No-Index",
  "Index page (SEO, served at the root with 200):": "Index-Seite (SEO, wird an der Root mit 200 ausgeliefert):",
  "— none (root opens the funnel) —": "— keine (die Root öffnet den Funnel) —",
  "Custom API (any CRM)": "Custom API (beliebiges CRM)",
  "TrackBox account credentials (dashboard → API Testing). Set up once per account — offers will reference this partner.": "TrackBox-Kontodaten (Dashboard → API Testing). Einmal pro Konto einrichten — Offers verweisen dann auf diesen Partner.",
  "Username": "Benutzername",
  "Signup path": "Signup-Pfad",
  "Pull path": "Pull-Pfad",
  "Pull type": "Pull-Typ",
  "Auto pull-sync": "Automatischer Pull-Sync",
  "Universal integration for any partner CRM. Describe its lead-registration API request — the tracker will send form data there and redirect using the link from the response.": "Universelle Integration für jedes Partner-CRM. Beschreibe dessen API-Request zur Lead-Registrierung — der Tracker sendet dorthin die Formulardaten und leitet mit dem Link aus der Antwort weiter.",
  "API URL (base)": "API-URL (Basis)",
  "Body format": "Body-Format",
  "Headers": "Header",
  "(one \"Key: value\" per line, macros allowed)": "(ein \"Key: Value\" pro Zeile, Makros erlaubt)",
  "Body template (JSON)": "Body-Vorlage (JSON)",
  "(values are macros in curly braces)": "(Werte sind Makros in geschweiften Klammern)",
  "Redirect field": "Weiterleitungsfeld",
  "Success field (optional)": "Erfolgsfeld (optional)",
  "Success value (optional)": "Erfolgswert (optional)",
  "plus any form fields and offer parameters. The redirect field is a path in the JSON response (e.g. data.url); if empty, the first http(s) link found in the response is used.": "plus beliebige Formularfelder und Offer-Parameter. Das Feld redirect ist ein Pfad in der JSON-Antwort (z. B. data.url); ist es leer, wird der erste gefundene http(s)-Link in der Antwort verwendet.",
  "Set up a partner/CRM here once, then offers reference it. TrackBox / Tigloo is the ready-made adapter; Custom API fits any other CRM. Leads from offer forms are sent to the selected partner.": "Richte hier einmal einen Partner/CRM ein, danach verweisen Offers darauf. TrackBox / Tigloo ist der fertige Adapter; Custom API passt zu jedem anderen CRM. Leads aus Offer-Formularen werden an den gewählten Partner gesendet.",
  "Affiliate routing (form offers)": "Affiliate-Routing (Formular-Offers)",
  "Route this offer to one or more partners with weights (split/rotation). Inactive partners are skipped (e.g. until terms are agreed). The lead goes by weight; on rejection it falls back to the next partner.": "Route dieses Offer mit Gewichtungen (Split/Rotation) an einen oder mehrere Partner. Inaktive Partner werden übersprungen (z. B. bis Konditionen vereinbart sind). Der Lead wird nach Gewicht zugewiesen; bei Ablehnung geht er an den nächsten Partner.",
  "Telegram lead alerts": "Telegram-Lead-Alerts",
  "(sent on EVERY submit — even test/error)": "(wird bei JEDEM Submit gesendet — auch Test/Fehler)",
  "Every lead captured by your form offers lands here — accepted, rejected and test. Filter, export to CSV and resell. Statuses are updated by postbacks and pull sync.": "Jeder Lead, den deine Formular-Offers erfassen, landet hier — akzeptiert, abgelehnt und Test. Filtere, exportiere als CSV und verkaufe weiter. Status werden per Postback und Pull-Sync aktualisiert.",
  "Hint": "Hinweis",
  "Cycle language": "Sprache wechseln",
  "Switch to {lang}": "Zu {lang} wechseln",
  "Current language: {lang}": "Aktuelle Sprache: {lang}",
  "Scroll to top": "Nach oben scrollen",
  "Something went wrong": "Etwas ist schiefgelaufen",
  "An unexpected error occurred.": "Ein unerwarteter Fehler ist aufgetreten.",
  "Reload page": "Seite neu laden",
  "My first campaign": "Meine erste Kampagne",
  "CPA Network": "CPA Network",
  "Main FB pixel": "Haupt-FB-Pixel",
  "zapier integration": "Zapier-Integration",
  "Bot token": "Bot-Token",
  "Chat ID": "Chat ID",
  "(no match)": "(kein Treffer)",
  "+ Upload": "+ Hochladen",
  "A custom conversion type with its own reporting rules and status transitions.": "Ein benutzerdefinierter Conversion-Typ mit eigenen Reporting-Regeln und Status-Übergängen.",
  "A formula over base metrics rendered as a report column.": "Eine Formel über Basis-Metriken, dargestellt als Report-Spalte.",
  "A/B testing": "A/B-Tests",
  "Add a manual cost, or connect an ad account to sync spend automatically.": "Füge einen manuellen Kosten-Eintrag hinzu oder verbinde ein Werbekonto, um Spend automatisch zu synchronisieren.",
  "Add cost": "Kosten hinzufügen",
  "Add from preset": "Aus Preset hinzufügen",
  "Add manual cost": "Manuelle Kosten hinzufügen",
  "Add partner route": "Partner-Route hinzufügen",
  "Add range": "Bereich hinzufügen",
  "Add value": "Wert hinzufügen",
  "Added to blacklist": "Zur Blacklist hinzugefügt",
  "Added to whitelist": "Zur Whitelist hinzugefügt",
  "Adjust the period or campaign filter.": "Passe den Zeitraum oder den Kampagnen-Filter an.",
  "Affiliate CRM — push leads via API": "Affiliate-CRM — Leads per API senden",
  "Affiliate network postback": "Postback des Affiliate-Netzwerks",
  "All offers": "Alle Offers",
  "All rows": "Alle Zeilen",
  "Allowed next statuses": "Erlaubte nächste Status",
  "Amount": "Betrag",
  "Any date": "Beliebiges Datum",
  "Any status": "Beliebiger Status",
  "Arithmetic over base metrics. Supported: + - * / ( ) and numbers.": "Arithmetik über Basis-Metriken. Unterstützt: + - * / ( ) und Zahlen.",
  "Back to streams": "Zurück zu Streams",
  "Base metrics": "Basismetriken",
  "Bind your own domain to mask tracking links. Point an A record to your tracking server and verify ownership via TXT record.": "Binde deine eigene Domain ein, um Tracking-Links zu maskieren. Richte einen A-Record auf deinen Tracking-Server und bestätige die Inhaberschaft per TXT-Record.",
  "Black": "Black",
  "Black / white lists": "Blacklists / Whitelists",
  "Blacklist": "Blacklist",
  "Blacklisted": "Gesperrt",
  "Blank referrer (JS)": "Leerer Referrer (JS)",
  "Book spend against a campaign. It is folded into the campaign cost used by ROI and dashboards.": "Verbuche Spend auf eine Kampagne. Er fließt in die Kampagnenkosten ein, die ROI und Dashboards verwenden.",
  "Bot": "Bot",
  "Bot IP addresses": "Bot-IP-Adressen",
  "Bot User-Agent signatures": "Bot-User-Agent-Signaturen",
  "Bot lists": "Bot-Listen",
  "Bot lists saved": "Bot-Listen gespeichert",
  "Breakdown": "Aufschlüsselung",
  "Bucket": "Bucket",
  "Built-in statuses": "Integrierte Status",
  "By destination": "Nach Ziel",
  "By stream": "Nach Stream",
  "CPS (per sale)": "CPS (pro Sale)",
  "CPuC (per unique click)": "CPuC (pro Unique Click)",
  "CRM": "CRM",
  "CRM response": "CRM-Antwort",
  "Cadence": "Intervall",
  "Calendar dates when the stream is active (owner timezone). Leave start or end empty for an open-ended side. 'Is not' inverts the range.": "Kalenderdaten, an denen der Stream aktiv ist (Zeitzone des Besitzers). Lasse Start oder Ende leer für ein offenes Ende. 'Ist nicht' kehrt den Zeitraum um.",
  "California, Bavaria, Moscow Oblast": "Kalifornien, Bayern, Oblast Moskau",
  "Canonical status stored on each conversion. Auto-generated from the name if left blank.": "Kanonischer Status, der bei jeder Conversion gespeichert wird. Wird automatisch aus dem Namen generiert, wenn das Feld leer bleibt.",
  "Click API (server-to-server)": "Click-API (Server-to-Server)",
  "Code (slug)": "Code (Slug)",
  "Column key in reports. Auto-generated from the name if left blank.": "Spaltenschlüssel in Reports. Wird automatisch aus dem Namen generiert, wenn das Feld leer bleibt.",
  "Comma-separated email addresses.": "Kommagetrennte E-Mail-Adressen.",
  "Compensates cost for traffic lost between the source and the tracker: real cost = base / (1 − loss%/100).": "Gleicht Kosten für Traffic aus, der zwischen Traffic-Quelle und Tracker verloren geht: realer Kosten = Basis / (1 − Verlust%/100).",
  "Configure any partner CRM lead API": "Konfiguriere die Lead-API jedes beliebigen Partner-CRM",
  "Conversion date": "Conversion-Datum",
  "Conversion statuses": "Conversion-Status",
  "Conversion type created": "Conversion-Typ erstellt",
  "Conversion type deleted": "Conversion-Typ gelöscht",
  "Conversion type updated": "Conversion-Typ aktualisiert",
  "Conversion types": "Conversion-Typen",
  "Cookie (default)": "Cookie (Standard)",
  "Copy blacklist": "Blacklist kopieren",
  "Copy list": "Liste kopieren",
  "Copy whitelist": "Whitelist kopieren",
  "Cost entries": "Kosteneinträge",
  "Cost entry added": "Kosteneintrag hinzugefügt",
  "Cost entry deleted": "Kosteneintrag gelöscht",
  "Count conversions of this type toward the offer daily cap.": "Conversions dieses Typs auf den täglichen Cap des Offers anrechnen.",
  "Counts against offer cap": "Zählt zum Offer-Cap",
  "Counts in conversions": "Zählt bei Conversions",
  "Counts in revenue": "Zählt beim Umsatz",
  "Counts vs cap": "Anzahl vs. Cap",
  "Create conversion type": "Conversion-Typ erstellen",
  "Create custom metric": "Benutzerdefinierte Metrik erstellen",
  "Create metric": "Metrik erstellen",
  "Create one like uCR = conversions / unique_clicks * 100.": "Erstelle eine wie uCR = conversions / unique_clicks * 100.",
  "Create one to export campaign performance on demand.": "Erstelle einen, um die Kampagnen-Performance auf Abruf zu exportieren.",
  "Create one to map partner statuses like FTD or second deposit.": "Erstelle einen, um Partner-Status wie FTD oder zweite Einzahlung zuzuordnen.",
  "Create one to receive recurring reports by email.": "Erstelle einen, um wiederkehrende Reports per E-Mail zu erhalten.",
  "Create type": "Typ erstellen",
  "Custom bot IPs/CIDRs and UA signatures for the bot-detection filter": "Benutzerdefinierte Bot-IPs/CIDRs und UA-Signaturen für den Bot-Erkennungsfilter",
  "Custom bot IPs/CIDRs and User-Agent signatures used by the bot-detection fraud filter.": "Benutzerdefinierte Bot-IPs/CIDRs und User-Agent-Signaturen, die vom Bot-Erkennungsfilter des Fraud-Schutzes verwendet werden.",
  "Custom conversion types: map network statuses, reporting flags and transition rules": "Benutzerdefinierte Conversion-Typen: Netzwerk-Status, Report-Flags und Übergangsregeln zuordnen",
  "Custom metric created": "Benutzerdefinierte Metrik erstellt",
  "Custom metric deleted": "Benutzerdefinierte Metrik gelöscht",
  "Custom metric updated": "Benutzerdefinierte Metrik aktualisiert",
  "Custom metrics": "Eigene Metriken",
  "DSAR erasure completed": "DSAR-Löschung abgeschlossen",
  "DSAR export ready": "DSAR-Export bereit",
  "Daily": "Täglich",
  "Data subject": "Betroffene Person",
  "Data-subject access (Article 15) and erasure (Article 17) by identifier.": "Auskunftsrecht der betroffenen Person (Artikel 15) und Löschung (Artikel 17) nach Identifikator.",
  "Data-subject export (Art. 15) and erasure (Art. 17) by identifier": "Export der Daten der betroffenen Person (Art. 15) und Löschung (Art. 17) nach Identifikator",
  "Date": "Datum",
  "Date range": "Zeitraum",
  "Day": "Day",
  "Day of month (1-31)": "Tag des Monats (1-31)",
  "Day of week": "Wochentag",
  "Decimals": "Dezimalstellen",
  "Define a reusable report and its grouping/metrics.": "Definiere einen wiederverwendbaren Report sowie dessen Gruppierung/Metriken.",
  "Define custom conversion types, map network statuses and control reporting semantics.": "Definiere benutzerdefinierte Conversion-Typen, ordne Netzwerk-Status zu und steuere die Report-Semantik.",
  "Define formula-based report columns over base metrics (CR, EPC, ROI variants).": "Definiere formelbasierte Report-Spalten auf Basis von Grundmetriken (CR, EPC, ROI-Varianten).",
  "Delete conversion type": "Conversion-Typ löschen",
  "Delete cost entry": "Kosteneintrag löschen",
  "Delete custom metric": "Benutzerdefinierte Metrik löschen",
  "Delete file": "Datei löschen",
  "Delete report": "Report löschen",
  "Delete schedule": "Zeitplan löschen",
  "Delete this file?": "Diese Datei löschen?",
  "Desktop, Mobile, Tablet": "Desktop, Mobile, Tablet",
  "Destination": "Ziel",
  "Distribution": "Verteilung",
  "Double meta (hide referrer)": "Doppel-Meta (Referrer verbergen)",
  "Dry-run clicks through this campaign to test flow logic and filters — no real traffic is recorded.": "Simuliere Klicks über diese Kampagne, um Flow-Logik und Filter zu testen – es wird kein echter Traffic erfasst.",
  "EPC (sensitive)": "EPC (sensibel)",
  "Edge server updated": "Edge-Server aktualisiert",
  "Edit conversion type": "Conversion-Typ bearbeiten",
  "Edit custom metric": "Benutzerdefinierte Kennzahl bearbeiten",
  "Enter a valid amount": "Gib einen gültigen Betrag ein",
  "Enter at least one identifier": "Gib mindestens einen Identifikator ein",
  "Enter bot token and chat id": "Gib Bot-Token und Chat-ID ein",
  "Enter the text to find": "Gib den zu suchenden Text ein",
  "Equalize weights": "Gewichte angleichen",
  "Erase": "Löschen",
  "Erase data": "Daten löschen",
  "Erase subject data?": "Daten der betroffenen Person löschen?",
  "Erased": "Gelöscht",
  "Erasure is a hard delete and cannot be undone. It requires an admin role.": "Die Löschung ist endgültig und kann nicht rückgängig gemacht werden. Dafür ist eine Admin-Rolle erforderlich.",
  "Error creating conversion type": "Fehler beim Erstellen des Conversion-Typs",
  "Error creating cost entry": "Fehler beim Erstellen des Kosteneintrags",
  "Error creating custom metric": "Fehler beim Erstellen der benutzerdefinierten Kennzahl",
  "Error creating report": "Fehler beim Erstellen des Reports",
  "Error creating schedule": "Fehler beim Erstellen des Zeitplans",
  "Error deleting conversion type": "Fehler beim Löschen des Conversion-Typs",
  "Error deleting cost entry": "Fehler beim Löschen des Kosteneintrags",
  "Error deleting custom metric": "Fehler beim Löschen der benutzerdefinierten Kennzahl",
  "Error deleting file": "Fehler beim Löschen der Datei",
  "Error deleting report": "Fehler beim Löschen des Reports",
  "Error deleting schedule": "Fehler beim Löschen des Zeitplans",
  "Error loading bot lists": "Fehler beim Laden der Bot-Listen",
  "Error loading conversion types": "Fehler beim Laden der Conversion-Typen",
  "Error loading cost entries": "Fehler beim Laden der Kosteneinträge",
  "Error loading custom metrics": "Fehler beim Laden der benutzerdefinierten Kennzahlen",
  "Error loading reports": "Fehler beim Laden der Reports",
  "Error loading scheduled reports": "Fehler beim Laden der geplanten Reports",
  "Error saving bot lists": "Fehler beim Speichern der Bot-Listen",
  "Error updating conversion type": "Fehler beim Aktualisieren des Conversion-Typs",
  "Error updating custom metric": "Fehler beim Aktualisieren der benutzerdefinierten Kennzahl",
  "Error uploading file": "Fehler beim Hochladen der Datei",
  "Every submitted lead is stored here: filter, export (CSV) and resell": "Jeder übermittelte Lead wird hier gespeichert: filtern, exportieren (CSV) und weiterverkaufen",
  "Export data": "Daten exportieren",
  "Export flows": "Flows exportieren",
  "Exported": "Exportiert",
  "Failed to clone stream": "Stream konnte nicht geklont werden",
  "Failed to equalize weights": "Gewichtungen konnten nicht angeglichen werden",
  "Failed to erase DSAR": "DSAR konnte nicht gelöscht werden",
  "Failed to export DSAR": "DSAR konnte nicht exportiert werden",
  "Failed to export flows": "Flows konnten nicht exportiert werden",
  "Failed to export list": "Liste konnte nicht exportiert werden",
  "Failed to export report": "Report konnte nicht exportiert werden",
  "Failed to import flows": "Flows konnten nicht importiert werden",
  "Failed to insert flow": "Flow konnte nicht eingefügt werden",
  "Failed to load leads": "Leads konnten nicht geladen werden",
  "Failed to remove": "Entfernen fehlgeschlagen",
  "Failed to replace URLs": "URLs konnten nicht ersetzt werden",
  "Failed to run report": "Report konnte nicht ausgeführt werden",
  "Failed to update": "Aktualisierung fehlgeschlagen",
  "Failed to update list": "Liste konnte nicht aktualisiert werden",
  "Failed to update schedule": "Zeitplan konnte nicht aktualisiert werden",
  "Favourite": "Favorit",
  "Favourite flows": "Favoriten-Flows",
  "Favourites": "Favoriten",
  "Fetched": "Abgerufen",
  "File deleted": "Datei gelöscht",
  "File uploaded": "Datei hochgeladen",
  "Filter rule": "Filterregel",
  "Find": "Suchen",
  "Find and replace a substring in flow redirect URLs (never landing/offer URLs).": "Suche und ersetze eine Teilzeichenfolge in den Weiterleitungs-URLs von Flows (nie in Landingpage-/Offer-URLs).",
  "Fire on statuses": "Bei Status auslösen",
  "First 25 simulated clicks and how each was routed.": "Die ersten 25 simulierten Klicks und wie jeder geroutet wurde.",
  "Flag clicks that arrive with no User-Agent header.": "Markiere Klicks, die ohne User-Agent-Header eintreffen.",
  "Flow tools": "Flow-Tools",
  "Form submit (POST)": "Formularübermittlung (POST)",
  "Format": "Format",
  "Formula": "Formel",
  "Formula is required": "Formel ist erforderlich",
  "Formula-based report columns over base metrics (CR, EPC, ROI variants)": "Formelbasierte Report-Spalten auf Basis von Basiskennzahlen (CR, EPC, ROI-Varianten)",
  "Friday": "Freitag",
  "From": "Von",
  "GDPR / DSAR": "DSGVO / DSAR",
  "Group by": "Gruppieren nach",
  "Has label": "Hat Label",
  "Headless click registration and the JS adapter for landing pages.": "Headless-Klickerfassung und der JS-Adapter für Landingpages.",
  "Hour": "Stunde",
  "Hour (0-23)": "Stunde (0-23)",
  "How returning visitors are identified for unique-click detection: Cookie (default), IP, IP+UA, or Parameter — identify by a GET parameter (e.g. external_id) so the same user is recognised across IP/cookie changes.": "Wie wiederkehrende Besucher für die Erkennung eindeutiger Klicks identifiziert werden: Cookie (Standard), IP, IP+UA oder Parameter — Identifikation über einen GET-Parameter (z. B. external_id), damit derselbe Nutzer trotz IP-/Cookie-Änderungen erkannt wird.",
  "IP + User-Agent": "IP + User-Agent",
  "IP of your tracking server": "IP deines Tracking-Servers",
  "IPs": "IPs",
  "ISP / carrier": "ISP / Anbieter",
  "Import flows": "Flows importieren",
  "Imported": "Importiert",
  "In conversions": "In Conversions",
  "In revenue": "Im Umsatz",
  "Include this type in the conversions column.": "Diesen Typ in der Conversions-Spalte berücksichtigen.",
  "Include this type in the revenue column.": "Diesen Typ in der Umsatz-Spalte berücksichtigen.",
  "Insert": "Einfügen",
  "Integration": "Integration",
  "JS adapter snippet": "JS-Adapter-Snippet",
  "Key (e.g. price)": "Schlüssel (z. B. price)",
  "Key metrics over time buckets. Toggle to attribute conversions to their arrival date.": "Wichtige Kennzahlen über Zeitintervalle. Umschalten, um Conversions ihrem Eingangsdatum zuzuordnen.",
  "Keys": "Schlüssel",
  "Label color": "Label-Farbe",
  "Last run": "Letzte Ausführung",
  "Lead export failed": "Lead-Export fehlgeschlagen",
  "Lead storage": "Lead-Speicher",
  "Leads": "Leads",
  "Leads exported": "Leads exportiert",
  "Leave empty to count every conversion.": "Leer lassen, um jede Conversion zu zählen.",
  "Leave the period blank to record spend as of now.": "Lass den Zeitraum leer, um das Budget zum aktuellen Zeitpunkt zu erfassen.",
  "Lists": "Listen",
  "Manager": "Manager",
  "Manual": "Manuell",
  "Manually record campaign spend the ad-account sync can’t see — flat fees, offline media, corrections.": "Erfasse manuell Kampagnenausgaben, die die Synchronisierung des Werbekontos nicht sehen kann — Pauschalgebühren, Offline-Medien, Korrekturen.",
  "Manually record campaign spend — flat fees, offline media, corrections": "Kampagnenausgaben manuell erfassen — Pauschalgebühren, Offline-Medien, Korrekturen",
  "Marked values are reusable as report filters and copyable for ad networks.": "Markierte Werte lassen sich als Reportfilter wiederverwenden und für Affiliate-Netzwerke kopieren.",
  "Match the X-Requested-With header for webview / in-app browser detection. Substring match — e.g. com.android targets Android webviews; @empty targets clicks with no header.": "Vergleicht den X-Requested-With-Header zur Erkennung von WebViews / In-App-Browsern. Teilstring-Abgleich — z. B. zielt com.android auf Android-WebViews; @empty zielt auf Klicks ohne Header.",
  "Match the search engine derived from the se / se_referrer params or the referrer host — e.g. google, bing, yandex.": "Vergleicht die Suchmaschine, die aus den Parametern se / se_referrer oder dem Referrer-Host ermittelt wird — z. B. google, bing, yandex.",
  "Match the visitor's ISP / ASN organisation name (from the offline IP-intel table). Masks, /regex/ and @empty supported — e.g. AMAZON*, *Comcast*.": "Vergleicht den ISP- / ASN-Organisationsnamen des Besuchers (aus der Offline-IP-Intel-Tabelle). Masken, /regex/ und @empty werden unterstützt — z. B. AMAZON*, *Comcast*.",
  "Matched": "Übereinstimmend",
  "Metrics": "Metriken",
  "Metrics over time buckets (hour/day/weekday/month) + conversion-date view": "Kennzahlen nach Zeiträumen (Stunde/Tag/Wochentag/Monat) + Ansicht nach Conversion-Datum",
  "Monday": "Monday",
  "Monthly": "Monatlich",
  "Moscow, New York": "Moskau, New York",
  "Moscow, New York, London": "Moskau, New York, London",
  "Named key/value pairs injected into landing/offer/postback URLs via the {offer_value:NAME} macro.": "Benannte Schlüssel/Wert-Paare, die über das Makro {offer_value:NAME} in Landingpage-/Offer-/Postback-URLs eingefügt werden.",
  "Network preset…": "Netzwerk-Preset…",
  "Network status values": "Statuswerte des Affiliate-Netzwerks",
  "New report": "Neuer Report",
  "New saved report": "Neuer gespeicherter Report",
  "New schedule": "Neuer Zeitplan",
  "New scheduled report": "Neuer geplanter Report",
  "No cost entries yet": "Noch keine Kosteneinträge",
  "No custom conversion types yet": "Noch keine benutzerdefinierten Conversion-Typen",
  "No custom metrics yet": "Noch keine benutzerdefinierten Kennzahlen",
  "No data for this period": "Keine Daten für diesen Zeitraum",
  "No favourite flows yet. Star a flow to reuse it here.": "Noch keine favorisierten Flows. Markiere einen Flow mit einem Stern, um ihn hier wiederzuverwenden.",
  "No label": "Ohne Bezeichnung",
  "No leads yet": "Noch keine Leads",
  "No list entries yet. Use the thumbs buttons on report rows.": "Noch keine Listeneinträge. Nutze die Daumen-Buttons in den Report-Zeilen.",
  "No match": "Kein Treffer",
  "No offer values. Add a key like price, then use {offer_value:price} in URLs.": "Keine Offer-Werte. Füge einen Key wie price hinzu und verwende dann {offer_value:price} in URLs.",
  "No partner routes — this is a plain redirect/upload offer.": "Keine Partner-Routen — dies ist ein einfaches Redirect-/Upload-Offer.",
  "No recipients set": "Keine Empfänger festgelegt",
  "No saved reports yet": "Noch keine gespeicherten Reports",
  "No scheduled reports yet": "Noch keine geplanten Reports",
  "No status values added": "Keine Statuswerte hinzugefügt",
  "Not accepted": "Nicht angenommen",
  "Note": "Note",
  "Offer": "Offer",
  "Offer values": "Offer-Werte",
  "One exact IP or CIDR block per line (e.g. 203.0.113.7 or 10.0.0.0/8).": "Eine exakte IP oder ein CIDR-Block pro Zeile (z. B. 203.0.113.7 oder 10.0.0.0/8).",
  "One per line: substring, mask (*) or /regex/.": "Einer pro Zeile: Teilstring, Maske (*) oder /regex/.",
  "One value per line (or comma-separated). Each simulated query samples one value from each list.": "Ein Wert pro Zeile (oder durch Komma getrennt). Jede simulierte Abfrage nimmt einen Wert aus jeder Liste als Stichprobe.",
  "Only these conversion statuses are sent to the ad platform. Default: sale.": "Nur diese Conversion-Status werden an die Werbeplattform gesendet. Standard: sale.",
  "Open Domains": "Domains öffnen",
  "Overrides": "Overrides",
  "Owner": "Owner",
  "POST /v1/click with an API key (write scope). Returns the routing decision without a browser redirect.": "POST /v1/click mit einem API-Key (Write-Scope). Liefert die Routing-Entscheidung ohne Browser-Redirect.",
  "Parameter name, e.g. external_id": "Parametername, z. B. external_id",
  "Parameters": "Parameters",
  "Paste on a landing page to auto-append the click id and forward the visitor.": "Auf einer Landingpage einfügen, um die Click-ID automatisch anzuhängen und den Besucher weiterzuleiten.",
  "Per-query trace": "Trace pro Abfrage",
  "Period": "Zeitraum",
  "Period end": "Ende des Zeitraums",
  "Period start": "Beginn des Zeitraums",
  "Phone": "Telefon",
  "Pick a report, cadence and recipients.": "Wähle einen Report, einen Rhythmus und Empfänger.",
  "Postback added from preset": "Postback aus Preset hinzugefügt",
  "Postback macro": "Postback-Makro",
  "Provide at least one identifier. Matching clicks and conversions across your accessible workspaces are affected.": "Gib mindestens einen Identifier an. Übereinstimmende Clicks und Conversions in all deinen zugänglichen Workspaces sind betroffen.",
  "Pull lead statuses and deposits from TrackBox (last 7 days) and update stored leads. Set the Pull x-api-key on the integration first.": "Lead-Status und Deposits der letzten 7 Tage von TrackBox abrufen und gespeicherte Leads aktualisieren. Lege zuerst den Pull-x-api-key in der Integration fest.",
  "Pull lead statuses from OpenAFF for the number of days set on the integration and update stored leads. Set the status API token on the integration first.": "Lead-Status von OpenAFF für die in der Integration eingestellte Anzahl Tage abrufen und gespeicherte Leads aktualisieren. Lege zuerst den Status-API-Token in der Integration fest.",
  "Pull sync": "Pull-Synchronisierung",
  "Pull sync (statuses/deposits)": "Pull-Sync (Status/Deposits)",
  "Pull sync done": "Pull-Sync abgeschlossen",
  "Queries": "Abfragen",
  "ROI %": "ROI %",
  "ROI (sensitive)": "ROI (sensibel)",
  "Raw status strings partner networks send that should map to this type (case-insensitive).": "Rohe Status-Strings, die Partner-Netzwerke senden und die auf diesen Typ gemappt werden sollen (Groß-/Kleinschreibung wird ignoriert).",
  "Raw statuses to treat as TRASH (recorded but excluded from payouts). E.g. trash, invalid.": "Rohe Status, die als TRASH behandelt werden (werden erfasst, aber von Payouts ausgeschlossen). Z. B. trash, invalid.",
  "Raw statuses to treat as a DEPOSIT (first-class conversion type). E.g. dep, ftd, deposit.": "Rohe Status, die als DEPOSIT behandelt werden (Conversion-Typ erster Klasse). Z. B. dep, ftd, deposit.",
  "Raw statuses to treat as a REGISTRATION (first-class conversion type). E.g. reg, signup.": "Rohe Status, die als REGISTRATION behandelt werden (Conversion-Typ erster Klasse). Z. B. reg, signup.",
  "Read-only — only the workspace owner can edit the matrix": "Nur Lesezugriff — nur der Workspace-Owner kann die Matrix bearbeiten",
  "Recipients": "Empfänger",
  "Recurring reports emailed on a daily/weekly/monthly cadence": "Wiederkehrende Reports, die täglich/wöchentlich/monatlich per E-Mail versendet werden",
  "Recurring reports emailed to recipients on a daily/weekly/monthly cadence.": "Wiederkehrende Reports, die im täglichen/wöchentlichen/monatlichen Rhythmus an Empfänger per E-Mail versendet werden.",
  "Removed": "Entfernt",
  "Replace": "Ersetzen",
  "Replace URL": "URL ersetzen",
  "Replace with": "Ersetzen durch",
  "Report deleted": "Report gelöscht",
  "Report queued": "Report in der Warteschlange",
  "Report saved": "Report gespeichert",
  "Report type": "Report-Typ",
  "Request": "Anfrage",
  "Response sample": "Beispielantwort",
  "Reusable partner networks: postback, offer params, inbound URL": "Wiederverwendbare Partner-Netzwerke: Postback, Offer-Parameter, eingehende URL",
  "Reusable report definitions you can export to CSV or XLSX on demand.": "Wiederverwendbare Berichtsdefinitionen, die du jederzeit nach CSV oder XLSX exportieren kannst.",
  "Reusable report definitions, exportable to CSV/XLSX on demand": "Wiederverwendbare Berichtsdefinitionen, jederzeit exportierbar nach CSV/XLSX",
  "RevShare (% of payout)": "RevShare (% des Payouts)",
  "Revenue (sensitive)": "Umsatz (sensibel)",
  "Routing record (A record)": "Routing-Eintrag (A-Eintrag)",
  "Run now": "Jetzt ausführen",
  "Run pull sync": "Pull-Sync ausführen",
  "Run simulation": "Simulation starten",
  "Runs a rolling 7-day sync. Use this to verify the response before enabling auto pull-sync.": "Führt eine rollierende 7-Tage-Synchronisierung aus. Nutze das, um die Antwort zu prüfen, bevor du die automatische Pull-Synchronisierung aktivierst.",
  "Sample datasets": "Beispieldatensätze",
  "Saturday": "Saturday",
  "Saved reports": "Gespeicherte Reports",
  "Schedule created": "Zeitplan erstellt",
  "Schedule deleted": "Zeitplan gelöscht",
  "Scheduled reports": "Geplante Reports",
  "Search conversion types": "Conversion-Typen suchen",
  "Search custom metrics": "Benutzerdefinierte Metriken suchen",
  "Search engines": "Suchmaschinen",
  "Search presets": "Such-Presets",
  "Send a synthetic lead to the CRM and inspect the response. A throwaway email/phone is used unless you override below.": "Sende einen synthetischen Lead an das CRM und prüfe die Antwort. Dabei wird eine Wegwerf-E-Mail/-Telefonnummer verwendet, sofern du sie unten nicht überschreibst.",
  "Send test lead": "Testlead senden",
  "Set another entry page first": "Zuerst eine andere Einstiegsseite festlegen",
  "Show shortcuts": "Shortcuts anzeigen",
  "Simulate": "Simulieren",
  "Simulating…": "Simuliere…",
  "Simulation failed": "Simulation fehlgeschlagen",
  "Source": "Quelle",
  "Starred flows from any campaign. Insert a copy into this campaign.": "Favorisierte Flows aus beliebigen Kampagnen. Füge eine Kopie in diese Kampagne ein.",
  "Stored form leads: name/email/phone/geo/status, filter + CSV export for resale": "Gespeicherte Formular-Leads: Name/E-Mail/Telefon/GEO/Status, Filter + CSV-Export für den Weiterverkauf",
  "Stream cloned": "Stream geklont",
  "Streams changed": "Streams geändert",
  "Streams decide which offer each visitor lands on. Configure your default stream and you'll have a working tracking link.": "Streams entscheiden, auf welches Offer jeder Besucher gelangt. Konfiguriere deinen Standard-Stream, und du hast einen funktionierenden Tracking-Link.",
  "Submitted leads from your offer forms will appear here.": "Übermittelte Leads aus deinen Offer-Formularen erscheinen hier.",
  "Sunday": "Sonntag",
  "Synced": "Synchronisiert",
  "Telegram postbacks added — press Save to apply": "Telegram-Postbacks hinzugefügt — klicke auf Speichern, um zu übernehmen",
  "Google Ads postbacks added — press Save to apply": "Google-Ads-Postbacks hinzugefügt — klicke auf Speichern, um zu übernehmen",
  "Google Ads preset applied — press Save to apply": "Google-Ads-Preset angewendet — klicke auf Speichern, um zu übernehmen",
  "Also add the standard Google Ads parameters (campaignid, adgroupid, keyword, matchtype, cost, tm, tml, sub1–3) as defaults": "Auch die Standard-Google-Ads-Parameter (campaignid, adgroupid, keyword, matchtype, cost, tm, tml, sub1–3) als Standardwerte hinzufügen",
  "Google Ads postbacks added + click-time gtag turned off — press Save to apply": "Google-Ads-Postbacks hinzugefügt + Click-Time-gtag für diese Kampagne deaktiviert — klicke auf Speichern, um zu übernehmen",
  "Adding these also turns OFF the click-time gtag (fire on redirect) for this campaign, so the same Google conversion is not counted twice.": "Das Hinzufügen deaktiviert für diese Kampagne auch das Click-Time-gtag (Auslösung beim Redirect), damit dieselbe Google-Conversion nicht doppelt gezählt wird.",
  "Tracking params (campaignid, adgroupid, keyword, tm, tml, sub1–3) are declared once on the Google Ads traffic source — use \"Import from source\" to add them to a campaign.": "Tracking-Parameter (campaignid, adgroupid, keyword, tm, tml, sub1–3) werden einmalig an der Traffic-Quelle Google Ads deklariert — nutze „Aus Quelle importieren“, um sie einer Kampagne hinzuzufügen.",
  "Google Ads conversions": "Google-Ads-Conversions",
  "Outbound only: these HTTP calls notify another system after XPNSR records a conversion. Affiliate-network presets and inbound URLs belong on the Affiliate networks page and must be pasted into the partner dashboard — they are not forwarding rules.": "Nur ausgehend: Diese HTTP-Aufrufe benachrichtigen ein anderes System, nachdem XPNSR eine Conversion erfasst hat. Presets für Affiliate-Netzwerke und eingehende URLs gehören auf die Seite Affiliate-Netzwerke und müssen in das Partner-Dashboard eingefügt werden — sie sind keine Weiterleitungsregeln.",
  "Inbound partner setup: click-ID offer parameters, status mapping, and the postback URL to paste into the partner dashboard. This does not send leads to a CRM and is not campaign S2S forwarding.": "Eingehende Partner-Einrichtung: Click-ID-Offer-Parameter, Status-Mapping und die Postback-URL zum Einfügen in das Partner-Dashboard. Dies sendet keine Leads an ein CRM und ist kein S2S-Forwarding der Kampagne.",
  "Inbound postback URL template": "Vorlage für eingehende Postback-URL",
  "Inbound URL for the partner network to call when it reports lead, sale, reject, or another status. Copy this into the partner dashboard; XPNSR does not call this URL as an outgoing campaign postback.": "Eingehende URL, die das Affiliate-Netzwerk aufruft, wenn es einen Lead, eine Sale, eine Ablehnung oder einen anderen Status meldet. Kopiere diese in das Partner-Dashboard; XPNSR ruft diese URL nicht als ausgehenden Kampagnen-Postback auf.",
  "Pick an inbound postback preset or configure the partner contract from scratch. For form-to-CRM lead delivery, create an Integration and attach it to the offer instead.": "Wähle eine Vorlage für eingehende Postbacks oder konfiguriere den Partnervertrag von Grund auf. Für die Lead-Übermittlung vom Formular ans CRM erstelle stattdessen eine Integration und verknüpfe sie mit dem Offer.",
  "Google Ads deposit postback added + click-time gtag kept off — press Save to apply": "Einzahlungs-Postback für Google Ads hinzugefügt + gtag beim Klick weiterhin deaktiviert — klicke auf Speichern, um es anzuwenden",
  "Legacy click-time conversion: fires on /r/ before any registration or deposit. Keep this disabled for lead/deposit optimization. Real leads are sent automatically from hosted landings after a successful /api/lead response.": "Alte Klick-Conversion: wird bei /r/ ausgelöst, bevor eine Registrierung oder Einzahlung stattfindet. Lass sie für die Lead-/Einzahlungsoptimierung deaktiviert. Echte Leads werden automatisch von gehosteten Landingpages nach einer erfolgreichen /api/lead-Antwort gesendet.",
  "Keep this OFF for real conversion optimization. Leads fire online from the hosted landing only after /api/lead succeeds; deposits can be forwarded below by S2S on the broker sale postback. Enabling this makes Google optimize on clicks and can double-count conversions.": "Lass dies für echte Conversion-Optimierung DEAKTIVIERT. Leads werden online erst von der gehosteten Landingpage ausgelöst, nachdem /api/lead erfolgreich war; Einzahlungen können unten per S2S über den Broker-Sale-Postback weitergeleitet werden. Wenn du dies aktivierst, optimiert Google nach Klicks und Conversions können doppelt gezählt werden.",
  "Adds only the deposit/Purchase S2S postback. It fires on the broker sale postback and matches the Google click by {gclid}. The account id and deposit label come from the per-click {tm} tag (AW-<account>/<deposit-label>) in the ad Final URL suffix.": "Fügt nur den Einzahlungs-/Kauf-S2S-Postback hinzu. Er wird beim Broker-Sale-Postback ausgelöst und ordnet den Google-Klick anhand von {gclid} zu. Die Konto-ID und das Einzahlungslabel stammen aus dem {tm}-Tag pro Klick (AW-<account>/<deposit-label>) im Suffix der finalen Anzeigen-URL.",
  "Deposit → Purchase (with payout value) — fires on sale": "Einzahlung → Kauf (mit Payout-Wert) — wird bei Sale ausgelöst",
  "Lead S2S is intentionally not added: the hosted landing already sends the Lead conversion online via client-side gtag after the CRM accepts /api/lead. Adding a lead S2S rule would risk double-counting the same lead.": "Lead-S2S wird absichtlich nicht hinzugefügt: Die gehostete Landingpage sendet die Lead-Conversion bereits online per Client-seitigem gtag, nachdem das CRM /api/lead akzeptiert hat. Eine Lead-S2S-Regel würde riskieren, denselben Lead doppelt zu zählen.",
  "For online leads, pass tml=AW-<account>/<lead-label> in each ad account Final URL suffix. Keep \"Fire Google Ads gtag on redirect\" OFF: the tracker injects a separate lead gtag into hosted landings and fires it only after a successful lead submission. Configure Lead as Primary when bidding on leads; keep Purchase secondary until deposit reporting is verified, then adjust goals to your bidding strategy.": "Übergib bei Online-Leads tml=AW-<account>/<lead-label> im Final-URL-Suffix jedes Werbekontos. Lass \"Google Ads gtag beim Redirect feuern\" AUS: Der Tracker fügt ein separates Lead-gtag in gehostete Landingpages ein und feuert es erst nach erfolgreicher Lead-Übermittlung. Konfiguriere Lead als Primary, wenn du auf Leads bietest; halte Purchase sekundär, bis das Deposit-Reporting verifiziert ist, und passe die Ziele dann an deine Bidding-Strategie an.",
  "Sends the Google Ads conversion server-side on the broker postback, matched by {gclid} — no gtag on the landing and no API. Account id and label are read from the {tm} tag (AW-<account>/<label>) you already put in the ad Final URL suffix.": "Sendet die Google Ads Conversion serverseitig beim Broker-Postback, abgeglichen per {gclid} — kein gtag auf der Landingpage und keine API. Account-ID und Label werden aus dem {tm}-Tag (AW-<account>/<label>) gelesen, das du bereits im Final-URL-Suffix der Anzeige hinterlegt hast.",
  "Deposit → Purchase (primary, with value) — fires on sale": "Deposit → Purchase (primär, mit Wert) — feuert bei Sale",
  "Registration → Lead (secondary) — fires on lead": "Registrierung → Lead (sekundär) — feuert bei Lead",
  "For the Lead tag add its label to the ad Final URL suffix as tml=<label> (same AW account). If tml is empty the Lead beacon is skipped automatically. Keep Lead as Secondary in Google so optimization stays on deposits.": "Füge für das Lead-Tag dessen Label im Final-URL-Suffix der Anzeige als tml=<label> hinzu (gleiches AW-Konto). Ist tml leer, wird der Lead-Beacon automatisch übersprungen. Halte Lead in Google als Sekundär, damit die Optimierung auf Deposits bleibt.",
  "Test integration": "Integration testen",
  "Test lead accepted": "Test-Lead akzeptiert",
  "Test lead not accepted": "Test-Lead nicht akzeptiert",
  "This permanently deletes all matching clicks and conversions. This cannot be undone.": "Dies löscht dauerhaft alle übereinstimmenden Clicks und Conversions. Dies kann nicht rückgängig gemacht werden.",
  "This permanently deletes the conversion type. Existing conversions keep their stored status.": "Dies löscht den Conversion-Typ dauerhaft. Bestehende Conversions behalten ihren gespeicherten Status.",
  "This permanently deletes the metric column from reports.": "Dies löscht die Metrik-Spalte dauerhaft aus den Reports.",
  "This permanently deletes the saved report definition.": "Dies löscht die gespeicherte Report-Definition dauerhaft.",
  "This permanently deletes the scheduled report.": "Dies löscht den geplanten Report dauerhaft.",
  "This removes the manual cost and reverses its contribution to the campaign spend.": "Dies entfernt die manuellen Kosten und macht deren Beitrag zum Kampagnen-Spend rückgängig.",
  "Thursday": "Donnerstag",
  "To": "Bis",
  "Total leads": "Leads gesamt",
  "Tracking domains are managed on the Domains page — add and verify a custom domain there.": "Tracking-Domains werden auf der Seite Domains verwaltet — füge dort eine eigene Domain hinzu und verifiziere sie.",
  "Traffic Simulation": "Traffic-Simulation",
  "Traffic loss %": "Traffic-Verlust %",
  "Traffic trends": "Traffic-Trends",
  "Transition rules: which statuses a conversion in this type may move to. Leave all unchecked to allow any transition.": "Übergangsregeln: In welche Status eine Conversion dieses Typs wechseln darf. Lass alles ungewählt, um jeden Übergang zuzulassen.",
  "Treat empty User-Agent as bot": "Leeren User-Agent als Bot behandeln",
  "Trends": "Trends",
  "Tuesday": "Dienstag",
  "US, CA, GB": "US, CA, GB",
  "US, CA, GB, RU": "US, CA, GB, RU",
  "US, GB, DE": "US, GB, DE",
  "US,RU,DE": "US,RU,DE",
  "Uniqueness method": "Unique-Methode",
  "Update reporting semantics and status transitions.": "Aktualisiere die Reporting-Semantik und Status-Übergänge.",
  "Update the formula, format or decimals.": "Aktualisiere die Formel, das Format oder die Dezimalstellen.",
  "Use a negative amount to book a correction.": "Verwende einen negativen Betrag, um eine Korrektur zu buchen.",
  "Viewer": "Viewer",
  "Visitor ID": "Visitor ID",
  "Wednesday": "Wednesday",
  "Weekly": "Wöchentlich",
  "Weights equalized": "Gewichte angeglichen",
  "White": "White",
  "Whitelist": "Whitelist",
  "Whitelisted": "Whitelisted",
  "X-Requested-With": "X-Requested-With",
  "analyst": "analyst",
  "box/goal id": "box/goal id",
  "buy, cheap, discount": "kaufen, günstig, Rabatt",
  "cpa, nutra, en": "cpa, nutra, en",
  "day": "Tag",
  "days": "Tage",
  "e.g. Q3 influencer flat fee": "z. B. Influencer-Pauschale Q3",
  "e.g. Second deposit": "z. B. Zweite Einzahlung",
  "e.g. Unique CR": "z. B. Unique CR",
  "e.g. Weekly digest": "z. B. Wöchentliche Übersicht",
  "e.g. Weekly performance": "z. B. Wöchentliche Performance",
  "email / phone / name": "E-Mail / Telefon / Name",
  "free, demo": "kostenlos, Demo",
  "redirect": "Weiterleitung",
  "statuses on schedule": "Status nach Zeitplan",
  "Remove variant": "Variante entfernen",
  "Start test": "Test starten",
  "Pause test": "Test pausieren",
  "View test results": "Testergebnisse ansehen",
  "Remove parameter": "Parameter entfernen",
  "Remove status mapping": "Status-Zuordnung entfernen",
  "Copy postback URL template": "Postback-URL-Vorlage kopieren",
  "Copy inbound postback URL": "Eingehende Postback-URL kopieren",
  "Remove IP from blacklist": "IP aus der Blacklist entfernen",
  "Remove IP from whitelist": "IP aus der Whitelist entfernen",
  "Copy curl command": "curl-Befehl kopieren",
  "Copy JS snippet": "JS-Snippet kopieren",
  "Copy snippet": "Snippet kopieren",
  "Remove postback": "Postback entfernen",
  "Campaign actions": "Kampagnenaktionen",
  "Remove vendor": "Anbieter entfernen",
  "Remove campaign": "Kampagne entfernen",
  "Remove value": "Wert entfernen",
  "Remove field": "Feld entfernen",
  "Copy webhook URL": "Webhook-URL kopieren",
  "Copy landing page URL": "Landingpage-URL kopieren",
  "Open landing page": "Landingpage öffnen",
  "Remove partner route": "Partner-Route entfernen",
  "Copy lead-form URL": "Lead-Form-URL kopieren",
  "Copy offer URL": "Offer-URL kopieren",
  "Delete list entry": "Listeneintrag löschen",
  "Copy secret": "Secret kopieren",
  "Remove time range": "Zeitfenster entfernen",
  "Remove date range": "Datumsbereich entfernen",
  "Pause stream": "Stream pausieren",
  "Resume stream": "Stream fortsetzen",
  "Open redirect URL": "Weiterleitungs-URL öffnen",
  "Open offer URL": "Offer-URL öffnen",
  "Copy postback URL": "Postback-URL kopieren",
  "Delete rule": "Regel löschen",
  "Delete filter": "Filter löschen",
  "Delete traffic rule": "Traffic-Regel löschen",
  "This permanently deletes the traffic rule. Traffic will fall through to the remaining rules or the campaign default.": "Dies löscht die Traffic-Regel dauerhaft. Der Traffic fällt dann an die verbleibenden Regeln oder den Kampagnen-Standard zurück.",
  "Delete fraud filter": "Betrugsfilter löschen",
  "This permanently deletes the fraud filter. Traffic it currently blocks or scores will no longer be evaluated by this rule.": "Dies löscht den Fraud-Filter dauerhaft. Traffic, den er derzeit blockiert oder bewertet, wird nicht mehr von dieser Regel geprüft.",
  "Action (no page — hand off to the offer)": "Action (keine Seite — Weiterleitung direkt zum Offer)",
  "After click (at redirect)": "Nach dem Klick (beim Redirect)",
  "Before click (at landing — enables offer macros)": "Vor dem Klick (auf der Landingpage — aktiviert Offer-Makros)",
  "Match the mobile carrier from the edge X-Carrier header. Masks, /regex/ and @empty supported — e.g. Vodafone*, /^T-Mobile/.": "Gleicht den Mobilfunkanbieter anhand des X-Carrier-Headers vom Edge ab. Masken, /regex/ und @empty werden unterstützt — z. B. Vodafone*, /^T-Mobile/.",
  "Mobile operator / carrier": "Mobilfunkanbieter",
  "Offer selection moment": "Zeitpunkt der Offer-Auswahl",
  "Preload (serve the page from the tracker domain)": "Preload (Seite von der Tracker-Domain ausliefern)",
  "Preload fetches the page server-side and serves it under your tracker domain; Action shows nothing and lets the stream pick an offer.": "Preload lädt die Seite serverseitig und liefert sie unter deiner Tracker-Domain aus; Action zeigt nichts an und lässt den Stream ein Offer wählen.",
  "QR code": "QR-Code",
  "Redirect (send visitor to the URL)": "Redirect (Besucher zur URL weiterleiten)",
  "Remote rotator (fetch target)": "Remote-Rotator (Ziel abrufen)",
  "Scan to open the tracking link on a device.": "Scannen, um den Tracking-Link auf einem Gerät zu öffnen.",
  "Transparent (server-side fetch)": "Transparent (serverseitiger Abruf)",
  "When to pick the offer for this stream. After (default): at redirect time. Before: at landing-serve time, so {offer_name} / {offer_value:*} macros render on the landing page.": "Wann das Offer für diesen Stream gewählt wird. Nach (Standard): beim Redirect. Vor: beim Ausliefern der Landingpage, sodass die Makros {offer_name} / {offer_value:*} auf der Landingpage gerendert werden.",
  "Added to favourites": "Zu Favoriten hinzugefügt",
  "Credentials and settings for this partner. Fields marked * are required.": "Zugangsdaten und Einstellungen für diesen Partner. Mit * markierte Felder sind erforderlich.",
  "Key created": "Schlüssel erstellt",
  "Removed from favourites": "Aus Favoriten entfernt",
  "Affiliate network archived": "Affiliate-Netzwerk archiviert",
  "Archive affiliate network": "Affiliate-Netzwerk archivieren",
  "Archive landing page": "Landingpage archivieren",
  "Archive offer": "Offer archivieren",
  "Archive stream": "Stream archivieren",
  "Archive traffic source": "Traffic-Quelle archivieren",
  "Archived at": "Archiviert am",
  "Archived items are hidden from your lists. Restore them or delete them permanently.": "Archivierte Elemente werden in deinen Listen ausgeblendet. Stelle sie wieder her oder lösche sie endgültig.",
  "Delete permanently": "Endgültig löschen",
  "Deleted permanently": "Endgültig gelöscht",
  "Error loading archive": "Fehler beim Laden des Archivs",
  "Error restoring": "Fehler beim Wiederherstellen",
  "Landing page archived": "Landingpage archiviert",
  "No archived items": "Keine archivierten Elemente",
  "Offer archived": "Offer archiviert",
  "Restored": "Wiederhergestellt",
  "Stream archived": "Stream archiviert",
  "This will move \"{name}\" to the archive. You can restore it or delete it permanently from the Archive page.": "Dadurch wird \"{name}\" ins Archiv verschoben. Du kannst es auf der Archiv-Seite wiederherstellen oder endgültig löschen.",
  "This will permanently delete \"{name}\". This action cannot be undone.": "Dadurch wird \"{name}\" endgültig gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
  "Traffic source archived": "Traffic-Quelle archiviert",
  "View archived": "Archiv ansehen",
  "Start date is required": "Startdatum ist erforderlich",
  "Enter a valid cost": "Gib gültige Kosten ein",
  "Updated {n} clicks": "{n} Klicks aktualisiert",
  "Failed to update costs": "Kosten konnten nicht aktualisiert werden",
  "Statistics deleted": "Statistik gelöscht",
  "Failed to delete statistics": "Statistik konnte nicht gelöscht werden",
  "Maintenance & costs": "Wartung und Kosten",
  "Retroactively rewrite click costs, reset statistics, or grab an alternative tracking link.": "Schreibe Klickkosten rückwirkend um, setze Statistiken zurück oder hol dir einen alternativen Tracking-Link.",
  "Update costs": "Kosten aktualisieren",
  "Retroactively (re)write per-click cost for clicks in a time range. Total mode spreads the amount across matched clicks; per-click applies it to each.": "Schreibt die Kosten pro Klick für Klicks in einem Zeitraum rückwirkend (neu). Der Modus Total verteilt den Betrag auf die passenden Klicks; pro Klick wendet ihn auf jeden einzeln an.",
  "Start date": "Startdatum",
  "End date": "Enddatum",
  "Total (spread across clicks)": "Total (auf Klicks verteilen)",
  "Per click": "Pro Klick",
  "Only unique clicks": "Nur Unique-Klicks",
  "Skip bot clicks": "Bot-Klicks überspringen",
  "Clean statistics": "Statistik bereinigen",
  "Alternative link prefixes": "Alternative Link-Präfixe",
  "Any of these path prefixes route the same tracking id — rotate them across sources to dodge blocklists.": "Jedes dieser Pfadpräfixe leitet dieselbe Tracking-ID — rotiere sie über die Traffic-Quellen, um Blocklisten zu umgehen.",
  "Delete statistics": "Statistik löschen",
  "This permanently deletes all clicks and conversions for this campaign. The campaign configuration is kept. This cannot be undone.": "Dadurch werden alle Klicks und Conversions dieser Kampagne endgültig gelöscht. Die Kampagnenkonfiguration bleibt erhalten. Dies kann nicht rückgängig gemacht werden.",
  "Error loading S2S log": "Fehler beim Laden des S2S-Logs",
  "S2S postback log": "S2S-Postback-Log",
  "Every outbound conversion postback fired across your campaigns — filter by campaign, status or result.": "Jeder ausgehende Conversion-Postback, der über deine Kampagnen ausgelöst wurde — filtere nach Kampagne, Status oder Ergebnis.",
  "Any result": "Beliebiges Ergebnis",
  "Outbound conversion postbacks will appear here once your campaigns start forwarding conversions.": "Ausgehende Conversion-Postbacks erscheinen hier, sobald deine Kampagnen Conversions weiterleiten.",
  "Result": "Ergebnis",
  "HTTP": "HTTP",
  "Error loading system status": "Fehler beim Laden des Systemstatus",
  "Paste the Tor exit list first": "Füge zuerst die Tor-Exit-Liste ein",
  "Tor exit list updated": "Tor-Exit-Liste aktualisiert",
  "Failed to update Tor exit list": "Aktualisierung der Tor-Exit-Liste fehlgeschlagen",
  "Process uptime, database size, data-processing queue and host metrics.": "Prozess-Uptime, Datenbankgröße, Verarbeitungswarteschlange und Host-Metriken.",
  "Process": "Verarbeiten",
  "Uptime": "Uptime",
  "Started": "Gestartet",
  "Python": "Python",
  "Platform": "Plattform",
  "Database": "Datenbank",
  "Total documents": "Dokumente gesamt",
  "Data processing": "Datenverarbeitung",
  "Analytics backend": "Analytics-Backend",
  "Ingest mode": "Ingest-Modus",
  "Queue depth": "Warteschlangenlänge",
  "Click uniqueness": "Klick-Uniqueness",
  "Redis ping": "Redis-Ping",
  "Host": "Host",
  "Load average": "Systemlast",
  "Disk used": "Belegter Speicher",
  "Disk free": "Freier Speicher",
  "Cron": "Cron",
  "Last cost sync": "Letzter Kostenabgleich",
  "FX rates": "Wechselkurse",
  "No FX rates cached.": "Keine Wechselkurse im Cache.",
  "Tor exit list": "Tor-Exit-Liste",
  "Paste a newline-delimited Tor exit-node dump (e.g. from torbulkexitlist) to refresh the in-memory block list.": "Füge eine zeilenweise Liste von Tor-Exit-Nodes ein (z. B. aus torbulkexitlist), um die Sperrliste im Speicher zu aktualisieren.",
  "Replace list": "Liste ersetzen",
  "Error loading fingerprints": "Fehler beim Laden der Fingerprints",
  "Fingerprint updated": "Fingerprint aktualisiert",
  "Failed to update fingerprint": "Fingerprint konnte nicht aktualisiert werden",
  "JA3 / JA4 fingerprint overrides — mark a fingerprint as good or bad to steer bot detection.": "JA3-/JA4-Fingerprint-Overrides — markiere einen Fingerprint als gut oder schlecht, um die Bot-Erkennung zu steuern.",
  "All classifications": "Alle Klassifizierungen",
  "All kinds": "Alle Arten",
  "No fingerprint overrides yet": "Noch keine Fingerprint-Overrides",
  "As traffic arrives, JA3/JA4 fingerprints appear here so you can mark known-good or known-bad clients.": "Sobald Traffic eingeht, erscheinen hier JA3/JA4-Fingerprints, damit du bekannte gute oder schlechte Clients markieren kannst.",
  "Fingerprint": "Fingerprint",
  "Kind": "Typ",
  "Label": "Label",
  "Hits": "Hits",
  "Last seen": "Zuletzt gesehen",
  "Classification": "Klassifizierung",
  "Telegram alerts": "Telegram-Warnungen",
  "Deploy + server-error notifications for the operator.": "Deploy- und Serverfehler-Benachrichtigungen für den Betreiber.",
  "Configured": "Konfiguriert",
  "Not configured": "Nicht eingerichtet",
  "Topic": "Thema",
  "Topic ID (optional)": "Topic-ID (optional)",
  "Leave the token empty to keep the saved one.": "Lass das Token leer, um das gespeicherte zu behalten.",
  "Save & send test": "Speichern und Test senden",
  "Test message delivered": "Testnachricht zugestellt",
  "Send failed": "Senden fehlgeschlagen",
  "Chat ID is required": "Chat-ID ist erforderlich",
  "Nightly DB backups": "Nächtliche DB-Backups",
  "A full copy of the database every night, kept on the persistent volume.": "Jede Nacht eine vollständige Kopie der Datenbank, gespeichert auf dem persistenten Volume.",
  "Daily at": "Täglich um",
  "Copies kept": "Aufbewahrte Kopien",
  "Stored": "Gespeichert",
  "Latest": "Neueste",
  "No backups yet": "Noch keine Backups",
  "Run backup now": "Backup jetzt starten",
  "Backup started — the result will arrive in the monitoring topic.": "Backup gestartet — das Ergebnis kommt im Monitoring-Thema an.",
  "Platform admin": "Plattform-Admin",
  "Operator": "Operator",
  "Cross-tenant back-office: accounts, access and platform health.": "Mandantenübergreifendes Backoffice: Konten, Zugriffe und Plattformzustand.",
  "Accounts": "Konten",
  "New sign-ups": "Neue Registrierungen",
  "Last 30 days": "Letzte 30 Tage",
  "Clicks (24h)": "Klicks (24h)",
  "Clicks (30d)": "Klicks (30d)",
  "Conversions (30d)": "Conversions (30d)",
  "Platform state": "Plattformstatus",
  "Self-signup": "Selbstregistrierung",
  "Open": "Öffnen",
  "Closed": "Geschlossen",
  "Controlled by the DISABLE_REGISTRATION variable on Railway.": "Gesteuert über die Variable DISABLE_REGISTRATION auf Railway.",
  "Root admins": "Root-Admins",
  "From PLATFORM_ADMIN_EMAILS — manage the list on Railway.": "Aus PLATFORM_ADMIN_EMAILS — die Liste wird auf Railway verwaltet.",
  "Granted admins": "Vergebene Admins",
  "Every registered account. Block access or grant platform admin.": "Alle registrierten Konten. Sperre den Zugriff oder vergib Plattform-Adminrechte.",
  "Search by email or name…": "Nach E-Mail oder Name suchen…",
  "Plan": "Plan",
  "Last click": "Letzter Klick",
  "No accounts found": "Keine Konten gefunden",
  "Root admin": "Root-Admin",
  "Client": "Client",
  "Managed on Railway": "Verwaltet auf Railway",
  "Grant platform admin": "Plattform-Admin vergeben",
  "Grant platform admin?": "Plattform-Admin vergeben?",
  "Make admin": "Zum Admin machen",
  "Revoke platform admin": "Plattform-Admin entziehen",
  "Revoke platform admin?": "Plattform-Admin entziehen?",
  "Revoke admin": "Admin entziehen",
  "Block account": "Konto sperren",
  "Block this account?": "Dieses Konto sperren?",
  "The user loses access immediately — every session is rejected until you unblock them. Their campaigns and tracking links keep serving traffic.": "Der Nutzer verliert sofort den Zugriff — jede Sitzung wird abgelehnt, bis du ihn entsperrst. Seine Kampagnen und Tracking-Links liefern weiterhin Traffic aus.",
  "Reason (optional)": "Grund (optional)",
  "Visible to admins only": "Nur für Admins sichtbar",
  "Unblock": "Entsperren",
  "Unblock account": "Konto entsperren",
  "Unblock this account?": "Dieses Konto entsperren?",
  "The user will be able to sign in again immediately.": "Der Nutzer kann sich sofort wieder anmelden.",
  "This user gets operator access: the platform back-office, every account, and platform settings. The grant is audit-logged.": "Dieser Nutzer erhält Betreiberzugriff: das Plattform-Backoffice, alle Konten und die Plattformeinstellungen. Die Vergabe wird im Audit-Log erfasst.",
  "The user keeps their account but loses operator access.": "Der Nutzer behält sein Konto, verliert aber den Betreiberzugriff.",
  "Account blocked": "Konto gesperrt",
  "Account unblocked": "Konto entsperrt",
  "Platform admin granted": "Plattform-Admin vergeben",
  "Platform admin revoked": "Plattform-Admin entzogen",
  "Failed to load platform overview": "Plattformübersicht konnte nicht geladen werden",
  "Failed to load users": "Nutzer konnten nicht geladen werden",
  "{count} accounts": "{count} Konten",
  "Page {page} of {total}": "Seite {page} von {total}",
  "Change plan": "Tarif ändern",
  "Plan updated": "Tarif aktualisiert",
  "Sets the edition directly (status \"active\", no trial) — for manual and comp accounts. Accounts with a live Stripe subscription must change plans through Stripe.": "Setzt die Edition direkt (Status „active“, ohne Testphase) — für manuelle und kostenlose Konten. Konten mit einem aktiven Stripe-Abo müssen den Tarif über Stripe wechseln.",
  "Account deleted": "Konto gelöscht",
  "Delete account": "Konto löschen",
  "Delete this account permanently?": "Dieses Konto endgültig löschen?",
  "This wipes the account and ALL of its data — campaigns, clicks, conversions, offers, landings, domains, reports. It cannot be undone.": "Damit werden das Konto und ALLE seine Daten gelöscht — Kampagnen, Klicks, Conversions, Offers, Landingpages, Domains, Reports. Das lässt sich nicht rückgängig machen.",
  "We sent a confirmation link to {email}. Open it to activate your account — the link is valid for 24 hours.": "Wir haben einen Bestätigungslink an {email} gesendet. Öffne ihn, um dein Konto zu aktivieren — der Link ist 24 Stunden gültig.",
  "Check your spam folder if it doesn't arrive within a minute.": "Sieh in deinem Spam-Ordner nach, falls sie nicht innerhalb einer Minute ankommt.",
  "Resend the email": "E-Mail erneut senden",
  "Sent — check your inbox": "Gesendet — sieh in deinem Posteingang nach",
  "Could not resend the email — try again.": "Die E-Mail konnte nicht erneut gesendet werden — versuch es noch einmal.",
  "Back to sign in": "Zurück zur Anmeldung",
  "Confirming your email…": "Deine E-Mail wird bestätigt…",
  "This takes a second.": "Das dauert nur eine Sekunde.",
  "Email confirmed — welcome aboard!": "E-Mail bestätigt — willkommen an Bord!",
  "Taking you to your dashboard…": "Du wirst zu deinem Dashboard weitergeleitet…",
  "Verification failed — the link may have expired.": "Verifizierung fehlgeschlagen — der Link ist möglicherweise abgelaufen.",
  "The verification link is incomplete — open the link from the email again.": "Der Verifizierungslink ist unvollständig — öffne den Link aus der E-Mail erneut.",
  "Use 8–128 characters; long passphrases are recommended": "Verwende 8–128 Zeichen; lange Passphrasen werden empfohlen",
  "Users": "Benutzer",
  "Error": "Fehler",
  "Failed to load documentation.": "Dokumentation konnte nicht geladen werden.",
  "Production readiness": "Produktionsreife",
  "Ready": "Bereit",
  "Attention required": "Achtung erforderlich",
  "Secret-free checks for runtime configuration and isolation controls.": "Secret-freie Prüfungen für Laufzeitkonfiguration und Isolationskontrollen.",
  "Environment": "Umgebung",
  "production": "Produktion",
  "development": "Entwicklung",
  "Rate limiter": "Rate-Limiter",
  "Access token TTL": "Gültigkeitsdauer des Access-Tokens",
  "Backend root": "Backend als Root",
  "Blocking checks": "Blockierende Prüfungen",
  "Failed to load integrity status": "Integritätsstatus konnte nicht geladen werden",
  "Traffic suspended": "Traffic ausgesetzt",
  "Traffic resumed": "Traffic fortgesetzt",
  "Data integrity": "Datenintegrität",
  "Mandatory unique indexes protect click attribution, conversions and billing idempotency.": "Verpflichtende eindeutige Indizes schützen die Click-Attribution, Conversions und die Idempotenz der Abrechnung.",
  "All mandatory indexes are present and unique.": "Alle erforderlichen Indizes sind vorhanden und eindeutig.",
  "Do not ignore this warning. Review backend startup logs before changing indexes.": "Ignoriere diese Warnung nicht. Prüfe die Backend-Startprotokolle, bevor du Indizes änderst.",
  "Missing": "Fehlt",
  "Not unique": "Nicht eindeutig",
  "Resume campaign traffic": "Kampagnen-Traffic fortsetzen",
  "Resume traffic": "Traffic fortsetzen",
  "Suspend campaign traffic": "Kampagnen-Traffic aussetzen",
  "Suspend traffic": "Traffic aussetzen",
  "Suspend all campaign traffic for this account?": "Gesamten Kampagnen-Traffic für dieses Konto aussetzen?",
  "Public tracking links will return the same inactive-campaign response. Campaign settings stay unchanged, and traffic can be resumed instantly.": "Öffentliche Tracking-Links liefern dieselbe Antwort wie bei inaktiven Kampagnen. Die Kampagneneinstellungen bleiben unverändert, und der Traffic kann sofort wieder fortgesetzt werden.",
  "Resume campaign traffic for this account?": "Kampagnen-Traffic für dieses Konto fortsetzen?",
  "Existing active campaigns and tracking links will start serving again.": "Bestehende aktive Kampagnen und Tracking-Links werden wieder bedient.",
  "Password changed — other devices have been signed out": "Passwort geändert — andere Geräte wurden abgemeldet",
  "Sign out of every device, including this one? You will need to sign in again.": "Auf allen Geräten abmelden, einschließlich diesem? Du musst dich danach erneut anmelden.",
  "All sessions signed out": "Alle Sitzungen abgemeldet",
  "Error signing out sessions": "Fehler beim Abmelden der Sitzungen",
  "Changing your password also signs out every other device.": "Das Ändern deines Passworts meldet dich auch auf allen anderen Geräten ab.",
  "Active sessions": "Aktive Sitzungen",
  "Lost a laptop, or think someone else has your password? End every session at once.": "Laptop verloren oder vermutest du, dass jemand dein Passwort kennt? Beende alle Sitzungen auf einmal.",
  "This signs out every device, including this one. Signing back in takes one password.": "Dies meldet dich auf allen Geräten ab, einschließlich diesem. Für die erneute Anmeldung genügt das Passwort.",
  "Sign out everywhere": "Überall abmelden",
  "Pages": "Seiten",
  "Copy path": "Pfad kopieren",
  "Choose your plan": "Wähle deinen Plan",
  "Every plan includes the whole tracker.": "Jeder Plan enthält den gesamten Tracker.",
  "{n} days free": "{n} Tage kostenlos",
  "Billed today": "Heute fällig",
  "Continue": "Weiter",
  "Start and Pro: {n} days free, card required. Charged automatically on day {next} unless you cancel. One free trial per account.": "Start und Pro: {n} Tage kostenlos, Karte erforderlich. Wird am Tag {next} automatisch abgebucht, sofern du nicht kündigst. Eine kostenlose Testphase pro Konto.",
  "Could not load plans.": "Pläne konnten nicht geladen werden.",
  "Try again": "Erneut versuchen",
  "Opening secure payment…": "Sichere Zahlung wird geöffnet…",
  "Could not open the payment page. Choose a plan to continue.": "Die Zahlungsseite konnte nicht geöffnet werden. Wähle einen Plan, um fortzufahren.",
  "Start and Pro come with {n} days free. A card is required up front: Stripe checks it but charges nothing until day {next}, then the plan renews automatically. Cancel any time before the trial ends and you pay nothing. Team and Network are billed on the day you subscribe. One free trial per account.": "Start und Pro beinhalten {n} Tage kostenlos. Eine Karte wird vorab benötigt: Stripe prüft sie, bucht aber erst ab Tag {next} ab, danach verlängert sich der Plan automatisch. Kündige jederzeit vor Ablauf der Testphase und du zahlst nichts. Team und Network werden am Tag der Anmeldung abgerechnet. Eine kostenlose Testphase pro Konto.",
  "Choose a plan to open your workspace.": "Wähle einen Plan, um deinen Workspace zu öffnen.",
  "Payment was not completed. Choose a plan to continue.": "Die Zahlung wurde nicht abgeschlossen. Wähle einen Plan, um fortzufahren.",
  "Confirming your payment…": "Deine Zahlung wird bestätigt…",
  "Payment received, but confirmation is taking longer than usual. Refresh this page in a minute.": "Zahlung erhalten, aber die Bestätigung dauert länger als gewöhnlich. Aktualisiere diese Seite in einer Minute.",
  "Payment confirmed. Welcome aboard!": "Zahlung bestätigt. Willkommen an Bord!",
  "Free trial until {date}. Your card will be charged automatically on that day — nothing to do. Cancel before then in Manage billing and you pay nothing.": "Kostenlose Testphase bis {date}. Deine Karte wird an diesem Tag automatisch belastet — du musst nichts tun. Kündige vorher unter Abrechnung verwalten und du zahlst nichts.",
  "Start {n}-day free trial": "{n} Tage kostenlos starten",
  "Subscribe": "Abonnieren",
  "Your free trial has already been used, so this plan is billed today.": "Deine kostenlose Testphase wurde bereits genutzt, daher wird dieser Plan heute abgerechnet.",
  "To switch plans, contact support — we move you without losing paid days.": "Um den Plan zu wechseln, wende dich an den Support — wir übertragen dich, ohne bezahlte Tage zu verlieren.",
  "Everything in Network, on your own server or cloud, installed with one command. Unlimited users, domains and history.": "Alles aus Network, auf deinem eigenen Server oder in der Cloud, installiert mit einem einzigen Befehl. Unbegrenzte Nutzer, Domains und Verlauf.",
  "After payment you issue your licence key on the page Self-hosted and install the tracker yourself with one command, following the step-by-step guide. If you prefer, we set it up for you or move you off your old tracker. The hosting is billed to you by your provider.": "Nach der Zahlung erstellst du deinen Lizenzschlüssel auf der Seite Self-hosted und installierst den Tracker selbst mit einem Befehl, Schritt für Schritt nach Anleitung. Wenn du möchtest, richten wir ihn für dich ein oder migrieren dich von deinem alten Tracker. Das Hosting wird dir direkt von deinem Anbieter in Rechnung gestellt.",
  "Install on your own server": "Installation auf deinem eigenen Server",
  "Or we set it up for you, on request": "Oder wir richten es auf Wunsch für dich ein",
  "Your own server or a dedicated cloud, with a licence key.": "Dein eigener Server oder eine dedizierte Cloud, mit Lizenzschlüssel.",
  "Monthly or 12 months": "Monatlich oder 12 Monate",
  "Cannot reach the server. Check your connection and try again.": "Der Server ist nicht erreichbar. Prüfe deine Verbindung und versuche es erneut.",
  "Clicks are never counted": "Clicks werden nie gezählt",
  "However much traffic you send, the invoice does not move.": "Egal wie viel Traffic du schickst, die Rechnung bleibt gleich.",
  "Bots filtered on arrival": "Bots werden beim Eingang gefiltert",
  "Datacenter, VPN and proxy traffic is handled before a page loads.": "Datacenter-, VPN- und Proxy-Traffic wird abgefangen, bevor eine Seite lädt.",
  "First link in five minutes": "Erster Link in fünf Minuten",
  "Add a source, create a campaign, copy the link.": "Traffic-Quelle hinzufügen, Kampagne erstellen, Link kopieren.",
  "Your workspace": "Dein Workspace",
  "Everything is already running": "Alles läuft bereits",
  "Your workspace, your campaigns, your numbers.": "Dein Workspace, deine Kampagnen, deine Zahlen.",
  "Confirm your email": "Bestätige deine E-Mail",
  "Open the link we sent and your workspace is ready.": "Öffne den Link, den wir dir geschickt haben, und dein Workspace ist bereit.",
  "Enter your code": "Gib deinen Code ein",
  "Six digits from your authenticator app.": "Sechs Ziffern aus deiner Authenticator-App.",
  "Create your account": "Erstelle dein Konto",
  "Two fields and a password. Tracking is live in minutes.": "Zwei Felder und ein Passwort. Das Tracking läuft in wenigen Minuten.",
  "We sent a confirmation link to": "Wir haben einen Bestätigungslink gesendet an",
  "Check spam if it is not there within a minute. The link lasts 24 hours.": "Schau im Spam-Ordner nach, falls er nach einer Minute nicht da ist. Der Link ist 24 Stunden gültig.",
  "Sent again. Give it a moment.": "Erneut gesendet. Gib ihm einen Moment.",
  "Sending": "Wird gesendet",
  "Use a different account": "Anderes Konto verwenden",
  "Verification code": "Bestätigungscode",
  "Checking": "Wird geprüft",
  "Signing in": "Anmeldung läuft",
  "Your name": "Dein Name",
  "At least 8 characters.": "Mindestens 8 Zeichen.",
  "Creating": "Wird erstellt",
  "Continue with": "Weiter mit",
  "No account yet?": "Noch kein Konto?",
  "Create one": "Konto erstellen",
  "New accounts are closed at the moment.": "Neue Konten sind derzeit geschlossen.",
  "Terms": "Nutzungsbedingungen",
  "and": "und",
  "Privacy": "Datenschutz",
  "History kept forever": "Historie unbegrenzt",
  "Light theme": "Helles Design",
  "Dark theme": "Dunkles Design",
  "Match system": "Wie das System",
  "Theme": "Theme",
  "Navigate": "Navigieren",
  "Not included on your plan. Open Billing to upgrade.": "In deinem Plan nicht enthalten. Öffne Abrechnung, um zu upgraden.",
  "Talk to us": "Talk to us",
  "Automatic flow optimiser": "Automatischer Flow-Optimierer",
  "Learning bot detection": "Lernende Bot-Erkennung",
  "Lead forms into a CRM": "Lead-Formulare ins CRM",
  "Roles and 31 permissions": "Rollen und 31 Berechtigungen",
  "Single sign on": "Single Sign-on",
  "We move you off your old tracker": "Wir migrieren dich von deinem alten Tracker",
  "90 days of history": "90 Tage Historie",
  "1 year of history": "1 Jahr Historie",
  "2 years of history": "2 Jahre Historie",
  "History kept": "Aufbewahrte Historie",
  "Your first campaigns, with nothing to set up.": "Deine ersten Kampagnen, ganz ohne Einrichtung.",
  "Everything that makes the work run itself.": "Alles, was die Arbeit von selbst laufen lässt.",
  "A team, with roles and a paper trail.": "Ein Team, mit Rollen und Nachverfolgbarkeit.",
  "A network, under your own brand.": "Ein Netzwerk, unter deiner eigenen Marke.",
  "Run the tracker on your own server or in a dedicated cloud. Your licence key activates one production server and one test server.": "Betreibe den Tracker auf deinem eigenen Server oder in einer dedizierten Cloud. Dein Lizenzschlüssel aktiviert einen Produktivserver und einen Testserver.",
  "Self-hosted installs come with the Enterprise plan. Servers activated earlier stop once their current licence runs out.": "Self-hosted-Installationen sind im Enterprise-Plan enthalten. Zuvor aktivierte Server stoppen, sobald ihre aktuelle Lizenz abläuft.",
  "This is the only time the key is shown. Store it somewhere safe: you enter it when you install the tracker.": "Der Schlüssel wird nur dieses eine Mal angezeigt. Bewahre ihn sicher auf: Du gibst ihn bei der Installation des Trackers ein.",
  "A new key replaces the current one at once. Servers that still use the old key cannot renew their licence and stop within {days} days unless you enter the new key on them.": "Ein neuer Schlüssel ersetzt den aktuellen sofort. Server, die noch den alten Schlüssel verwenden, können ihre Lizenz nicht erneuern und stoppen innerhalb von {days} Tagen, sofern du nicht den neuen Schlüssel auf ihnen hinterlegst.",
  "The server loses its slot right away and stops within {days} days. Use this when you move the tracker to another server.": "Der Server verliert seinen Platz sofort und stoppt innerhalb von {days} Tagen. Nutze dies, wenn du den Tracker auf einen anderen Server umziehst.",
  "Each server checks in with us once a day and receives a licence valid for {days} days. If it cannot check in, or the subscription ends, it keeps working until that licence runs out and then stops. A test server is limited to {clicks} clicks a day. Only technical data is sent: licence, server id and version, never data about your traffic or your clients.": "Jeder Server meldet sich einmal täglich bei uns und erhält eine Lizenz, die {days} Tage gültig ist. Kann er sich nicht melden, oder endet das Abo, läuft er weiter, bis diese Lizenz abläuft, und stoppt dann. Ein Testserver ist auf {clicks} Klicks pro Tag begrenzt. Es werden nur technische Daten übertragen: Lizenz, Server-ID und Version, niemals Daten zu deinem Traffic oder deinen Kunden.",
  "Run this command as root on a fresh server. In about ten minutes it installs everything (Kubernetes, HTTPS certificates, the database and the tracker). Running it again upgrades the install and keeps the data.": "Führe diesen Befehl als root auf einem frischen Server aus. In etwa zehn Minuten installiert er alles (Kubernetes, HTTPS-Zertifikate, die Datenbank und den Tracker). Ein erneuter Aufruf aktualisiert die Installation und behält die Daten.",
  "Self-hosted": "Selbst gehostet",
  "Enterprise": "Enterprise",
  "Licence key": "Lizenzschlüssel",
  "Issue licence key": "Lizenzschlüssel ausstellen",
  "Rotate key": "Schlüssel rotieren",
  "Rotate licence key?": "Lizenzschlüssel rotieren?",
  "Licence key issued": "Lizenzschlüssel ausgestellt",
  "Server deactivated": "Server deaktiviert",
  "Deactivate this server?": "Diesen Server deaktivieren?",
  "Servers": "Server",
  "Production": "Produktion",
  "Revoked": "Widerrufen",
  "Deactivated": "Deaktiviert",
  "Deactivate": "Deaktivieren",
  "Issued": "Ausgestellt",
  "Version": "Version",
  "See plans": "Tarife ansehen",
  "No servers activated yet.": "Noch keine Server aktiviert.",
  "Transfers left (30 days)": "Verbleibende Übertragungen (30 Tage)",
  "Could not load this page.": "Diese Seite konnte nicht geladen werden.",
  "Licensing is temporarily unavailable. Try again later.": "Die Lizenzierung ist vorübergehend nicht verfügbar. Versuch es später erneut.",
  "Your server: 4 CPU cores, 8 GB RAM, 50 GB SSD, Ubuntu or Debian (x86-64). The tracker installs with one command.": "Dein Server: 4 CPU-Kerne, 8 GB RAM, 50 GB SSD, Ubuntu oder Debian (x86-64). Der Tracker wird mit einem einzigen Befehl installiert.",
  "Put your licence key in place of the X: it is shown once, when you issue or rotate it.": "Setze deinen Lizenzschlüssel anstelle der X ein: Er wird nur einmal angezeigt, wenn du ihn ausstellst oder erneuerst.",
  "The first account signed up with this email gets administrator rights on the server.": "Das erste Konto, das mit dieser E-Mail-Adresse registriert wird, erhält Administratorrechte auf dem Server.",
  "Without --domain the tracker starts on an address like 1-2-3-4.sslip.io. For your own domain, first point tracker.example.com and api.tracker.example.com at the server, then add --domain tracker.example.com.": "Ohne --domain startet der Tracker unter einer Adresse wie 1-2-3-4.sslip.io. Für deine eigene Domain richte zuerst tracker.example.com und api.tracker.example.com auf den Server aus und füge dann --domain tracker.example.com hinzu.",
  "Install on your server": "Auf deinem Server installieren",
  "Server requirements": "Serveranforderungen",
  "Production server": "Produktionsserver",
  "Test server": "Testserver",
  "Operating system": "Betriebssystem",
  "Disk space": "Speicherplatz",
  "Connection": "Connection",
  "Ubuntu 22.04 / 24.04 or Debian 12, x86-64": "Ubuntu 22.04 / 24.04 or Debian 12, x86-64",
  "4 cores (2 at least)": "4 Kerne (mindestens 2)",
  "8 GB (4 GB at least)": "8 GB (mindestens 4 GB)",
  "50 GB SSD (30 GB free at least)": "50 GB SSD (mindestens 30 GB frei)",
  "Public IP address, ports 80 and 443 open": "Öffentliche IP-Adresse, Ports 80 und 443 offen",
  "After the install": "Nach der Installation",
  "Server state and licence": "Serverstatus und Lizenz",
  "Upgrade to the newest signed release": "Auf die neueste signierte Version aktualisieren",
  "Back up the database to /var/backups/xpnsr": "Datenbank sichern unter /var/backups/xpnsr",
  "Copy command": "Befehl kopieren",
  "Install the tracker on your own server in about 15 minutes. You do not need to know Kubernetes or Linux: you copy one command and the installer does the rest.": "Installiere den Tracker in etwa 15 Minuten auf deinem eigenen Server. Du musst weder Kubernetes noch Linux kennen: Du kopierst einen Befehl, und der Installer erledigt den Rest.",
  "Install guide": "Installationsanleitung",
  "Step-by-step guide": "Schritt-für-Schritt-Anleitung",
  "Back to Self-hosted": "Zurück zu Selbst gehostet",
  "Step": "Step",
  "Get a server": "Einen Server besorgen",
  "Optional: your own domain": "Optional: deine eigene Domain",
  "Issue your licence key": "Lizenzschlüssel ausstellen",
  "Connect to the server": "Mit dem Server verbinden",
  "Run the install command": "Installationsbefehl ausführen",
  "Open your tracker": "Deinen Tracker öffnen",
  "Keep it running": "Am Laufen halten",
  "Rent a VPS or cloud server from any provider, for example Hetzner, DigitalOcean, OVH, Vultr or AWS Lightsail: 4 CPU cores, 8 GB RAM, 50 GB SSD, Ubuntu 24.04 (x86-64). It usually costs 15–60 USD a month, billed to you by the provider.": "Miete einen VPS oder Cloud-Server bei einem beliebigen Anbieter, zum Beispiel Hetzner, DigitalOcean, OVH, Vultr oder AWS Lightsail: 4 CPU-Kerne, 8 GB RAM, 50 GB SSD, Ubuntu 24.04 (x86-64). Das kostet meist 15–60 USD im Monat, die dir der Anbieter in Rechnung stellt.",
  "Take a fresh server with nothing else installed, and make sure ports 80 and 443 are open in the provider's firewall.": "Nimm einen frischen Server, auf dem nichts anderes installiert ist, und stelle sicher, dass die Ports 80 und 443 in der Firewall des Anbieters offen sind.",
  "Note the server's IP address and the root password or SSH key from the provider's panel.": "Notiere dir die IP-Adresse des Servers sowie das Root-Passwort oder den SSH-Schlüssel aus dem Panel des Anbieters.",
  "For your own address, create two DNS records of type A that point at the server's IP address, for example tracker.example.com and api.tracker.example.com. Skip this to start on a free address like 1-2-3-4.sslip.io; you can switch later.": "Für deine eigene Adresse lege zwei DNS-Einträge vom Typ A an, die auf die IP-Adresse des Servers zeigen, zum Beispiel tracker.example.com und api.tracker.example.com. Überspringe das, um mit einer kostenlosen Adresse wie 1-2-3-4.sslip.io zu starten; du kannst später wechseln.",
  "On the page Self-hosted click Issue licence key and save the key somewhere safe: it is shown only once.": "Klicke auf der Seite Self-Hosted auf Lizenzschlüssel ausstellen und speichere den Schlüssel an einem sicheren Ort: Er wird nur einmal angezeigt.",
  "On Mac or Linux open Terminal, on Windows open PowerShell, and type the command below with your server's IP address. Answer yes to the first question and enter the password.": "Öffne auf Mac oder Linux das Terminal, unter Windows PowerShell, und gib den folgenden Befehl mit der IP-Adresse deines Servers ein. Beantworte die erste Frage mit yes und gib das Passwort ein.",
  "Copy the command from the page Self-hosted (your key and email are already in it), paste it into the terminal and press Enter. For your own domain add --domain tracker.example.com to it.": "Kopiere den Befehl von der Seite Self-hosted (dein Key und deine E-Mail sind schon enthalten), füge ihn ins Terminal ein und drücke Enter. Für deine eigene Domain füge --domain tracker.example.com hinzu.",
  "The install takes about 10 minutes. If the connection drops, the install keeps going: reconnect and follow it with the command below.": "Die Installation dauert etwa 10 Minuten. Falls die Verbindung abbricht, läuft die Installation weiter: Verbinde dich erneut und verfolge sie mit dem folgenden Befehl.",
  "At the end the installer prints the address of your workspace. Open it and sign up with the administrator email from the command: that account gets administrator rights. The licence activates on its own.": "Am Ende zeigt der Installer die Adresse deines Workspace an. Öffne sie und registriere dich mit der Administrator-E-Mail aus dem Befehl: Dieses Konto erhält Administratorrechte. Die Lizenz aktiviert sich von selbst.",
  "To check everything, run the command below: the licence line should say \"state\":\"active\".": "Um alles zu prüfen, führe den folgenden Befehl aus: Die Lizenzzeile sollte \"state\":\"active\" anzeigen.",
  "Updates: the command below installs the newest signed release and keeps your data.": "Updates: Der folgende Befehl installiert die neueste signierte Version und behält deine Daten.",
  "Backups: the command below saves the database to /var/backups/xpnsr. Copy it off the server regularly and turn on your provider's snapshots.": "Backups: Der folgende Befehl speichert die Datenbank unter /var/backups/xpnsr. Kopiere sie regelmäßig vom Server und aktiviere die Snapshots deines Anbieters.",
  "Test server: install a second server the same way, choosing Test server on the page Self-hosted.": "Testserver: Installiere einen zweiten Server auf die gleiche Weise und wähle dabei Testserver auf der Seite Self-hosted.",
  "If something goes wrong": "Wenn etwas schiefgeht",
  "ports 80/443 are already in use": "ports 80/443 are already in use (Ports 80/443 bereits belegt)",
  "Another web server runs on this machine. Use a fresh server or stop that web server, then run the command again.": "Auf dieser Maschine läuft bereits ein anderer Webserver. Nutze einen frischen Server oder stoppe diesen Webserver und führe den Befehl erneut aus.",
  "The browser says the connection is not private": "Der Browser meldet, dass die Verbindung nicht privat ist",
  "The HTTPS certificate is issued a few minutes after DNS points at the server. Wait five minutes; the command below should show READY True.": "Das HTTPS-Zertifikat wird wenige Minuten ausgestellt, nachdem der DNS auf den Server zeigt. Warte fünf Minuten; der folgende Befehl sollte READY True anzeigen.",
  "The licence says the slot is in use": "Die Lizenz meldet, dass der Platz belegt ist",
  "The key is already active on another server. Deactivate that server on the page Self-hosted, then enter the key on the licence screen of your workspace, or wait up to an hour.": "Der Key ist bereits auf einem anderen Server aktiv. Deaktiviere diesen Server auf der Seite Self-hosted und gib den Key dann auf dem Lizenzbildschirm deines Workspace ein, oder warte bis zu einer Stunde.",
  "licence key not recognised": "licence key not recognised (Lizenzschlüssel nicht erkannt)",
  "Paste the key again exactly as saved, or rotate it on the page Self-hosted and use the new one.": "Füge den Key erneut genau so ein, wie er gespeichert wurde, oder erneuere ihn auf der Seite Self-hosted und verwende den neuen.",
  "Anything else": "Sonst noch etwas",
  "Run the install command again: it is always safe and continues where it stopped. If that does not help, send us the last lines of /var/log/xpnsr-install.log and the output of xpnsr status.": "Führe den Installationsbefehl erneut aus: Das ist immer sicher und setzt dort fort, wo er gestoppt wurde. Falls das nicht hilft, schick uns die letzten Zeilen von /var/log/xpnsr-install.log und die Ausgabe von xpnsr status.",
  "Prefer that we do it?": "Sollen wir das übernehmen?",
  "We install the tracker for you, or move you off your old tracker with your campaigns. You open the server in your own hosting account and give us temporary access; it is included in Enterprise.": "Wir installieren den Tracker für dich oder migrieren dich samt Kampagnen von deinem alten Tracker. Du richtest den Server in deinem eigenen Hosting-Account ein und gibst uns vorübergehend Zugriff; das ist in Enterprise enthalten.",
  "Write to us": "Schreib uns",
  "Fallback rules": "Fallback-Regeln",
  "Used only when a click matches none of the campaign streams. Set up routing in streams; keep these for rare catch-all cases.": "Wird nur verwendet, wenn ein Klick zu keinem der Kampagnen-Streams passt. Richte das Routing in den Streams ein; nutze dies nur für seltene Auffangfälle.",
  "Add the banner to your landing page": "Banner zur Landingpage hinzufügen",
  "Paste this line into the <head> of every landing page of the campaign. The banner shows only while it is enabled above, and only to visitors from the chosen regions.": "Füge diese Zeile in den <head> jeder Landingpage der Kampagne ein. Das Banner wird nur angezeigt, solange es oben aktiviert ist, und nur für Besucher aus den ausgewählten Regionen.",
  "Copy code": "Code kopieren",
  "No campaigns yet": "Noch keine Kampagnen",
  "Audience": "Audience",
  "Updated at {time}": "Aktualisiert um {time}",
  "Download ZIP": "ZIP herunterladen",
  "Download failed": "Download fehlgeschlagen",
  "Enter the licence key from your account (page Self-hosted). It activates this server, which then renews its licence once a day on its own.": "Gib den Lizenzschlüssel aus deinem Konto ein (Seite Self-hosted). Er aktiviert diesen Server, der danach seine Lizenz einmal täglich selbstständig erneuert.",
  "The licence of this installation has run out or is no longer valid, so the tracker is stopped. Check the Enterprise subscription and the key, then activate again.": "Die Lizenz dieser Installation ist abgelaufen oder nicht mehr gültig, daher ist der Tracker gestoppt. Prüfe das Enterprise-Abo und den Schlüssel und aktiviere erneut.",
  "The licence could not be renewed. The tracker keeps working until {date} and then stops unless a renewal succeeds.": "Die Lizenz konnte nicht erneuert werden. Der Tracker läuft weiter bis zum {date} und stoppt danach, falls die Erneuerung nicht gelingt.",
  "Test server: limited to {n} clicks a day.": "Testserver: begrenzt auf {n} Klicks pro Tag.",
  "This installation is not licensed. Ask the administrator to activate it.": "Diese Installation ist nicht lizenziert. Bitte den Administrator, sie zu aktivieren.",
  "Licence activated": "Lizenz aktiviert",
  "Licence expired": "Lizenz abgelaufen",
  "Activate this installation": "Diese Installation aktivieren",
  "Licensed to {who} · licence {id}": "Lizenziert für {who} · Lizenz {id}",
  "Live clicks": "Live-Klicks",
  "Open clicks log": "Klick-Log öffnen",
  "Could not load clicks": "Klicks konnten nicht geladen werden",
  "No clicks yet": "Noch keine Klicks",
  "Send traffic to a tracking link and every click shows up here as it happens.": "Schick Traffic an einen Tracking-Link, und jeder Klick erscheint hier in Echtzeit.",
  "cloaked": "cloaked",
  "proxy": "Proxy",
  "human": "Mensch",
  "{n}s ago": "vor {n} s",
  "Trend": "Trend",
  "Clicks, last 14 days": "Klicks, letzte 14 Tage",
  "Add level": "Ebene hinzufügen",
  "Remove level": "Ebene entfernen",
  "Last {n} days": "Letzte {n} Tage",
  "All time": "Gesamter Zeitraum",
  "JA3 / JA4 fingerprint overrides for bot detection": "JA3-/JA4-Fingerprint-Überschreibungen zur Bot-Erkennung",
  "Uptime, DB size, data-processing queue and host metrics": "Verfügbarkeit, DB-Größe, Verarbeitungswarteschlange und Server-Metriken",
  "Outbound conversion postbacks fired across your campaigns": "Ausgehende Conversion-Postbacks aus all deinen Kampagnen",
  "Normal — a regular stream with filters. Catch (intercepting) — checked before Normal streams and takes a matching click first, e.g. bots or a test GEO. Fallback — the last stream; it gets traffic that matched nothing else.": "Normal — ein regulärer Stream mit Filtern. Catch (abfangend) — wird vor den Normal-Streams geprüft und übernimmt passende Klicks zuerst, z. B. Bots oder ein Test-GEO. Fallback — der letzte Stream; er erhält Traffic, der sonst nirgends gepasst hat.",
  "Interface: search, shortcuts and language": "Interface: Suche, Shortcuts und Sprache",
  "CAPI": "CAPI",
  "FAQ": "FAQ",
  "Cost, integrations & ops": "Kosten, Integrationen und Betrieb",
  "New campaign": "Neue Kampagne",
  "Command palette": "Befehlspalette",
  "Pre-landing page": "Prelander-Seite",
  "good": "gut",
  "bad": "schlecht",
  "unknown": "unbekannt",
  "Error reports": "Fehlerberichte",
  "Server and browser errors grouped by cause. Resolve hides a report until the error happens again; Ignore keeps it quiet.": "Server- und Browserfehler, gruppiert nach Ursache. Beheben blendet einen Report aus, bis der Fehler erneut auftritt; Ignorieren hält ihn dauerhaft stumm.",
  "Unresolved": "Ungelöst",
  "Ignored": "Ignoriert",
  "All": "Alle",
  "All sources": "Alle Quellen",
  "Server": "Server",
  "Search by error text": "Nach Fehlertext suchen",
  "Count": "Anzahl",
  "First seen": "Zuerst gesehen",
  "No error reports": "Keine Fehlerberichte",
  "Could not load error reports": "Fehler-Reports konnten nicht geladen werden",
  "Could not load the report": "Report konnte nicht geladen werden",
  "Report updated": "Bericht aktualisiert",
  "Could not update the report": "Report konnte nicht aktualisiert werden",
  "Seen {n} times": "{n}-mal gesehen",
  "Mark resolved": "Als gelöst markieren",
  "Reopen": "Wieder öffnen",
  "Datacenter / hosting VPN / Tor IPs": "Datacenter- / Hosting-VPN- / Tor-IPs",
  "Visitors from cloud and hosting networks, VPNs that run on them, and Tor exits get the safe page. Residential proxies cannot be recognised without a paid IP database.": "Besucher aus Cloud- und Hosting-Netzwerken, VPNs, die darauf laufen, sowie Tor-Exit-Nodes bekommen die Safe Page. Residential Proxies lassen sich ohne kostenpflichtige IP-Datenbank nicht erkennen.",
  "Offer only with a Google Ads click ID": "Offer nur mit Google-Ads-Click-ID",
  "Real Google Ads clicks always carry gclid, gbraid or wbraid; reviewers and link checkers open the link without one. Visitors without a valid click ID get the safe page. Leave off if auto-tagging is disabled or the campaign gets other traffic.": "Echte Google-Ads-Klicks tragen immer gclid, gbraid oder wbraid; Reviewer und Link-Checker öffnen den Link ohne diese. Besucher ohne gültige Click-ID bekommen die Safe Page. Lass die Option aus, wenn Auto-Tagging deaktiviert ist oder die Kampagne anderen Traffic erhält.",
  "Show white page": "White Page anzeigen",
  "Shows the campaign white page (the page bots get) instead of an offer. Put it in a Default stream with no filters to send visitors that no other stream accepts to the white page instead of the target URL.": "Zeigt die White Page der Kampagne (die Seite, die Bots sehen) statt eines Offers. Füge sie in einen Default-Stream ohne Filter ein, um Besucher, die kein anderer Stream akzeptiert, zur White Page statt zur Ziel-URL zu schicken.",
  "Transparent mode fetches the page from our server, so the visitor IP and cookies never reach it. Use it only for your own landing pages, not for affiliate offer links, or conversions may not be counted.": "Der transparente Modus lädt die Seite über unseren Server, sodass IP und Cookies des Besuchers sie nie erreichen. Nutze ihn nur für deine eigenen Landingpages, nicht für Affiliate-Offer-Links, sonst werden Conversions möglicherweise nicht gezählt.",
  "Check failed": "Prüfung fehlgeschlagen",
  "Can be shown in iframe mode": "Kann im iFrame-Modus angezeigt werden",
  "Blocked: visitors will see an empty screen in iframe mode": "Blockiert: Besucher sehen im iFrame-Modus einen leeren Bildschirm",
  "Could not confirm: test it on a real phone before launch": "Konnte nicht bestätigt werden: teste sie vor dem Start auf einem echten Smartphone",
  "Check that the page allows framing. Paste the final offer or landing URL your streams send visitors to.": "Prüfe, ob die Seite das Einbetten in einen Frame erlaubt. Füge die finale Offer- oder Landingpage-URL ein, zu der deine Streams Besucher schicken.",
  "Checking…": "Checking…",
  "Check framing": "Framing prüfen",
};

export default de;
